(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56965],{

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 17349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CarWarranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/carWarranty/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 330 315",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_34175)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#91B3FA",
                        opacity: "0.3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M103.748 99.792a1.67 1.67 0 01-2.097-.764 65.898 65.898 0 01-2.451-5.13 1.669 1.669 0 01.88-2.189c.012-.004.02-.008.032-.011a1.67 1.67 0 012.161.894 65.4 65.4 0 002.328 4.877c.432.811.123 1.82-.694 2.252-.052.028-.107.051-.159.075v-.004zm-5.341-13.51a1.67 1.67 0 01-2.237-1.108 68.6 68.6 0 01-1.26-5.541 1.666 1.666 0 011.344-1.94 1.67 1.67 0 011.943 1.342c.32 1.761.725 3.53 1.197 5.264.226.824-.21 1.67-.983 1.984h-.004zm-2.229-14.348a1.67 1.67 0 01-2.292-1.48c-.08-1.885-.075-3.8.008-5.685.044-.918.821-1.63 1.745-1.59.92.039 1.634.818 1.594 1.74a62.88 62.88 0 00-.008 5.4 1.667 1.667 0 01-1.043 1.615h-.004zm1.04-14.487a1.671 1.671 0 01-2.265-1.853 68 68 0 011.28-5.542 1.675 1.675 0 012.055-1.163 1.668 1.668 0 011.166 2.05c-.48 1.726-.889 3.5-1.218 5.265a1.672 1.672 0 01-1.019 1.242zm4.25-13.894c-.4.162-.86.17-1.289-.016a1.662 1.662 0 01-.868-2.193 67.48 67.48 0 012.478-5.118 1.671 1.671 0 012.261-.68 1.664 1.664 0 01.682 2.255 62.944 62.944 0 00-2.356 4.861 1.66 1.66 0 01-.908.883v.008zm7.221-12.607a1.668 1.668 0 01-1.975-2.53 66.314 66.314 0 013.553-4.44 1.669 1.669 0 012.519 2.188 64.978 64.978 0 00-3.375 4.22c-.19.261-.444.451-.722.562zM163.96 4.413c-.214.088-.448.131-.694.12a61.621 61.621 0 00-5.409 0 1.669 1.669 0 11-.143-3.333 65.147 65.147 0 015.699 0c.92.039 1.637.819 1.598 1.737a1.671 1.671 0 01-1.043 1.476h-.008zm-45.432 15.845a1.674 1.674 0 01-1.884-.45 1.66 1.66 0 01.167-2.352 65.57 65.57 0 014.453-3.539 1.668 1.668 0 111.967 2.696 61.702 61.702 0 00-4.228 3.36 1.657 1.657 0 01-.471.29l-.004-.005zm30.918-14.831c-.103.04-.21.075-.321.095a63.49 63.49 0 00-5.274 1.207 1.668 1.668 0 11-.884-3.218 68.319 68.319 0 015.551-1.27 1.67 1.67 0 011.947 1.337 1.665 1.665 0 01-1.015 1.849h-.004zm-18.939 6.602a1.668 1.668 0 01-1.408-3.02 67.19 67.19 0 015.136-2.458c.012-.004.024-.008.031-.016a1.677 1.677 0 012.162.89 1.666 1.666 0 01-.881 2.19 62.67 62.67 0 00-4.877 2.335 2.958 2.958 0 01-.163.075v.004zM175.583 5.973a1.666 1.666 0 01-.996.08c-.84-.19-1.697-.369-2.55-.527a1.663 1.663 0 01-1.336-1.944 1.666 1.666 0 011.947-1.334 67.33 67.33 0 012.681.554 1.667 1.667 0 01.254 3.17z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#91B3FA",
                        opacity: "0.3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M216.863 35.731c-.749.301-1.626.024-2.054-.684a63.333 63.333 0 00-1.388-2.197 1.672 1.672 0 012.788-1.84c.503.76.995 1.539 1.463 2.31a1.666 1.666 0 01-.805 2.407l-.004.004zM185.568 129.472c-.714.288-1.432.562-2.162.827a1.668 1.668 0 11-1.146-3.131 65.299 65.299 0 004.925-2.023 1.673 1.673 0 012.217.816c.389.835.02 1.828-.817 2.212-.987.455-2.002.891-3.017 1.302v-.003zm-10.632 3.273a1.542 1.542 0 01-.273.083c-1.821.396-3.68.717-5.524.958a1.667 1.667 0 11-.433-3.305 63.794 63.794 0 005.247-.911c.9-.193 1.792.377 1.986 1.275a1.665 1.665 0 01-1.007 1.9h.004zm21.354-8.795a1.668 1.668 0 01-1.523-2.953 61.943 61.943 0 004.354-3.052 1.675 1.675 0 012.344.309 1.665 1.665 0 01-.309 2.339 66.564 66.564 0 01-4.588 3.214 2.032 2.032 0 01-.278.143zm-35.602 10.275c-.198.08-.412.123-.638.119a66.306 66.306 0 01-5.599-.277 1.668 1.668 0 11.305-3.321c1.761.162 3.549.249 5.318.261a1.668 1.668 0 01.61 3.214l.004.004zm46.721-19.261a1.67 1.67 0 01-1.816-2.719 63.722 63.722 0 003.577-3.93 1.67 1.67 0 012.566 2.133 66.646 66.646 0 01-3.768 4.14 1.667 1.667 0 01-.563.376h.004zm8.879-11.205a1.666 1.666 0 01-2.042-2.427 63.2 63.2 0 002.633-4.62 1.67 1.67 0 012.248-.72 1.667 1.667 0 01.722 2.245 68.097 68.097 0 01-2.772 4.861 1.662 1.662 0 01-.789.661zm6.218-12.873a1.662 1.662 0 01-1.182.024 1.668 1.668 0 01-1.019-2.126 63.564 63.564 0 001.562-5.082 1.67 1.67 0 013.232.843 67.344 67.344 0 01-1.645 5.348c-.167.47-.524.819-.952.99l.004.003zm3.259-13.917a1.632 1.632 0 01-.82.107 1.667 1.667 0 01-1.46-1.853c.21-1.753.349-3.534.409-5.296a1.668 1.668 0 013.335.119 65.865 65.865 0 01-.433 5.577 1.67 1.67 0 01-1.035 1.35l.004-.004zm.119-14.297a1.669 1.669 0 01-2.284-1.377 63.706 63.706 0 00-.769-5.257 1.669 1.669 0 013.279-.622c.345 1.825.619 3.69.809 5.534a1.663 1.663 0 01-1.035 1.718v.004zm-3.029-13.965a1.669 1.669 0 01-2.209-1.017 63.074 63.074 0 00-1.356-3.67 82.352 82.352 0 00-.539-1.298 1.662 1.662 0 01.876-2.19c.852-.383 1.828.029 2.193.876a67.42 67.42 0 011.994 5.225 1.669 1.669 0 01-.955 2.074h-.004zM146.432 132.531a1.68 1.68 0 01-1.003.079 64.877 64.877 0 01-2.653-.676 1.668 1.668 0 11.893-3.211c.836.23 1.685.448 2.522.642a1.667 1.667 0 01.241 3.17v-.004z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M141.273 113.757a.782.782 0 00.901-.107l7.042-6.365a41.547 41.547 0 0013.328 1.477l5.472 7.742a.784.784 0 00.857.301l10.945-3.171a.775.775 0 00.563-.708l.472-9.465a41.493 41.493 0 0010.464-8.367l9.363 1.61a.788.788 0 00.817-.391l5.492-9.967a.77.77 0 00-.107-.899l-6.377-7.03a41.204 41.204 0 001.48-13.303l7.756-5.463a.778.778 0 00.301-.855l-3.176-10.925a.775.775 0 00-.71-.562l-9.481-.47a41.471 41.471 0 00-8.383-10.447l1.614-9.345a.785.785 0 00-.393-.816l-9.985-5.482a.774.774 0 00-.9.107l-7.043 6.365a41.43 41.43 0 00-13.328-1.476l-5.472-7.743a.782.782 0 00-.856-.3l-10.945 3.17a.775.775 0 00-.563.709l-.472 9.464a41.51 41.51 0 00-10.465 8.367l-9.362-1.61a.787.787 0 00-.817.391l-5.492 9.967a.776.776 0 00.107.899l6.376 7.03a41.231 41.231 0 00-1.479 13.304l-7.756 5.462a.78.78 0 00-.302.855l3.177 10.925c.091.32.376.546.709.562l9.482.47a41.427 41.427 0 008.383 10.447l-1.614 9.345a.785.785 0 00.392.816l9.985 5.482z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M164.678 77.86c-5.179 2.085-11.258.118-14.165-4.83-3.192-5.442-1.352-12.46 4.096-15.643a11.4 11.4 0 018.685-1.195 11.369 11.369 0 016.987 5.284c3.192 5.443 1.352 12.46-4.097 15.643a11.07 11.07 0 01-1.51.74h.004zm-7.547-18.747a9.11 9.11 0 00-1.169.574c-4.18 2.442-5.588 7.826-3.141 11.993 2.447 4.173 7.84 5.582 12.015 3.135 4.18-2.442 5.588-7.825 3.141-11.993a8.729 8.729 0 00-5.357-4.053 8.71 8.71 0 00-5.489.344z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M171.082 93.087a29.768 29.768 0 01-3.621 1.187c-1.463.372-2.95.63-4.445.764-.02 0-.04 0-.059.004-.06.004-.115.012-.175.016-.111.008-.226.016-.337.028a.67.67 0 01-.714-.618.669.669 0 01.619-.712 27.258 27.258 0 005.623-1.002c9.132-2.644 15.782-9.737 18.273-18.232a26.6 26.6 0 00.016-14.954 27.34 27.34 0 00-.901-2.604c-2.304-5.7-6.467-10.395-11.932-13.395-6.277-3.448-13.526-4.248-20.41-2.256-14.212 4.12-22.413 19.003-18.289 33.186a26.767 26.767 0 007.491 12.152c.076.067.131.15.167.237a.666.666 0 01-.131.705.67.67 0 01-.944.035 28.065 28.065 0 01-7.867-12.753c-4.331-14.891 4.286-30.519 19.2-34.837 7.225-2.094 14.835-1.25 21.426 2.367 5.738 3.15 10.108 8.079 12.527 14.064.36.89.674 1.8.947 2.735 2.098 7.212 1.253 14.808-2.371 21.387-3.156 5.731-8.097 10.09-14.093 12.504v-.008z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#91B3FA",
                        opacity: "0.3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M67.357 161.818a1.029 1.029 0 01-1.193-.316 43.309 43.309 0 01-1.575-2.114 1.028 1.028 0 01.258-1.433 1.028 1.028 0 011.436.257 41.27 41.27 0 001.499 2.015 1.026 1.026 0 01-.425 1.591zM63.031 155.18a1.03 1.03 0 01-1.297-.475 46.018 46.018 0 01-2.26-4.995c-.202-.534.103-1.116.599-1.33a1.031 1.031 0 011.328.598 43.259 43.259 0 002.153 4.765 1.028 1.028 0 01-.527 1.433l.004.004zm-3.795-9.998a1.034 1.034 0 01-1.392-.709 44.67 44.67 0 01-.98-5.391 1.032 1.032 0 012.05-.241c.203 1.721.52 3.455.933 5.145a1.032 1.032 0 01-.615 1.2l.004-.004zm-1.253-10.616a1.025 1.025 0 01-1.416-.962 43.58 43.58 0 01.381-5.471 1.032 1.032 0 012.046.27 42.52 42.52 0 00-.36 5.217c0 .431-.27.795-.647.946h-.004zm1.4-10.601a1.029 1.029 0 01-1.384-1.211 44.212 44.212 0 011.709-5.209 1.04 1.04 0 011.34-.578c.532.21.79.808.58 1.338a42.509 42.509 0 00-1.63 4.968 1.034 1.034 0 01-.615.696v-.004zm3.95-9.939a1.03 1.03 0 01-1.29-1.449 45.48 45.48 0 012.923-4.639 1.03 1.03 0 011.677 1.2 41.91 41.91 0 00-2.787 4.425 1.006 1.006 0 01-.52.459l-.004.004zm6.245-8.676a1.042 1.042 0 01-1.087-.198 1.03 1.03 0 01-.055-1.457 44.254 44.254 0 013.97-3.784 1.04 1.04 0 011.455.123 1.023 1.023 0 01-.123 1.448 42.318 42.318 0 00-3.783 3.61 1.042 1.042 0 01-.373.258h-.004zm8.18-6.888a1.034 1.034 0 01-1.248-.392 1.032 1.032 0 01.301-1.425c1.527-.99 3.133-1.9 4.778-2.7a1.04 1.04 0 011.38.476 1.03 1.03 0 01-.475 1.377 42.515 42.515 0 00-4.56 2.573.943.943 0 01-.18.091h.005zm14.804-6.1a.88.88 0 01-.175.052 42.737 42.737 0 00-5.048 1.39 1.032 1.032 0 01-1.312-.638c-.187-.538.099-1.14.638-1.31a45.21 45.21 0 015.294-1.46 1.027 1.027 0 011.221.795c.103.495-.166.981-.622 1.168l.004.003z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#91B3FA",
                        opacity: "0.3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M118.353 174.932a1.029 1.029 0 01-.781-1.904 43.119 43.119 0 004.624-2.268 1.039 1.039 0 011.407.384 1.032 1.032 0 01-.384 1.405 45.207 45.207 0 01-4.846 2.379c-.004 0-.008 0-.012.004h-.008zm-4.981 1.738c-.035.016-.071.024-.107.036-1.729.49-3.501.878-5.274 1.159a1.027 1.027 0 01-1.177-.855 1.031 1.031 0 01.856-1.179 42.899 42.899 0 005.036-1.105 1.032 1.032 0 011.273.709 1.026 1.026 0 01-.607 1.235zm14.133-6.943c-.424.17-.928.044-1.213-.34a1.029 1.029 0 01.21-1.441 43.298 43.298 0 003.938-3.317 1.034 1.034 0 011.459.035 1.03 1.03 0 01-.036 1.457 44.154 44.154 0 01-4.128 3.475.927.927 0 01-.23.131zm-24.546 8.574a1.034 1.034 0 01-.353.075 44.647 44.647 0 01-5.4-.147 1.03 1.03 0 11.182-2.05c1.705.151 3.438.198 5.151.143a1.031 1.031 0 011.067.993c.015.443-.254.831-.647.99v-.004zm32.164-15.829a1.045 1.045 0 01-1.043-.159 1.029 1.029 0 01-.143-1.448 42.717 42.717 0 003.022-4.165 1.03 1.03 0 011.741 1.105 45.03 45.03 0 01-3.169 4.366 1.057 1.057 0 01-.412.301h.004zm5.655-8.871a1.052 1.052 0 01-.833-.024 1.028 1.028 0 01-.488-1.373 43.689 43.689 0 001.939-4.766c.183-.538.77-.827 1.309-.645.539.182.829.764.646 1.302a44.955 44.955 0 01-2.03 4.995c-.115.242-.313.42-.543.511zm3.362-9.967a1.013 1.013 0 01-.594.052 1.029 1.029 0 01-.801-1.216c.349-1.678.594-3.388.733-5.09.048-.566.544-.99 1.115-.942.567.047.991.542.943 1.112a44.106 44.106 0 01-.769 5.34 1.03 1.03 0 01-.627.748v-.004zM92.415 177.363a1.034 1.034 0 01-.603.051 44.378 44.378 0 01-2.561-.629 1.029 1.029 0 11.55-1.983c.798.221 1.619.423 2.444.597.555.119.912.669.793 1.224a1.039 1.039 0 01-.623.74z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M88.228 164.708a.523.523 0 00.602-.071l4.711-4.26a27.75 27.75 0 008.919.99l3.664 5.181a.521.521 0 00.571.202l7.324-2.121a.527.527 0 00.377-.475l.313-6.334a27.682 27.682 0 007.003-5.601l6.265 1.081c.218.04.44-.067.547-.261l3.676-6.67a.52.52 0 00-.071-.602l-4.267-4.702a27.622 27.622 0 00.992-8.902l5.19-3.658a.522.522 0 00.203-.57l-2.126-7.311a.527.527 0 00-.476-.376l-6.344-.312a27.659 27.659 0 00-5.612-6.991l1.083-6.254a.52.52 0 00-.262-.546l-6.682-3.669a.522.522 0 00-.602.071l-4.711 4.259a27.748 27.748 0 00-8.918-.989l-3.665-5.182a.525.525 0 00-.57-.202l-7.325 2.122a.525.525 0 00-.377.475l-.313 6.333a27.677 27.677 0 00-7.003 5.601l-6.265-1.08a.522.522 0 00-.547.261l-3.676 6.669a.521.521 0 00.07.602l4.268 4.703a27.6 27.6 0 00-.992 8.902l-5.19 3.657a.523.523 0 00-.203.57l2.126 7.311a.526.526 0 00.476.376l6.344.313a27.657 27.657 0 005.612 6.99l-1.083 6.254c-.04.218.067.44.262.547l6.681 3.669z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M103.927 140.82a7.76 7.76 0 01-4.878.304 7.743 7.743 0 01-4.758-3.602c-2.173-3.705-.924-8.486 2.791-10.655 3.72-2.166 8.502-.919 10.675 2.786a7.715 7.715 0 01.817 5.906 7.721 7.721 0 01-3.608 4.75 7.692 7.692 0 01-1.039.511zm-5.048-12.544a5.724 5.724 0 00.694 10.857 5.72 5.72 0 004.354-.597 5.691 5.691 0 002.653-3.496 5.695 5.695 0 00-.599-4.346c-1.456-2.478-4.501-3.463-7.098-2.418h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M108.372 151.424a19.673 19.673 0 01-5.762 1.358l-.178.011a1.037 1.037 0 01-1.103-.953 1.035 1.035 0 01.956-1.101 17.526 17.526 0 003.835-.708 17.164 17.164 0 007.292-4.37 17.484 17.484 0 002.812-3.729c.008-.012.012-.024.019-.032.02-.035.04-.067.056-.103a17.197 17.197 0 001.463-13.189 17.221 17.221 0 00-8.307-10.358 17.283 17.283 0 00-13.213-1.461 17.252 17.252 0 00-10.378 8.293 17.195 17.195 0 00-1.463 13.189 17.256 17.256 0 004.846 7.861 1.028 1.028 0 01.052 1.452 1.034 1.034 0 01-1.46.056 19.364 19.364 0 01-5.429-8.796 19.237 19.237 0 011.638-14.756 19.277 19.277 0 0111.61-9.278 19.332 19.332 0 0114.784 1.635c3.957 2.173 6.975 5.573 8.641 9.701.246.614.468 1.243.654 1.884 2.8 9.635-2.252 19.717-11.377 23.39l.012.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M62.135 25.915H50.778v257.217h11.357V25.915z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M81.918 0H30.701C18.016 0 7.733 10.264 7.733 22.926v51.126c0 12.661 10.283 22.926 22.968 22.926h51.217c12.685 0 22.968-10.265 22.968-22.926V22.926C104.886 10.265 94.603 0 81.918 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M79.321 4.75H33.694c-11.272 0-20.41 9.121-20.41 20.373v45.544c0 11.252 9.138 20.373 20.41 20.373h45.627c11.272 0 20.41-9.12 20.41-20.373V25.123c0-11.252-9.138-20.373-20.41-20.373z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M38.362 22.59l-5.679-2.775a1.41 1.41 0 00-1.562.218l-.619.554-.999.898-.638.575c-.429.383-.58.989-.381 1.527l2.173 5.926c.33.898 1.079 1.583 2.018 1.781l3.839.84L61.429 59.75l1.435-1.29 1-.899 1.356-1.219-24.915-27.617-.404-3.923a2.791 2.791 0 00-1.535-2.216l-.004.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_34175)",
                        d: "M37.977 22.926l-5.147-2.533c-.464-.226-1.055-.186-1.44.162l-.555.499-.9.808-.575.518c-.384.344-.487.926-.309 1.413l1.97 5.356a2.53 2.53 0 001.833 1.607l3.474.756 22.468 24.901 1.277-1.148.9-.807 1.404-1.263-22.469-24.901-.456-3.452c-.09-.859-.697-1.532-1.475-1.912v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_0_34175)",
                        d: "M81.796 65.676L64.082 49.894l-8.946 8.071 13.629 18.798a11.935 11.935 0 005.064 4.006l5.433 2.311c.92.385 2.042.274 2.783-.391l3.72-3.345c.674-.606.916-1.587.742-2.474l-.916-4.552a12.046 12.046 0 00-3.8-6.642h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M62.773 48.65l-8.96 8.055a1.47 1.47 0 00-.11 2.08l.112.123a1.477 1.477 0 002.084.109l8.96-8.056a1.47 1.47 0 00.109-2.08l-.112-.123a1.477 1.477 0 00-2.083-.109zM78.278 77.151a1.253 1.253 0 01-.095 1.777l-.02.016a1.258 1.258 0 01-1.78-.095L59.498 60.134a1.253 1.253 0 01.095-1.777l.02-.016a1.259 1.259 0 011.78.095l16.885 18.715zM64.013 54.39l.017-.016a1.263 1.263 0 011.781.093l16.884 18.717a1.258 1.258 0 01-.094 1.778l-.017.016a1.263 1.263 0 01-1.781-.093L63.919 56.167a1.258 1.258 0 01.094-1.777zM26.299 64.765l-1.194 1.113c-2.05 1.908-2.668 4.572-1.38 5.953l1.531 1.643c1.289 1.381 3.997.954 6.047-.954l1.194-1.113c.08-.075.159-.15.234-.225l34.004-34.493-3.34-3.574-36.854 31.437a6.25 6.25 0 00-.242.217v-.004zm1.646 1.576c1.542-1.437 3.49-1.86 4.342-.942.856.914.297 2.822-1.25 4.259-1.542 1.437-3.489 1.86-4.341.942-.857-.914-.298-2.822 1.249-4.26z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M73.825 20.045l-6.936 6.452a2.174 2.174 0 00-.682 1.793l.325 3.44a2.174 2.174 0 001.809 1.94l3.414.565a2.18 2.18 0 001.84-.554l6.936-6.452c1.046-.974 2.775-.273 2.815 1.152.091 3.412-1.265 6.9-4.025 9.464-4.989 4.64-12.043 3.95-16.512-.839-4.47-4.79-4.663-11.863.321-16.502 2.76-2.569 6.337-3.673 9.743-3.34 1.424.138 1.999 1.907.956 2.88h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_0_34175)",
                        d: "M74.432 20.698l-6.936 6.452a2.162 2.162 0 00-.682 1.793l.325 3.44a2.174 2.174 0 001.808 1.94l3.415.565a2.18 2.18 0 001.84-.554l6.935-6.452c1.047-.974 2.776-.273 2.816 1.152.09 3.412-1.265 6.9-4.025 9.464-4.989 4.64-12.043 3.95-16.512-.839-4.47-4.79-4.664-11.863.32-16.502 2.76-2.569 6.338-3.673 9.744-3.34 1.423.138 1.998 1.907.956 2.88h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_0_34175)",
                        d: "M26.787 65.288L25.593 66.4c-2.05 1.908-2.669 4.572-1.38 5.953l1.53 1.643c1.29 1.382 3.998.954 6.048-.954l1.194-1.112c.079-.075.158-.15.234-.226l34.003-34.488-3.338-3.575-36.855 31.437c-.084.071-.163.142-.242.214v-.004zm1.645 1.575c1.543-1.437 3.49-1.86 4.343-.942.856.914.297 2.822-1.25 4.26-1.542 1.436-3.49 1.86-4.342.941-.856-.914-.297-2.822 1.25-4.259z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_0_34175)",
                        d: "M183.244 184.096c37.192 9.282 59.014 34.1 69.776 36.606 10.758 2.509 53.863 4.805 60.89 11.32 7.026 6.52.313 11.151 9.35 19.531 9.997 28.159-20.957 36.586-20.957 36.586l-281.385-2.28S1.93 287.565 1.51 274.028c-.42-13.538-.718-19.617.281-31.809.996-12.192 5.929-13.561 8.65-19.882 2.72-6.322 29.133-7.007 34.276-14.04 5.14-7.03 11.262-18.244 33.072-22.068 30.126-5.28 83.882-7.521 105.458-2.133h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_0_34175)",
                        d: "M0 273.228c.484 15.56 26.914 12.801 27.029 12.793 0 0 21.012-16.054-7.896-15.437-8.684-.226-17.491-4.817-17.491-4.817L0 273.228z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint6_linear_0_34175)",
                        d: "M324.973 258.511s.278 3.97-7.173 8.024c-9.232 5.023-47.098-.772-47.098-.772l2.149 20.86 30.213 1.54c-.706.194 39.675-2.13 21.905-29.652h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint7_linear_0_34175)",
                        d: "M49.477 228.678s-.908-7.066 6.527-15.727c7.435-8.66 11.778-14.376 17.496-15.845 5.718-1.472 47.569-7.251 50.317-2.806 2.749 4.445 6.29 31.741 6.29 31.741l-80.63 2.637z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint8_linear_0_34175)",
                        d: "M74.261 196.354c4.687-.696 40.285-4.829 49.477-3.649l2.379 9.132-76.676 26.833s-.364-5.815 3.466-11.547c6.436-9.63 16.453-20.155 21.354-20.769z",
                        opacity: "0.42"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint9_linear_0_34175)",
                        d: "M136.336 194.292c1.158 5.277 5.429 30.993 5.429 30.993l90.496-.419s-28.528-26.168-50.457-30.309c-21.929-4.14-46.209-3.055-45.472-.265h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint10_linear_0_34175)",
                        d: "M178.715 192.618c-17.864-2.474-24.411-2.007-43.136-.368l1.804 7.477s27.869-5.455 53.835-2.3c0 0-6.67-3.998-12.499-4.805l-.004-.004z",
                        opacity: "0.42"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint11_linear_0_34175)",
                        d: "M311.824 230.681s-14.66-4.691-18.237 6.879c-3.411 11.032 29.673 13.997 29.673 13.997s-2.439-16.364-11.436-20.876z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M44.469 216.178a.871.871 0 00.245-.036c3.443-1.037 6.345-4.659 9.7-8.851 4.905-6.119 10.46-13.058 19.526-14.788 17.385-3.313 43.735-5.605 43.997-5.629a.845.845 0 00.773-.918.835.835 0 00-.92-.772c-.266.024-26.704 2.324-44.171 5.653-9.684 1.844-15.7 9.357-20.537 15.393-3.18 3.971-5.929 7.398-8.863 8.285a.846.846 0 00-.567 1.061.85.85 0 00.813.606l.004-.004zM17.523 225.808a.849.849 0 00.762-.471c1.427-2.874 7.752-4.176 13.867-5.435 2.189-.451 4.45-.914 6.527-1.46a.847.847 0 00.607-1.037.852.852 0 00-1.04-.606c-2.037.534-4.274.993-6.439 1.441-6.813 1.405-13.249 2.731-15.045 6.345a.851.851 0 00.761 1.227v-.004zM141.86 284.204h.084c.495 0 .888-.439.884-.934a.908.908 0 00-.528-.815c-1.76-2.83-4.048-33.424-5.087-52.281a.896.896 0 00-1.789.091c.008.135.746 13.458 1.801 26.584 2.149 26.71 3.473 27.355 4.631 27.355h.004z",
                        opacity: "0.56"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint12_linear_0_34175)",
                        d: "M111.275 285.788c.202-1.188.317-2.898.317-4.445 0-18.529-15.049-33.491-33.611-33.491-18.563 0-33.611 14.934-33.611 33.463 0 1.548.114 3.285.317 4.473H111.275z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint13_linear_0_34175)",
                        d: "M104.911 283.888c1.849-14.989-8.825-28.635-23.84-30.481-15.016-1.846-28.687 8.809-30.536 23.797-1.849 14.988 8.825 28.635 23.84 30.481 15.016 1.845 28.687-8.809 30.536-23.797z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint14_linear_0_34175)",
                        d: "M77.72 302.741c12.285 0 22.245-9.942 22.245-22.206s-9.96-22.206-22.246-22.206c-12.286 0-22.246 9.942-22.246 22.206s9.96 22.206 22.246 22.206z",
                        opacity: "0.6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M96.404 288.582a.393.393 0 01-.365-.55 19.088 19.088 0 001.515-7.497c0-10.624-8.656-19.265-19.3-19.265-3.303 0-6.559.847-9.422 2.446a.395.395 0 11-.388-.688 20.142 20.142 0 019.81-2.549c11.08 0 20.093 8.997 20.093 20.056 0 2.708-.531 5.336-1.578 7.806a.396.396 0 01-.365.241z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint15_linear_0_34175)",
                        d: "M276.218 286.975c.202-1.187.317-2.822.317-4.37 0-18.528-15.049-33.451-33.611-33.451-18.562 0-33.611 14.875-33.611 33.404 0 1.547.115 3.23.317 4.417H276.218z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint16_linear_0_34175)",
                        d: "M242.666 309.217c15.129 0 27.394-12.242 27.394-27.344 0-15.101-12.265-27.344-27.394-27.344-15.129 0-27.393 12.243-27.393 27.344 0 15.102 12.264 27.344 27.393 27.344z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint17_linear_0_34175)",
                        d: "M246.239 303.78c12.128-1.965 20.363-13.371 18.395-25.477-1.969-12.105-13.396-20.326-25.523-18.361-12.128 1.965-20.363 13.371-18.395 25.477 1.969 12.106 13.396 20.326 25.523 18.361z",
                        opacity: "0.6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M261.351 289.924a.392.392 0 01-.364-.55 19.091 19.091 0 001.514-7.497c0-10.624-8.656-19.265-19.299-19.265-3.304 0-6.559.847-9.422 2.446a.395.395 0 11-.389-.688 20.144 20.144 0 019.811-2.549c11.079 0 20.093 8.997 20.093 20.056 0 2.708-.532 5.336-1.579 7.806a.396.396 0 01-.365.241z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint18_linear_0_34175)",
                        d: "M217.442 222.962l-6.868-7.188c-2.863-2.997-6.464-5.039-10.378-5.89l-13.586-2.949c-3.727-.812-7.296 2.003-7.704 6.076l-.096.958c-.416 4.148 2.626 7.754 6.5 7.707l17.503-.214c2.443-.032 4.66 1.524 5.623 3.938l.322.808c.428 1.072 1.407 1.765 2.49 1.765h4.302c2.435 0 3.637-3.186 1.888-5.015l.004.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint19_linear_0_34175)",
                        d: "M146.595 231.168h22.698c1.769 0 3.018 1.896 2.403 3.681-1.039 3.024-3.513 6.883-9.39 7.334-5.286.404-11.952-2.818-16.98-5.882-2.28-1.389-1.352-5.137 1.269-5.137v.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint20_linear_0_34175)",
                        d: "M1.697 242.219l3.97.705a2.76 2.76 0 012.28 2.719v9.349a2.76 2.76 0 01-2.76 2.755H1.233l.464-15.528z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint21_linear_0_34175)",
                        d: "M193.046 164.181l4.295 5.879c7.384.49 13.356-.855 18.126-3.013-1.534-6.852-3.541-11.091-5.242-13.664-8.324 8.396-17.183 10.802-17.183 10.802l.004-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint22_linear_0_34175)",
                        d: "M231.781 151.139l-8.994-20.832c-2.538 10.509-7.447 17.919-12.558 23.072 1.701 2.573 3.703 6.813 5.242 13.664 11.908-5.391 16.314-15.904 16.314-15.904h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint23_linear_0_34175)",
                        d: "M241.163 313.488c-6.107.281-12.015.103-15.961-.099 3.593-2.553 11.869-8.106 18.797-10.315l4.754-.285s1.61 2.446 2.185 8.043c-.789.982-3.089 2.351-9.775 2.656z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint24_linear_0_34175)",
                        d: "M225.155 313.425l.047-.036c3.946.202 9.854.38 15.961.099 6.682-.309 8.986-1.674 9.775-2.656.028.257.056.515.075.784a2.219 2.219 0 01-2.046 2.398c-5 .377-17.396 1.232-23.376.919-.789-.04-1.083-1.053-.436-1.512v.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint25_linear_0_34175)",
                        d: "M283.903 311.857c.448-2.862 1.166-6.998 1.717-8.055.868-1.658 3.843 0 3.843 0s2.089.974 3.049 2.593c.615 1.033 2.308 3.97 3.454 5.965.131.229.186.475.178.708l-11.912.416a2.374 2.374 0 01-.333-1.631l.004.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint26_linear_0_34175)",
                        d: "M296.148 313.072a1.357 1.357 0 01-1.32 1.318l-8.486.234a2.397 2.397 0 01-2.106-1.132l11.912-.416v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint27_linear_0_34175)",
                        d: "M213.524 127.841c7.598-1.987 21.608-5.099 32.763-4.434 2.561.155 4.615 2.174 4.758 4.731 1.686 29.651 3.989 55.966 8.324 71.276-9.747 3.852-19.407 5.637-28.94 4.24-7.142-15.267-13.384-32.898-18.721-52.915 0 0-3.129-15.967-.091-21.287.472-.832 1.098-1.402 1.907-1.611z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint28_linear_0_34175)",
                        d: "M231.797 107.068s1.919 11.423 2.49 16.704a2.073 2.073 0 01-1.126 2.066c-2.098 1.076-6.571 2.81-11.448 1.219-.805-.261-1.329-1.037-1.313-1.88l.333-15.251 11.06-2.862.004.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint29_linear_0_34175)",
                        d: "M219.286 94.413s-3.7 8.486-3.95 12.939c-.25 4.454-1.209 7.343 3.95 8.242 5.159.898 9.505-1.671 11.861-6.104 0 0 3.687-6.836 2.863-9.638-.825-2.803-14.724-5.44-14.724-5.44z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint30_linear_0_34175)",
                        d: "M229.382 106.296h-.65s2.688-5.502.325-6.468c-2.36-.966-9.589-.954-11.607-4.267-1.947-3.195 3.192-5.154 5.789-6.31.163-.071-3.085-.495-3.001-.336l-.536-.396c.147.277 1.852-1.041 1.939-1.342.084-.285 2.106-1.52 2.261-1.267.618.99-1.975 2.273 2.514 3.096 6.364 1.171 10.576 3.744 10.679 8.138a.35.35 0 00.543.285c.472-.285-1.396-.42-.393.424.718.601 1.174 1.306 1.285 2.244.127 1.096-.69 2.442-1.455 3.163a2.11 2.11 0 00-.686 1.607c.012.637.385 1.152.46 1.765.099.788-.686 1.334-1.289 1.678a39.48 39.48 0 00-2.474 1.52c-.448.305-1.349 1.239-1.939 1.089a.35.35 0 01-.266-.36l.242-3.891a.35.35 0 00-.349-.372h-1.392z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint31_linear_0_34175)",
                        d: "M229.223 107.111s1.412-5.419 3.847-3.899c2.435 1.52-1.265 6.072-3.22 6.278l-.627-2.375v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint32_linear_0_34175)",
                        d: "M270.702 167.332c3.755 10.521 1.642 21.799 1.642 21.799l4.953 1.318s6.396-7.596 4.933-24.447c-4.573-.696-8.851.372-11.528 1.33z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint33_linear_0_34175)",
                        d: "M282.23 166.002a65.801 65.801 0 00-.809-6.032c-3.347-18.588-27.219-32.885-32.834-36.016a.765.765 0 00-1.138.696l.797 25.266c13.296 1.785 19.585 9.377 22.456 17.412 2.673-.958 6.955-2.026 11.528-1.33v.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint34_linear_0_34175)",
                        d: "M180.841 166.133a3.22 3.22 0 01-1.757-2.102c-.476-1.801-.88-4.627 1.059-5.149 2.887-.78 6.955 5.015 6.955 5.015l1.753 4.251 2.01 1.417c-2.089.222-5.797-1.322-10.02-3.432z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint35_linear_0_34175)",
                        d: "M237.892 102.001a806.483 806.483 0 01-9.069-2.517c-5.151-1.465-10.386-2.76-15.469-4.438-1.083-.356-2.166-.7-3.256-1.021-.654-.194-1.471-.522-1.911-1.065-.48-.593-.278-1.492.551-1.52 1.423-.051 2.898.143 4.294.388.405.072 4.382.82 4.374.895 0-.008 1.515-10.438 13.34-6.805 14.248 4.382 8.914 17.029 7.146 16.087v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint36_linear_0_34175)",
                        d: "M230.429 203.962c.293 1.536 10.695 66.519 11.325 100.145.012.562.397 1.037.92 1.116 1.321.198 3.89.451 6.385-.043a.786.786 0 00.618-.741c.365-6.266 3.288-59.247-.293-84.188 0 0 29.57 66.669 34.055 85.055.111.447.492.748.924.725 1.265-.072 3.902-.317 5.992-1.14.749-.297 1.178-1.14.987-1.972-2.506-11-20.057-86.801-31.973-103.501l-28.94 4.548v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint37_linear_0_34175)",
                        d: "M249.388 219.218a.374.374 0 00.269-.111.386.386 0 00.008-.546l-3.961-4.042a.387.387 0 10-.555.538l3.961 4.042a.382.382 0 00.278.115v.004z",
                        opacity: "0.25"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint38_linear_0_34175)",
                        d: "M230.853 204.655l-10.814-25.566-1.792-28.848 22.099-1.995c4.846 8.613 9.862 16.533 15.279 22.756.226.261.393.57.476.902l6.916 26.758-32.164 5.993z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint39_linear_0_34175)",
                        d: "M218.247 150.236c-2.344-6.768-3.145-13.81-4.723-22.399 2.205-1.39 2.974-2.043 5.092-1.568 1.447 8.613 2.962 16.771 4.857 24.288l-5.23-.321h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint40_linear_0_34175)",
                        d: "M235.854 148.673c.031-8.348.138-16.803 1.879-25.361 2.748-.502 3.934-.716 5.817 0-2.105 9.116-2.133 18.074-3.2 26.24l-4.493-.883-.003.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint41_linear_0_34175)",
                        d: "M301.692 206.04l4.406 2.676c7.558 4.588 11.174 12.433 8.073 17.52l-3.684 6.048c-3.101 5.086-11.737 5.49-19.299.902l-4.406-2.675a26.893 26.893 0 01-.865-.551l-127.16-84.901 8.026-13.177L300.8 205.526c.297.166.595.336.884.511l.008.003zm-4.076 5.914c-5.691-3.455-11.972-3.519-14.026-.142-2.058 3.376.888 8.914 6.578 12.365 5.691 3.456 11.972 3.519 14.026.143 2.058-3.377-.888-8.91-6.578-12.366z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint42_linear_0_34175)",
                        d: "M126.209 98.15l25.557 15.516a6.848 6.848 0 013.256 5.102l1.197 10.834a6.854 6.854 0 01-4.354 7.145l-10.187 3.923a6.888 6.888 0 01-6.04-.539l-25.557-15.516c-3.854-2.34-8.752.922-7.959 5.355 1.896 10.608 8.328 20.512 18.495 26.687 18.38 11.158 39.742 4.528 50.493-13.122 10.75-17.646 6.824-39.63-11.556-50.788-10.167-6.175-21.937-7.315-32.247-4.117-4.31 1.338-4.961 7.176-1.102 9.52h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint43_linear_0_34175)",
                        d: "M124.745 100.552l25.558 15.517a6.845 6.845 0 013.255 5.102l1.198 10.834a6.853 6.853 0 01-4.354 7.144l-10.187 3.923a6.877 6.877 0 01-6.036-.538l-25.557-15.517c-3.855-2.339-8.752.923-7.959 5.356 1.896 10.608 8.328 20.512 18.495 26.687 18.38 11.158 39.742 4.528 50.492-13.122 10.751-17.646 6.825-39.63-11.555-50.789-10.168-6.175-21.937-7.315-32.247-4.116-4.311 1.338-4.961 7.176-1.103 9.519z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint44_linear_0_34175)",
                        d: "M300.522 207.96l4.406 2.676c7.558 4.588 11.175 12.433 8.074 17.52l-3.684 6.048c-3.101 5.086-11.738 5.49-19.3.902l-4.406-2.676c-.293-.178-.579-.36-.864-.55l-127.161-84.901 8.026-13.177 134.017 73.644c.297.166.595.336.884.51l.008.004zm-4.076 5.914c-5.691-3.456-11.972-3.519-14.026-.142-2.058 3.376.888 8.914 6.579 12.365 5.69 3.456 11.971 3.519 14.025.143 2.058-3.377-.888-8.91-6.578-12.366z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint45_linear_0_34175)",
                        d: "M272.673 186.661h-6.123s4.965 2.972 5.131 6.099c.167 3.127-1.97 9.603-2.97 11.365-1.094 1.927 13.864-2.87 8.582-17.464h-4.62z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_34175",
                        x1: "28.968",
                        x2: "62.377",
                        y1: "38.328",
                        y2: "38.328",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_34175",
                        x1: "55.136",
                        x2: "86.562",
                        y1: "66.598",
                        y2: "66.598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_34175",
                        x1: "1061.44",
                        x2: "997.464",
                        y1: "-489.47",
                        y2: "-455.77",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_34175",
                        x1: "1158.46",
                        x2: "1078.24",
                        y1: "-601.61",
                        y2: "-565.314",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_34175",
                        x1: "195.029",
                        x2: "175.273",
                        y1: "-60.483",
                        y2: "136.647",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_34175",
                        x1: "34.277",
                        x2: "14.521",
                        y1: "104.89",
                        y2: "302.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_34175",
                        x1: "313.763",
                        x2: "294.007",
                        y1: "132.903",
                        y2: "330.033",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_34175",
                        x1: "126.444",
                        x2: "72.112",
                        y1: "129.717",
                        y2: "269.12",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_34175",
                        x1: "235.89",
                        x2: "177.465",
                        y1: "-283.381",
                        y2: "-86.695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_34175",
                        x1: "203.742",
                        x2: "149.396",
                        y1: "159.54",
                        y2: "298.979",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_34175",
                        x1: "300.189",
                        x2: "241.768",
                        y1: "-264.278",
                        y2: "-67.596",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_34175",
                        x1: "319.537",
                        x2: "299.78",
                        y1: "133.481",
                        y2: "330.611",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_34175",
                        x1: "95.112",
                        x2: "75.355",
                        y1: "110.99",
                        y2: "308.12",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_34175",
                        x1: "50.337",
                        x2: "105.124",
                        y1: "280.544",
                        y2: "280.544",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_34175",
                        x1: "140.75",
                        x2: "44.315",
                        y1: "68.062",
                        y2: "394.32",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_34175",
                        x1: "258.532",
                        x2: "238.776",
                        y1: "127.365",
                        y2: "324.495",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_34175",
                        x1: "215.273",
                        x2: "270.056",
                        y1: "281.873",
                        y2: "281.873",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_34175",
                        x1: "294.583",
                        x2: "198.147",
                        y1: "106.852",
                        y2: "433.109",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_34175",
                        x1: "208.317",
                        x2: "188.561",
                        y1: "122.335",
                        y2: "319.464",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_34175",
                        x1: "169.563",
                        x2: "149.807",
                        y1: "118.451",
                        y2: "315.581",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_34175",
                        x1: "19.435",
                        x2: "-0.322",
                        y1: "103.406",
                        y2: "300.536",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_34175",
                        x1: "201.793",
                        x2: "216.505",
                        y1: "153.33",
                        y2: "226.531",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_34175",
                        x1: "344.051",
                        x2: "294.953",
                        y1: "44.879",
                        y2: "86.133",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_34175",
                        x1: "251.021",
                        x2: "224.802",
                        y1: "308.212",
                        y2: "308.212",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_34175",
                        x1: "251.021",
                        x2: "224.802",
                        y1: "312.918",
                        y2: "312.918",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_34175",
                        x1: "296.148",
                        x2: "283.871",
                        y1: "308.275",
                        y2: "308.275",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_34175",
                        x1: "296.148",
                        x2: "284.236",
                        y1: "313.848",
                        y2: "313.848",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_34175",
                        x1: "878.202",
                        x2: "829.104",
                        y1: "-373.808",
                        y2: "-332.554",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_34175",
                        x1: "229.073",
                        x2: "225.813",
                        y1: "134.522",
                        y2: "114.385",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_34175",
                        x1: "218.509",
                        x2: "239.64",
                        y1: "101.882",
                        y2: "118.077",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_34175",
                        x1: "234.422",
                        x2: "215.308",
                        y1: "89.94",
                        y2: "114.594",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_34175",
                        x1: "221.134",
                        x2: "242.261",
                        y1: "98.458",
                        y2: "114.653",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_34175",
                        x1: "215.301",
                        x2: "205.255",
                        y1: "-99.048",
                        y2: "-144.038",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_34175",
                        x1: "880.887",
                        x2: "831.789",
                        y1: "-370.618",
                        y2: "-329.364",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_34175",
                        x1: "181.937",
                        x2: "196.648",
                        y1: "151.725",
                        y2: "224.93",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_34175",
                        x1: "243.035",
                        x2: "275.472",
                        y1: "68.34",
                        y2: "21.181",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_34175",
                        x1: "246.199",
                        x2: "293.537",
                        y1: "300.445",
                        y2: "149.701",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_34175",
                        x1: "232.388",
                        x2: "259.497",
                        y1: "197.423",
                        y2: "232.537",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#5AB6FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2F68E3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_34175",
                        x1: "256.284",
                        x2: "229.313",
                        y1: "102.132",
                        y2: "227.206",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_34175",
                        x1: "228.113",
                        x2: "200.451",
                        y1: "94.793",
                        y2: "223.062",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_34175",
                        x1: "247.024",
                        x2: "219.718",
                        y1: "99.543",
                        y2: "226.157",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint41_linear_0_34175",
                        x1: "297.306",
                        x2: "269.224",
                        y1: "89.707",
                        y2: "134.085",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint42_linear_0_34175",
                        x1: "183.145",
                        x2: "168.52",
                        y1: "-1.908",
                        y2: "42.045",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint43_linear_0_34175",
                        x1: "228.393",
                        x2: "349.894",
                        y1: "150.086",
                        y2: "181.554",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint44_linear_0_34175",
                        x1: "266.771",
                        x2: "416.34",
                        y1: "196.897",
                        y2: "225.389",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint45_linear_0_34175",
                        x1: "262.327",
                        x2: "292.308",
                        y1: "180.157",
                        y2: "223.535",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_34175",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H329.494V315H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/carWarranty/index.tsx



function CarWarranty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:py-8 py-4 lg:px-12 px-6 lg:mt-52 mt-20 bg-[#F1F6FF] relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[500px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "Car Warranty?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-base lg:leading-8 font-light",
                        children: "A car warranty gives you protection against having to pay for labour costs and replacement of certain parts of your vehicle if they suffer from mechanical faults or electrical failure. Often it can be very expensive to repair your vehicle. It's important to check how to keep your warranty valid."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[250px] md:h-[315px] md:w-[330px] md:min-w-[330px] lg:absolute relative mx-auto lg:mx-0 lg:bottom-8 lg:right-24 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 32122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CarWarrantyCover; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/carWarrantyCover/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 526 400",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_34450)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M117.652 163.203c-11.018-11.316-3.512-30.045-18.392-39.954-6.715-4.471-14.962-2.055-16.767 6.095-1.682 7.595 4.942 14.215 1.847 21.964-4.83 12.087-17.741 17.885-10.466 31.812 5.185 9.93 19.817 12.565 23.754 23.392 1.872 5.146-.863 8.666-1.62 13.774-1.27 8.595 4.412 14.782 8.929 21.318 4.567 6.611 4.012 9.6 1.91 17.516-2.378 8.967-3.272 17.114-1.812 26.027 1.449 8.847-2.743 16.424-4.099 25.106-1.562 10.022 1.353 20.592 6.972 28.763 5.998 8.721 14.647 13.171 24.501 17.534 2.783 1.234 11.699 7.4 11.639 1.192-.063-6.584-14.554-10.681-18.569-14.96-19.262-20.523 18.764-38.807 8.547-60.144-2.136-4.459-5.836-9.314-5.293-14.566.647-6.257 6.948-10.032 9.734-15.512 4.807-9.455 1.196-19.76-2.603-28.379-2.717-6.161-6.223-12.129-6.637-19.023-.362-6.04 2.612-11.928 2.333-17.879-.326-6.998-5.158-15.085-13.914-24.079l.006.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M131.426 351.44a.682.682 0 01-.42-.042c-.192-.084-19.199-8.715-20.405-27.623-.545-8.541 2.63-20.091 5.698-31.261 3.653-13.288 7.425-27.029 4.43-34.522-5.779-14.449-10.982-28.286-11.186-38.78-.066-3.448.135-6.95.33-10.338.306-5.315.62-10.81-.108-16.124-.645-4.702-3.056-8.592-5.614-12.712-2.327-3.754-4.735-7.634-5.644-12.159-.783-3.905-.705-8.064-.63-12.085.108-5.732.22-11.655-2.21-16.772-1.937-4.087-7.086-14.941-9.213-15.145-.069-.006-.215-.021-.431.273a.679.679 0 01-1.092-.805c.555-.756 1.206-.861 1.652-.819 2.133.204 4.832 4.37 10.308 15.914 2.563 5.405 2.45 11.493 2.339 17.378-.075 3.949-.15 8.033.605 11.791.861 4.285 3.203 8.06 5.467 11.709 2.516 4.057 5.122 8.252 5.803 13.243.747 5.446.426 11.007.117 16.388-.192 3.361-.393 6.839-.327 10.233.198 10.266 5.359 23.974 11.09 38.303 3.167 7.916-.501 21.258-4.381 35.383-3.041 11.062-6.184 22.501-5.653 30.814 1.154 18.08 19.415 26.389 19.6 26.47a.68.68 0 01.345.895.676.676 0 01-.473.387l.003.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M143.991 334.085c-.45-1.818-.855-3.463-1.071-4.735-3.913-23.107-12.964-46.532-27.946-64.87-24.204-29.622-14.548-40.287-30.01-47.621-15.462-7.334-19.049 4.135-39.657-8.601-20.605-12.732-60.832 3.706-39 15.77 9.674 5.345 20.824 4.948 30.837 9.078 14.931 6.154 9.98 17.852 14.617 30.33 3.658 9.839 13.767 14.956 22.593 19.052 12.181 5.654 25.913 8.547 36.421 17.525 11.999 10.257 15.064 26.132 22.918 39.063 1.748 2.878 5.368 10.389 8.852 11.136 6.403 1.372 2.402-12.273 1.449-16.127h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M140.986 333.368a.821.821 0 01-1.146-.48c-6.699-20.202-14.307-36.446-23.259-49.656-2.864-4.225-6.75-6.338-10.862-8.573-1.961-1.065-3.988-2.17-5.968-3.535-3.457-2.389-6.681-5.288-9.578-8.616-3.29-3.775-5.94-8.075-8.502-12.231-3.164-5.135-6.438-10.443-10.895-14.678-7.998-7.598-17.999-12.543-27.616-16.754-10.523-4.609-23.733-9.311-32.562-4.684a.807.807 0 01-1.113-.348.827.827 0 01.348-1.113c9.453-4.952 23.125-.124 33.986 4.633 9.756 4.27 19.91 9.294 28.09 17.069 4.613 4.381 7.942 9.783 11.163 15.007 2.528 4.103 5.143 8.343 8.343 12.016 2.81 3.223 5.928 6.029 9.275 8.342 1.907 1.318 3.896 2.398 5.818 3.442 4.294 2.335 8.352 4.541 11.441 9.099 9.038 13.339 16.712 29.712 23.46 50.061a.822.822 0 01-.42.999h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_34450)",
                        d: "M113.255 46.727l17.49 309.751h291.007l12.551-309.751H113.255z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_0_34450)",
                        d: "M435.406 53.005H111.723a3.585 3.585 0 01-3.428-2.533l-1.976-6.425c-.711-2.308 1.017-4.645 3.428-4.645h326.649a3.588 3.588 0 013.544 4.135l-.986 6.425a3.587 3.587 0 01-3.545 3.043h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_0_34450)",
                        d: "M435.406 149.279H111.723a3.585 3.585 0 01-3.428-2.533l-1.976-6.425c-.711-2.307 1.017-4.645 3.428-4.645h326.649c2.198 0 3.88 1.96 3.544 4.135l-.986 6.425a3.587 3.587 0 01-3.545 3.043h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M431.505 115.792l1.778-43.95H114.674l2.48 43.95h314.351z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_0_34450)",
                        d: "M157.177 71.841h-7.32v43.951h7.32v-43.95z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_0_34450)",
                        d: "M207.372 71.841h-7.32v43.951h7.32v-43.95z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_0_34450)",
                        d: "M257.57 71.841h-7.32v43.951h7.32v-43.95z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint6_linear_0_34450)",
                        d: "M307.765 71.841h-7.32v43.951h7.32v-43.95z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint7_linear_0_34450)",
                        d: "M357.963 71.841h-7.32v43.951h7.32v-43.95z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint8_linear_0_34450)",
                        d: "M408.158 71.841h-7.32v43.951h7.32v-43.95z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M167.055 355.917l-6.933-168.809 227.419-5.816-6.75 174.625H167.055z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M174.396 356.289l-7.341-154.57h213.736l-7.923 154.588-198.472-.018z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_0_34450",
                        style: {
                            maskType: "luminance"
                        },
                        width: "214",
                        height: "156",
                        x: "167",
                        y: "201",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M174.396 356.289l-7.341-154.57h213.736l-7.923 154.588-198.472-.018z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        fill: "#91B3FA",
                        mask: "url(#mask0_0_34450)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M385.226 214.404H162.428v6.674h222.798v-6.674zM385.226 227.086H162.428v6.008h222.798v-6.008zM385.226 239.768H162.428v6.008h222.798v-6.008zM385.226 252.453H162.428v6.007h222.798v-6.007zM385.226 265.134H162.428v6.008h222.798v-6.008zM385.226 277.816H162.428v6.008h222.798v-6.008zM385.226 290.501H162.428v5.341h222.798v-5.341zM385.226 303.183H162.428v6.007h222.798v-6.007zM385.226 315.864H162.428v5.342h222.798v-5.342zM385.226 327.88H162.428v6.008h222.798v-6.008zM385.226 341.231H162.428v4.672h222.798v-4.672z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M392.036 167.677H156.949a4.53 4.53 0 00-4.528 4.532v30.321a4.53 4.53 0 004.528 4.531h235.087a4.53 4.53 0 004.529-4.531v-30.321a4.53 4.53 0 00-4.529-4.532z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint9_linear_0_34450)",
                        d: "M398.568 203.031a6.034 6.034 0 01-6.031 6.035h-235.42a6.034 6.034 0 01-6.031-6.035v-31.32a6.034 6.034 0 016.031-6.035h235.42a6.034 6.034 0 016.031 6.035v31.32zm-3.335-31.657a3.028 3.028 0 00-3.029-3.03h-235.42a3.029 3.029 0 00-3.029 3.03v30.654a3.03 3.03 0 003.029 3.031h235.42a3.029 3.029 0 003.029-3.031v-30.654z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M423.783 350.575H129.209a4.806 4.806 0 00-4.804 4.808v1.731a4.806 4.806 0 004.804 4.808h294.574a4.806 4.806 0 004.804-4.808v-1.731a4.806 4.806 0 00-4.804-4.808z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint10_linear_0_34450)",
                        d: "M497.342 330.784l23.424-6.346s5.539 1.605 4.723 9.848c-.815 8.244-24.177 6.74-24.177 6.74l-3.97-10.239v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint11_linear_0_34450)",
                        d: "M289.142 240.077c-44.686 11.181-70.902 41.07-83.83 44.092-12.928 3.022-64.713 5.785-73.158 13.636-8.445 7.85-.378 13.429-11.234 23.524-12.01 33.916 25.179 44.065 25.179 44.065l338.069-2.749s22.812 2.053 23.319-14.251c.507-16.304-5.038-24.539-6.235-39.222-1.199-14.683-1.223-15.421-4.492-23.035-3.269-7.613-35.006-8.441-41.18-16.91-6.178-8.468-13.531-21.975-39.735-26.578-36.197-6.359-100.781-9.057-126.7-2.572h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint12_linear_0_34450)",
                        d: "M509.298 347.427c-.581 18.741-32.333 15.419-32.471 15.407 0 0-25.245-19.338 9.482-18.594 10.436-.27 21.016-5.8 21.016-5.8l1.973 8.987z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint13_linear_0_34450)",
                        d: "M118.86 329.704s-.333 4.781 8.616 9.663c11.093 6.053 49.607-.6 49.607-.6l4.397 24.799-36.299 1.852c.849.231-47.667-2.566-26.318-35.711l-.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M449.852 293.772s1.088-8.511-7.845-18.945c-8.934-10.434-14.149-17.315-21.019-19.086-6.871-1.77-57.153-8.732-60.455-3.379-3.301 5.354-7.557 38.232-7.557 38.232l96.873 3.175.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M420.079 254.841c-5.632-.84-48.402-5.816-59.447-4.396l-2.858 11.001 92.12 32.32s.441-7.005-4.163-13.91c-7.731-11.601-19.765-24.274-25.655-25.015h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M345.494 252.356c-1.391 6.353-6.523 37.328-6.523 37.328l-108.724-.504s34.274-31.515 60.62-36.506c26.348-4.987 55.521-3.679 54.63-.321l-.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M294.582 250.337c21.46-2.98 29.329-2.416 51.827-.444l-2.165 9.002s-33.483-6.572-64.68-2.773c0 0 8.013-4.816 15.018-5.788v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint14_linear_0_34450)",
                        d: "M134.661 296.184s17.616-5.65 21.913 8.286c4.097 13.285-35.653 16.859-35.653 16.859s2.929-19.707 13.74-25.145z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint15_linear_0_34450)",
                        d: "M455.87 278.713c-.098 0-.197-.015-.296-.045-4.136-1.251-7.621-5.611-11.654-10.659-5.893-7.373-12.571-15.731-23.46-17.81-20.887-3.988-52.543-6.752-52.861-6.782a1.02 1.02 0 01-.93-1.108 1.006 1.006 0 011.107-.93c.317.027 32.082 2.8 53.068 6.809 11.632 2.221 18.863 11.272 24.674 18.543 3.821 4.78 7.123 8.909 10.649 9.978a1.022 1.022 0 01-.294 2.001l-.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint16_linear_0_34450)",
                        d: "M488.243 290.318c-.378 0-.737-.21-.917-.571-1.716-3.46-9.312-5.029-16.659-6.548-2.627-.543-5.344-1.104-7.842-1.758a1.024 1.024 0 01.516-1.981c2.447.643 5.137 1.198 7.74 1.735 8.187 1.692 15.918 3.289 18.077 7.643a1.023 1.023 0 01-.915 1.48z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint17_linear_0_34450)",
                        d: "M455.33 384.552c12.717-12.725 12.717-33.356 0-46.081-12.716-12.724-33.333-12.724-46.049 0-12.716 12.725-12.716 33.356 0 46.081 12.716 12.724 33.333 12.724 46.049 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M411.892 361.679c.297 11.478 9.836 20.541 21.304 20.247 11.471-.298 20.527-9.843 20.233-21.319-.296-11.478-9.833-20.541-21.304-20.244-11.47.297-20.527 9.843-20.233 21.319v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint18_linear_0_34450)",
                        d: "M210.616 390.305c16.99-5.898 25.986-24.461 20.093-41.463-5.894-17.001-24.444-26.003-41.435-20.106-16.99 5.898-25.986 24.461-20.092 41.463 5.893 17.001 24.444 26.003 41.434 20.106z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M179.542 359.671c.297 11.478 9.837 20.541 21.304 20.247 11.471-.297 20.528-9.84 20.234-21.318-.297-11.479-9.836-20.541-21.304-20.244-11.471.297-20.527 9.843-20.234 21.318v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint19_linear_0_34450)",
                        d: "M338.86 360.112h-.101c-.594 0-1.071-.261-1.062-.855.006-.432.264-.681.633-.849 2.117-3.409 4.864-40.188 6.111-62.902.033-.594.54-1.023 1.134-.987a1.088 1.088 0 011.014 1.149c-.009.159-.894 15.95-2.163 31.755-2.582 32.173-4.174 32.689-5.566 32.689z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint20_linear_0_34450)",
                        d: "M265.67 298.393h-22.785a7.113 7.113 0 00-7.11 7.115v.261a7.112 7.112 0 007.11 7.115h22.785a7.113 7.113 0 007.111-7.115v-.261a7.114 7.114 0 00-7.111-7.115z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M78.445 146.332a2.3 2.3 0 01-.426-.042l-12.239-2.422a2.186 2.186 0 01-1.742-1.851l-1.317-9.582a46.544 46.544 0 01-11.353-7.58l-9.35 2.469a2.19 2.19 0 01-2.379-.897l-6.942-10.374a2.194 2.194 0 01.075-2.542l5.842-7.712a46.563 46.563 0 01-2.681-13.39l-8.352-4.867a2.192 2.192 0 01-1.047-2.317l2.42-12.247a2.187 2.187 0 011.85-1.743l9.576-1.317a46.544 46.544 0 017.575-11.362L45.487 49.2a2.194 2.194 0 01.897-2.38l10.367-6.946a2.184 2.184 0 012.54.075l7.707 5.845a46.46 46.46 0 0113.38-2.682l4.865-8.358a2.19 2.19 0 012.315-1.047l12.238 2.421c.915.18 1.617.925 1.743 1.85l1.316 9.58a46.532 46.532 0 0111.354 7.581l9.351-2.47a2.19 2.19 0 012.378.898l6.942 10.374a2.192 2.192 0 01-.075 2.541l-5.842 7.713a46.548 46.548 0 012.681 13.39l8.352 4.867a2.192 2.192 0 011.047 2.317l-2.42 12.246a2.187 2.187 0 01-1.848 1.744l-9.575 1.317a46.519 46.519 0 01-7.575 11.362l2.468 9.356a2.189 2.189 0 01-.9 2.38l-10.364 6.947a2.19 2.19 0 01-2.54-.075l-7.707-5.846a46.48 46.48 0 01-13.384 2.683l-4.864 8.358a2.194 2.194 0 01-1.892 1.089l.003.003zm-11.81-5.02l11.567 2.289 5.43-9.33.735-.027a43.848 43.848 0 0013.969-2.799l.69-.261 8.604 6.527 9.797-6.566-2.756-10.447.501-.54a43.924 43.924 0 007.905-11.859l.303-.672 10.688-1.471 2.288-11.574-9.324-5.432-.027-.735a43.903 43.903 0 00-2.798-13.978l-.261-.69 6.523-8.61-6.562-9.804-10.439 2.758-.539-.501a43.9 43.9 0 00-11.852-7.914l-.672-.303-1.47-10.695-11.566-2.29-5.428 9.33-.734.027a43.836 43.836 0 00-13.97 2.8l-.689.261-8.604-6.527-9.797 6.566 2.756 10.446-.501.54a43.89 43.89 0 00-7.905 11.86l-.303.672-10.688 1.474-2.288 11.574 9.323 5.432.028.735a43.999 43.999 0 002.797 13.978l.261.69-6.522 8.61 6.561 9.804 10.44-2.758.54.501a43.873 43.873 0 0011.85 7.913l.672.303 1.47 10.696-.003-.003zm16.428-20.016a31.787 31.787 0 01-12.556-2.593 1.335 1.335 0 011.058-2.452 28.964 28.964 0 005.85 1.819c7.54 1.491 15.208-.042 21.593-4.322 6.384-4.279 10.724-10.791 12.214-18.332 1.491-7.544-.042-15.218-4.318-21.606-4.277-6.39-10.784-10.732-18.32-12.223-7.54-1.494-15.208.042-21.592 4.321-6.385 4.28-10.724 10.791-12.215 18.333a28.739 28.739 0 001.134 15.292 1.333 1.333 0 11-2.51.904 31.429 31.429 0 01-1.239-16.712c1.629-8.244 6.37-15.359 13.348-20.034 6.979-4.676 15.358-6.353 23.596-4.724 8.237 1.63 15.348 6.374 20.02 13.357 4.672 6.983 6.349 15.368 4.72 23.611-1.628 8.244-6.369 15.359-13.348 20.034-5.236 3.508-11.264 5.33-17.43 5.33l-.005-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M82.78 102.42c-6.552 0-12.043-5.156-12.388-11.776-.356-6.839 4.916-12.693 11.75-13.047 6.84-.351 12.685 4.918 13.04 11.757.356 6.84-4.916 12.694-11.75 13.048-.22.012-.438.018-.654.018h.003zm.013-22.17c-.171 0-.34.002-.513.011-5.365.28-9.503 4.874-9.225 10.246.28 5.368 4.874 9.506 10.239 9.23 5.365-.279 9.503-4.873 9.224-10.245-.27-5.197-4.582-9.243-9.725-9.243zM155.827 55.07a1.418 1.418 0 01-1.283-.823l-1.862-4.048a22.786 22.786 0 01-6.016-1.819l-3.794 2.34a1.407 1.407 0 01-1.634-.107l-4.642-3.805a1.415 1.415 0 01-.429-1.585l1.544-4.183a22.923 22.923 0 01-2.972-5.54l-4.336-1.029a1.412 1.412 0 01-1.08-1.233l-.596-5.978c-.06-.6.266-1.17.815-1.422l4.046-1.864c.324-2.08.935-4.1 1.817-6.02l-2.339-3.796a1.414 1.414 0 01.108-1.635l3.802-4.646a1.408 1.408 0 011.584-.429l4.18 1.546a22.83 22.83 0 015.536-2.974l1.026-4.34A1.412 1.412 0 01150.534.6l5.974-.594c.6-.057 1.17.267 1.422.813l1.862 4.051a22.81 22.81 0 016.016 1.819l3.793-2.344a1.409 1.409 0 011.635.111l4.642 3.802c.465.382.639 1.018.429 1.585l-1.545 4.183a22.73 22.73 0 012.972 5.54l4.336 1.026c.585.138 1.02.636 1.08 1.236l.597 5.975c.06.6-.267 1.17-.816 1.423l-4.045 1.863c-.324 2.08-.936 4.1-1.818 6.02l2.339 3.796c.318.513.273 1.17-.107 1.636l-3.8 4.645a1.412 1.412 0 01-1.583.429l-4.181-1.545a22.766 22.766 0 01-5.536 2.973l-1.028 4.337a1.411 1.411 0 01-1.233 1.08l-5.971.597c-.048.006-.093.006-.141.006v.006zm-9.278-8.973l.495.243c2.039.999 4.207 1.656 6.447 1.95l.549.072 2.147 4.664 5.134-.514 1.185-4.996.522-.18a20.738 20.738 0 005.934-3.187l.438-.336 4.816 1.78 3.269-3.995-2.696-4.372.243-.495a20.77 20.77 0 001.949-6.452l.072-.55 4.661-2.148-.513-5.137-4.993-1.183-.18-.522a20.788 20.788 0 00-3.185-5.939l-.336-.438 1.778-4.82-3.991-3.27-4.369 2.698-.495-.243a20.753 20.753 0 00-6.448-1.951l-.549-.072-2.147-4.663-5.134.513-1.181 4.996-.522.18a20.744 20.744 0 00-5.935 3.187l-.438.336-4.816-1.78-3.269 3.995 2.696 4.372-.243.495a20.796 20.796 0 00-1.949 6.452l-.072.55-4.66 2.148.513 5.138 4.993 1.185.18.522a20.76 20.76 0 003.184 5.939l.336.438-1.778 4.82 3.991 3.27 4.37-2.697-.003-.003zm9.743-3.178c-.585 0-1.166-.033-1.742-.1a1.001 1.001 0 01.225-1.989 13.52 13.52 0 002.873.018 13.393 13.393 0 009.092-4.876 13.401 13.401 0 002.981-9.882c-.738-7.4-7.356-12.823-14.748-12.082-7.396.738-12.812 7.358-12.074 14.759a13.465 13.465 0 002.588 6.7 1.002 1.002 0 01-1.607 1.195 15.464 15.464 0 01-2.972-7.697c-.846-8.499 5.374-16.103 13.867-16.953 8.496-.846 16.092 5.378 16.94 13.877.849 8.498-5.374 16.102-13.866 16.952-.516.05-1.035.078-1.554.078h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M408.761 39.312l-9.59-4.7a2.38 2.38 0 00-2.642.37l-1.044.939-1.685 1.518-1.08.972a2.382 2.382 0 00-.642 2.59l3.671 10.035c.558 1.521 1.823 2.683 3.407 3.019l6.48 1.416 42.089 46.769 2.427-2.184 1.685-1.519 2.288-2.065-42.089-46.768-.684-6.644c-.171-1.612-1.139-3.04-2.594-3.751l.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint21_linear_0_34450)",
                        d: "M408.11 39.879l-8.69-4.291c-.786-.385-1.782-.313-2.432.273l-.939.846-1.517 1.368-.972.877c-.651.585-.828 1.57-.525 2.391l3.332 9.069c.501 1.371 1.67 2.416 3.098 2.722l5.865 1.278 37.957 42.175 2.156-1.942 1.518-1.368 2.372-2.137-37.957-42.174-.771-5.843c-.152-1.453-1.181-2.599-2.492-3.241l-.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint22_linear_0_34450)",
                        d: "M482.134 112.281l-29.922-26.726L437.1 99.221l23.029 31.834a20.171 20.171 0 008.553 6.782l9.179 3.916c1.554.651 3.449.462 4.699-.663l6.283-5.663c1.137-1.023 1.547-2.689 1.254-4.189l-1.545-7.71c-.843-4.324-3.131-8.312-6.415-11.244l-.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint23_linear_0_34450)",
                        d: "M434.843 97.058l15.135-13.641a2.495 2.495 0 013.523.184l.185.205a2.5 2.5 0 01-.184 3.526l-15.137 13.643a2.495 2.495 0 01-3.523-.184l-.185-.205a2.5 2.5 0 01.184-3.526l.002-.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint24_linear_0_34450)",
                        d: "M476.188 131.712a2.134 2.134 0 01-.159 3.013l-.033.027a2.13 2.13 0 01-3.011-.159l-28.525-31.695a2.133 2.133 0 01.159-3.013l.033-.027a2.128 2.128 0 013.01.159l28.526 31.695z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint25_linear_0_34450)",
                        d: "M483.655 124.984a2.133 2.133 0 01-.159 3.013l-.033.027a2.13 2.13 0 01-3.011-.159L451.927 96.17a2.133 2.133 0 01.159-3.013l.033-.027a2.13 2.13 0 013.011.159l28.525 31.695z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint26_linear_0_34450)",
                        d: "M388.384 110.736l-2.018 1.881c-3.464 3.232-4.508 7.745-2.331 10.083l2.588 2.779c2.178 2.338 6.751 1.611 10.215-1.618l2.018-1.881c.135-.126.264-.252.393-.381l57.443-58.41-5.638-6.052-62.262 53.238c-.138.12-.276.24-.408.367v-.006zm2.78 2.664c2.609-2.433 5.893-3.148 7.338-1.596 1.445 1.551.501 4.78-2.108 7.214s-5.893 3.148-7.338 1.596c-1.446-1.551-.501-4.78 2.108-7.214z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint27_linear_0_34450)",
                        d: "M468.667 35.002l-11.714 10.926a3.685 3.685 0 00-1.155 3.034l.549 5.822a3.677 3.677 0 003.059 3.283l5.767.957a3.67 3.67 0 003.107-.939l11.713-10.926c1.767-1.648 4.688-.465 4.754 1.953.155 5.78-2.139 11.683-6.799 16.031-8.424 7.856-20.341 6.69-27.895-1.42-7.555-8.108-7.881-20.087.545-27.944 4.661-4.348 10.706-6.223 16.458-5.66 2.405.235 3.38 3.236 1.614 4.883h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint28_linear_0_34450)",
                        d: "M469.695 36.106l-11.713 10.927a3.685 3.685 0 00-1.155 3.034l.549 5.821a3.675 3.675 0 003.059 3.283l5.767.958a3.667 3.667 0 003.106-.94l11.714-10.926c1.766-1.647 4.687-.465 4.753 1.954.156 5.78-2.138 11.682-6.798 16.03-8.424 7.857-20.342 6.69-27.896-1.42-7.554-8.108-7.881-20.087.546-27.943 4.66-4.349 10.706-6.224 16.458-5.66 2.405.234 3.38 3.235 1.613 4.882h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint29_linear_0_34450)",
                        d: "M389.205 111.618l-2.018 1.881c-3.463 3.232-4.507 7.746-2.33 10.083l2.588 2.779c2.177 2.338 6.751 1.615 10.214-1.617l2.019-1.882c.134-.126.263-.252.392-.381l57.444-58.41-5.638-6.052-62.263 53.239c-.138.12-.276.24-.408.366v-.006zm2.78 2.665c2.609-2.434 5.893-3.148 7.339-1.597 1.445 1.552.501 4.781-2.109 7.214-2.609 2.434-5.892 3.148-7.338 1.597-1.445-1.552-.501-4.781 2.108-7.214z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint30_linear_0_34450)",
                        d: "M93.517 380.98s-.807 4.325-1.22 8.607a2.956 2.956 0 002.791 3.229c5.704.291 17.904.87 22.285.717a.961.961 0 00.858-1.308 2.157 2.157 0 00-1.089-1.171L97.07 381.59l-3.553-.61z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint31_linear_0_34450)",
                        d: "M92.914 378.43l.564 5.185s3.515 1.678 5.947-.15l-1.407-5.788-5.104.75v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint32_linear_0_34450)",
                        d: "M94.306 281.036c-.28 1.35-2.07 67.499 4.717 97.217.11.486-.138.981-.6 1.164-1.088.432-3.22 1.053-5.767 1.116a1.735 1.735 0 01-1.706-1.26c-1.955-6.899-11.306-41.457-12.257-74.392-1.061-36.803.013-1.251.013-1.251l1.043-22.732 14.557.141v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint33_linear_0_34450)",
                        d: "M70.306 383.018s-1.239 2.176-2.471 7.973a1.802 1.802 0 001.565 2.173c1.883.204 4.78.468 7.104.477 1.07 0 1.917-.921 1.797-1.986-.237-2.125-1.005-5.612-3.458-8.346l-4.537-.288v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint34_linear_0_34450)",
                        d: "M69.301 376.347l1.361 7.847s1.41 1.072 4.223.33l-.606-8.435-4.981.258h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint35_linear_0_34450)",
                        d: "M66.314 282.8c-6.112 34.853.432 86.288 2.708 96.365a1.569 1.569 0 001.254 1.203c1.058.186 2.798.345 4.522-.138a1.433 1.433 0 001.043-1.314c.396-8.127.3-58.031 5.872-77.699.282-.996.9-1.864 1.752-2.455l10.523-7.337.914-12.013-28.59 3.388h.002z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint36_linear_0_34450)",
                        d: "M103.776 217.009c-17.319-.453-36.478 4.204-36.478 4.204-5.452 30.099-1.52 64.912-1.52 64.912 13.377 3.646 28.558-1.878 28.558-1.878 2.348-12.58 13.087-47.946 13.087-47.946 8.474-.969 15.468-3.346 21.241-6.523-4.331-5.123-6.334-11.605-7.195-15.434-6.141 1.846-12.349 2.803-17.69 2.665h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint37_linear_0_34450)",
                        d: "M155.186 191.966c-1.683-2.073-3.845-1.119-3.845-1.119-2.651 10.749-16.101 19.359-29.872 23.5.861 3.829 2.864 10.314 7.195 15.434 22.911-12.604 26.525-37.815 26.525-37.815h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint38_linear_0_34450)",
                        d: "M154.766 192.486c.174.567-1.899 1.41-3.089-.919-.033-1.11-.66-5.872.009-6.773 3.578-4.783 10.481-10.755 10.481-10.755 1.146 1.153.183 2.266.183 2.266l-3.353 3.43c.684 1.263 1.521 2.332 1.901 3.853.291 1.152.093 2.383-.497 3.424-.594 1.044-1.401 2.404-2.163 3.466-1.442 2.011-3.472 2.005-3.472 2.005v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint39_linear_0_34450)",
                        d: "M157.522 181.968l-3.05 2.538-.975 2.548 2.669 3.022s.957-5.063 1.641-6.155c.683-1.092.338-1.626-.285-1.953z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint40_linear_0_34450)",
                        d: "M73.781 238.06l-6.483-16.847s-16.284 10.845-19.08 24.769c3.057.256 8.61 1.105 14.03 3.908 1.26-6.575 11.533-11.827 11.533-11.827v-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint41_linear_0_34450)",
                        d: "M87.771 253.989s-18.263 10.101-24.309 1.269c-1.256-1.833-1.541-3.646-1.211-5.368-5.42-2.803-10.973-3.653-14.03-3.908-.842 4.199-.46 8.673 1.965 13.216 10.55 19.755 39.948-.705 39.948-.705l-2.36-4.504h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint42_linear_0_34450)",
                        d: "M86.365 202.77L80.7 218.666a.573.573 0 00.255.693c1.493.846 6.885 3.301 13.447-.777a2.703 2.703 0 001.262-1.921l1.916-13.786-11.218-.108.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint43_linear_0_34450)",
                        d: "M99.934 187.015s4.508 12.559 3.686 17.156c-.819 4.598-8.319 4.195-14.832.393l-4.46-12.354c2.87-4.997 9.522-6.497 15.606-5.195z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint44_linear_0_34450)",
                        d: "M94.42 176.191c-3.665.441-3.869 3.574-9.687 5.999-3.595 1.497-4.702.798-6.267 2.4-2.423 2.479-2.927 7.392-1.14 10.798 3.077 5.863 11.456 9.224 11.807 8.204.096-.276 2.039-3.604-.045-5.708-.534-.54-.64-1.377-.333-2.073a1.85 1.85 0 00-.087-1.618c-.903-1.677-.75-3.103-.513-3.607.963-2.052 5.938.357 10.826-2.401.273-.153 4.726-2.733 4.558-5.998-.171-3.331-5.092-6.482-9.116-5.999l-.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint45_linear_0_34450)",
                        d: "M89.85 197.104s-4.313-.87-4.652 1.617c-.339 2.488 3.848 3.647 5.932 2.737l-1.284-4.354h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint46_linear_0_34450)",
                        d: "M84.037 269.951l9.95-34.769c.115-.396.45-.681.858-.729 1.803-.21 7.027-.801 13.057-1.311 7.264-.615 15.699-1.114 20.741-.69.716.06 1.148.819.83 1.464-2.867 5.804-14.658 29.412-20.563 37.145a1.022 1.022 0 01-.822.402l-23.082-.216a1.018 1.018 0 01-.969-1.296z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint47_linear_0_34450)",
                        d: "M86.44 261.551s-1.386-5.702-.828-7.724c.558-2.023 1.643-4.625 5.254-4.045 3.61.579 7.869 2.1 7.869 2.1s-.216 2.635-2.96 1.786l1.7 1.317s-.243 2.11-2.56.981l1.583 1.747s-.996 1.731-2.702.621c-1.707-1.11-2.522 3.904-7.36 3.217h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M94.911 245.385l-.345-.102 2.028-6.875a2.93 2.93 0 012.2-2.052c6.4-1.336 23.833-1.618 24.01-1.621l.006.36c-.174 0-17.574.285-23.94 1.615a2.567 2.567 0 00-1.928 1.8l-2.028 6.875h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint48_linear_0_34450)",
                        d: "M87.666 213.273l-5.92-.591c-.288-.03-.593.132-.701.39-.597 1.434-2.31 5.894-2.082 6.038 4.634 2.86 9.417 2.007 9.417 2.007v-7.22c0-.324-.384-.594-.717-.627l.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint49_linear_0_34450)",
                        d: "M96.807 213.525a.622.622 0 00-.312-.495.674.674 0 00-.597-.039l-1.185.504a.645.645 0 00-.338.333l-2.88 6.671c2.202 1.062 5.563-3.409 5.563-3.409l-.251-3.565z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint50_linear_0_34450)",
                        d: "M88.383 221.12s1.886 16.166 2.018 15.869c.132-.294 1.751-17.063 1.751-17.063s-2.432.795-3.766.849v.342l-.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M101.464 184.206h-.027a.169.169 0 01-.138-.192c.045-.267-.309-2.088-1.44-3.646-.968-1.338-2.222-2.13-3.727-2.358a.17.17 0 01-.141-.19.167.167 0 01.189-.141c1.595.241 2.924 1.081 3.946 2.491 1.203 1.657 1.557 3.55 1.497 3.895a.167.167 0 01-.165.138l.006.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint51_linear_0_34450)",
                        d: "M450.35 398.124c0-.117-.006-.237-.036-.357-1.782-7.067-9.066-10.692-9.066-10.692l-3.506.276c-2.015 6.23-3.313 9.273-2.99 10.975.009.048.024.093.036.138 2.891.258 8.841.426 15.562-.34z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint52_linear_0_34450)",
                        d: "M434.788 398.461c.156.567.576 1.011 1.113 1.122 4.111.864 10.649.168 13.393-.189.606-.078 1.047-.639 1.059-1.272-6.721.765-12.671.597-15.562.339h-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint53_linear_0_34450)",
                        d: "M444.133 381.617l-1.536 7.391c-.113.54-.527.948-1.031.993-.618.057-1.494.093-2.378-.039-.792-.117-1.344-.921-1.203-1.785l1.068-6.563h5.08v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint54_linear_0_34450)",
                        d: "M405.013 398.401c3.742-.105 5.676-.547 6.678-.955 0 .372 0 .75-.012 1.144-.012.42-.324.753-.705.753l-20.548-.132c-.657-.003-1.04-.765-.756-1.369 2.693.222 9.558.721 15.343.559z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint55_linear_0_34450)",
                        d: "M389.67 397.842c.024-.051.045-.105.081-.156 1.815-2.538 6.436-7.589 15.571-9.783l4.381-.138s1.952 3.394 1.988 9.678c-1.002.408-2.936.849-6.678.954-5.785.163-12.647-.336-15.343-.558v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint56_linear_0_34450)",
                        d: "M410.516 381.121c-.048.328-.651 5.294-.882 7.221-.054.456-.387.813-.804.861-.747.09-1.952.171-3.011-.045-.57-.117-.983-.663-.983-1.303v-7.796l5.677 1.062h.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint57_linear_0_34450)",
                        d: "M441.203 284.562s7.011 62.364 3.116 101.343c0 0-4.675 0-7.012-.78 0 0-7.284-60.975-9.641-78.425-.09-.658-1.029-.688-1.158-.036-2.908 14.68-14.328 72.246-15.687 77.681 0 0-3.895 1.56-7.011 0 0 0 6.232-83.413 10.907-98.225l26.486-1.561v.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint58_linear_0_34450)",
                        d: "M455.226 212.064s-29.602-4.679-52.975 1.56l1.559 24.166s6.232 33.52 10.907 48.332c0 0 17.918 3.118 26.486-1.56 0 0 7.011-42.096 10.907-48.332 0 0 3.895-16.37 3.116-24.166z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint59_linear_0_34450)",
                        d: "M434.662 190.763l2.948 19.956s-8.238 3.787-14.007-.162l1.241-14.083 9.818-5.711z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint60_linear_0_34450)",
                        d: "M421.965 177.766c-.093.168-1.871 10.233-2.966 16.46a4.371 4.371 0 004.046 5.12l2.387.141a8.508 8.508 0 008.913-7.211l1.727-11.284s-11.852-7.319-14.107-3.226z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint61_linear_0_34450)",
                        d: "M438.645 181.022c.915-1.14 1.712-2.979-.237-4.918-1.973-1.96-4.213-1.47-5.632-.813-.63.291-1.403.162-1.85-.366-.198-.234-.495-.396-.933-.345-.824.093-1.562-.454-1.661-1.279-.168-1.416-.921-3.082-3.422-3.565-4.585-.888-6.873 3.706-6.792 6.935.081 3.229 5.11 3.907 7.962 3.37 2.096-.393 3.907 1.45 4.72 2.455.297.366.405.843.3 1.299l-.726 3.118c.501.969.996 1.96 1.7 2.788.507.597 1.065.924 1.656 1.062.854-1.593 3.248-1.863 4.357-1.899a1.51 1.51 0 001.101-.522c.839-.964 2.15-3.109-.36-5.219-.624-.525-.696-1.467-.186-2.104l.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint62_linear_0_34450)",
                        d: "M432.905 194.1s.099-5.629 2.375-6.16c2.276-.529 4.735 1.119 2.786 4.489-2.423 4.192-5.164 1.668-5.164 1.668l.003.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint63_linear_0_34450)",
                        d: "M455.226 212.064s45.963 49.892-8.181 68.99v-3.898s20.254-17.15 4.675-40.536c0 0 1.946-22.219 3.506-24.556z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint64_linear_0_34450)",
                        d: "M446.658 277.546s-7.011-4.678-10.127-3.118c-3.116 1.56-3.116 3.898-3.116 3.898s1.559 3.118 3.895 2.338c2.337-.78 7.792.78 10.128 0 0 0 .779-3.118-.78-3.118z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint65_linear_0_34450)",
                        d: "M402.254 213.621s-47.91 48.332 6.231 67.433v-3.898s-20.254-17.15-4.675-40.536c0 0 1.556-19.101-1.559-22.996l.003-.003z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint66_linear_0_34450)",
                        d: "M408.875 277.546s7.011-4.678 10.127-3.118c3.116 1.56 3.116 3.898 3.116 3.898s-1.559 3.118-3.895 2.338c-2.337-.78-7.791.78-10.128 0 0 0-.779-3.118.78-3.118z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_34450",
                        x1: "-65.654",
                        x2: "277.587",
                        y1: "456.885",
                        y2: "194.23",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_34450",
                        x1: "296.519",
                        x2: "282.106",
                        y1: "-135.94",
                        y2: "-26.098",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_34450",
                        x1: "280.38",
                        x2: "312.813",
                        y1: "87.65",
                        y2: "-141.033",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_34450",
                        x1: "130.376",
                        x2: "193.839",
                        y1: "379.825",
                        y2: "-403.48",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_34450",
                        x1: "180.244",
                        x2: "243.71",
                        y1: "383.864",
                        y2: "-399.441",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_34450",
                        x1: "230.115",
                        x2: "293.578",
                        y1: "387.903",
                        y2: "-395.399",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_34450",
                        x1: "279.984",
                        x2: "343.446",
                        y1: "391.945",
                        y2: "-391.36",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_34450",
                        x1: "329.852",
                        x2: "393.317",
                        y1: "395.985",
                        y2: "-387.318",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_34450",
                        x1: "379.723",
                        x2: "443.185",
                        y1: "400.027",
                        y2: "-383.278",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_34450",
                        x1: "151.086",
                        x2: "398.568",
                        y1: "187.369",
                        y2: "187.369",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_34450",
                        x1: "525.405",
                        x2: "498.699",
                        y1: "330.695",
                        y2: "336.862",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_34450",
                        x1: "117.13",
                        x2: "386.283",
                        y1: "432.202",
                        y2: "292.413",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_34450",
                        x1: "477.946",
                        x2: "484.48",
                        y1: "228.964",
                        y2: "302.776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_34450",
                        x1: "138.955",
                        x2: "145.493",
                        y1: "258.993",
                        y2: "332.799",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_34450",
                        x1: "154.316",
                        x2: "145.623",
                        y1: "243.69",
                        y2: "283.257",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_34450",
                        x1: "433.694",
                        x2: "425.968",
                        y1: "125.719",
                        y2: "173.008",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_34450",
                        x1: "499.867",
                        x2: "492.141",
                        y1: "136.531",
                        y2: "183.818",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_34450",
                        x1: "447.311",
                        x2: "441.518",
                        y1: "285.186",
                        y2: "314.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_34450",
                        x1: "213.273",
                        x2: "206.514",
                        y1: "272.955",
                        y2: "316.863",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_34450",
                        x1: "424.154",
                        x2: "378.814",
                        y1: "285.018",
                        y2: "308.397",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_34450",
                        x1: "132.868",
                        x2: "226.65",
                        y1: "352.826",
                        y2: "316.426",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_34450",
                        x1: "504.237",
                        x2: "395.57",
                        y1: "70.858",
                        y2: "64.545",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_34450",
                        x1: "501.702",
                        x2: "486.583",
                        y1: "34.423",
                        y2: "66.879",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_34450",
                        x1: "443.236",
                        x2: "446.597",
                        y1: "64.942",
                        y2: "163.455",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_34450",
                        x1: "468.898",
                        x2: "510.625",
                        y1: "137.208",
                        y2: "233.698",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_34450",
                        x1: "477.636",
                        x2: "519.366",
                        y1: "133.43",
                        y2: "229.922",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_34450",
                        x1: "383.947",
                        x2: "379.383",
                        y1: "-448.771",
                        y2: "-517.472",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_34450",
                        x1: "1272.47",
                        x2: "1337.92",
                        y1: "-212.118",
                        y2: "-233.354",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_34450",
                        x1: "413.223",
                        x2: "487.87",
                        y1: "138.104",
                        y2: "14.274",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_34450",
                        x1: "397.929",
                        x2: "472.576",
                        y1: "128.885",
                        y2: "5.056",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_34450",
                        x1: "93.279",
                        x2: "95.766",
                        y1: "129.428",
                        y2: "184.073",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_34450",
                        x1: "92.771",
                        x2: "99.33",
                        y1: "380.692",
                        y2: "380.754",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_34450",
                        x1: "157.06",
                        x2: "127.649",
                        y1: "252.501",
                        y2: "286.091",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_34450",
                        x1: "61.092",
                        x2: "63.579",
                        y1: "130.894",
                        y2: "185.536",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_34450",
                        x1: "69.141",
                        x2: "74.803",
                        y1: "380.133",
                        y2: "380.186",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_34450",
                        x1: "147.287",
                        x2: "117.875",
                        y1: "243.939",
                        y2: "277.529",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_34450",
                        x1: "87.045",
                        x2: "32.403",
                        y1: "248.224",
                        y2: "361.629",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_34450",
                        x1: "121.375",
                        x2: "154.874",
                        y1: "209.763",
                        y2: "210.078",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_34450",
                        x1: "174.786",
                        x2: "164.881",
                        y1: "159.986",
                        y2: "173.784",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_34450",
                        x1: "173.644",
                        x2: "121.432",
                        y1: "170.852",
                        y2: "217.631",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_34450",
                        x1: "63.141",
                        x2: "8.502",
                        y1: "236.707",
                        y2: "350.112",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint41_linear_0_34450",
                        x1: "48.276",
                        x2: "81.27",
                        y1: "250.424",
                        y2: "263.612",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint42_linear_0_34450",
                        x1: "95.034",
                        x2: "81.525",
                        y1: "201.548",
                        y2: "229.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint43_linear_0_34450",
                        x1: "-917.319",
                        x2: "-893.184",
                        y1: "-406.352",
                        y2: "-392.007",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint44_linear_0_34450",
                        x1: "86.08",
                        x2: "92.956",
                        y1: "165.118",
                        y2: "204.317",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint45_linear_0_34450",
                        x1: "-920.367",
                        x2: "-896.232",
                        y1: "-401.216",
                        y2: "-386.872",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint46_linear_0_34450",
                        x1: "118.278",
                        x2: "103.567",
                        y1: "279.538",
                        y2: "244.135",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint47_linear_0_34450",
                        x1: "102.777",
                        x2: "98.574",
                        y1: "221.087",
                        y2: "233.689",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint48_linear_0_34450",
                        x1: "80.751",
                        x2: "67.54",
                        y1: "229.322",
                        y2: "271.629",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint49_linear_0_34450",
                        x1: "90.089",
                        x2: "76.878",
                        y1: "232.239",
                        y2: "274.546",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FE7062"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint50_linear_0_34450",
                        x1: "88.383",
                        x2: "92.149",
                        y1: "228.46",
                        y2: "228.46",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint51_linear_0_34450",
                        x1: "440.6",
                        x2: "448.708",
                        y1: "417.012",
                        y2: "336.289",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint52_linear_0_34450",
                        x1: "442.489",
                        x2: "443.991",
                        y1: "402.236",
                        y2: "327.514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint53_linear_0_34450",
                        x1: "439.839",
                        x2: "442.964",
                        y1: "374.505",
                        y2: "401.785",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint54_linear_0_34450",
                        x1: "401.069",
                        x2: "399.568",
                        y1: "419.53",
                        y2: "344.808",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint55_linear_0_34450",
                        x1: "411.277",
                        x2: "403.17",
                        y1: "502.615",
                        y2: "421.892",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint56_linear_0_34450",
                        x1: "406.929",
                        x2: "409.857",
                        y1: "377.994",
                        y2: "403.514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint57_linear_0_34450",
                        x1: "443.926",
                        x2: "501.569",
                        y1: "307.027",
                        y2: "191.223",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4042E2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4F52FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint58_linear_0_34450",
                        x1: "619.786",
                        x2: "528.842",
                        y1: "459.667",
                        y2: "356.185",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint59_linear_0_34450",
                        x1: "429.183",
                        x2: "431.286",
                        y1: "185.017",
                        y2: "222.828",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint60_linear_0_34450",
                        x1: "418.23",
                        x2: "419.37",
                        y1: "405.134",
                        y2: "378.518",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint61_linear_0_34450",
                        x1: "440.685",
                        x2: "418.542",
                        y1: "185.92",
                        y2: "173.72",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint62_linear_0_34450",
                        x1: "426.733",
                        x2: "427.873",
                        y1: "405.5",
                        y2: "378.885",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint63_linear_0_34450",
                        x1: "630.168",
                        x2: "539.224",
                        y1: "450.541",
                        y2: "347.059",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint64_linear_0_34450",
                        x1: "445.416",
                        x2: "443.765",
                        y1: "258.961",
                        y2: "265.713",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint65_linear_0_34450",
                        x1: "601.382",
                        x2: "510.438",
                        y1: "475.835",
                        y2: "372.356",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint66_linear_0_34450",
                        x1: "420.901",
                        x2: "417.748",
                        y1: "257.986",
                        y2: "268.938",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FEB3B1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_34450",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H525.573V400H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/sharedButton/index.tsx
var sharedButton = __webpack_require__(90652);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/carWarrantyCover/index.tsx




function CarWarrantyCover() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:mt-28 mt-14 lg:mb-52 mb-28 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "What Does a Car Warranty Cover?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 lg:text-lg text-base lg:leading-8 font-light",
                        children: "An auto warranty covers repairs for parts that fail due to defects or errors in how your vehicle was built. So, if your power window motor, transmission or infotainment system stops working as it's supposed to, you can take it back to the dealership, and they'll fix it. There will typically be no deductible with a new car warranty, and getting coverage will be a no-haggle affair. Warranties will typically cover both the failed part and the labor to swap it out or repair it. Car warranties last for a certain number of miles or years and expire when you hit the first milestone. For example, if your auto warranty is for five years or 50,000 miles, it would end once your mileage hits 50,000 even if the car was only three years old. It would expire after five years even if you only have driven 30,000 miles."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mt-[50px] mt-7 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[250px] md:h-[400px] md:w-[525px] md:min-w-[525px] relative mx-auto lg:mx-0 lg:mt-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 70111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ CategoryForm; },
/* harmony export */   "pA": function() { return /* binding */ AllowedSlugsAuto; },
/* harmony export */   "x6": function() { return /* binding */ AllowedSlugsHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96119);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12282);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);





const AllowedSlugsAuto = [
    "car-warranty",
    "autowarranty",
    "auto-warranty", 
];
const AllowedSlugsHome = [
    "home-warranty"
];
function CategoryForm({ form  }) {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: ` ${AllowedSlugsHome.includes(category?.slug) ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainSectionHome) : ""} ${AllowedSlugsAuto.includes(category?.slug) ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().mainSectionCar) : ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                colors: {
                    primaryColor: "#478ff0",
                    progressBar: "grey"
                },
                secondServiceColors: {
                    mainBackgroundColor: "#f1f6ff",
                    mainBorderColor: "#c5d4f4",
                    hoverRadioColor: "#4f96f6",
                    selectedRadioColor: "#4f96f6",
                    textHoverRadioColor: "#fff",
                    textSelectedRadioColor: "#fff",
                    hoverCheckboxColor: "#ddecff",
                    selectedCheckboxColor: "#ddecff"
                },
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().form),
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-button"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-inner"]),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-field"]),
                        checkbox: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["checkbox-field"]),
                        all: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().field)
                    },
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-wrapper"]),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-title"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-description"]),
                    formProgressbarClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["progress-bar"]),
                    labelAsTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["label-as-step-title"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tcpa)
                },
                goToThankYouPage: AllowedSlugsHome.includes(category?.slug) ? false : true,
                showProgress: true,
                form: form,
                dynamicThankYouFields: [
                    "firstName",
                    "manufacturingYear",
                    "vehicleMake",
                    "vehicleModel", 
                ]
            })
        })
    });
}


/***/ }),

/***/ 27397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HowIsCarWarranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/howIsHomeWarranty/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 400 403",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_6484)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_6484)",
                        d: "M189.053 284.649S156.261 108.098 75.162 8.669c-5.455-6.683-16.14-4.736-18.83 3.454C38.366 66.897.836 233.881 189.052 284.65z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M172.193 272.541c.406.439-.194 1.067-.654.691-17.006-13.979-82.077-81.741-100.936-211.331-.063-.416.556-.541.648-.135 7.1 30.175 36.717 141.602 100.942 210.775z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_0_6484)",
                        d: "M94.785 400.135h-21.37V106.083c0-17.757 14.47-32.204 32.254-32.204h22.233c6.001 0 10.884-4.875 10.884-10.867V1.276h21.371v61.736c0 17.757-14.47 32.204-32.255 32.204h-22.233c-6 0-10.884 4.876-10.884 10.867v294.052z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_0_6484)",
                        d: "M163.622 53.716h-28.476v4.865h28.476v-4.865z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_0_6484)",
                        d: "M112.832 70.105v28.43h4.873v-28.43h-4.873z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_0_6484)",
                        d: "M69.737 120.313h28.475v-4.865H69.737v4.865z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_0_6484)",
                        d: "M142.212 340.443S112.614 191.68 43.047 108.567c-4.675-5.586-13.686-3.827-15.864 3.121C12.597 158.147-17.3 299.585 142.212 340.443z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M127.844 330.397c.348.367-.15.904-.542.59-14.514-11.621-70.201-68.158-87.526-177.411-.059-.353.464-.464.546-.121 6.32 25.41 32.536 119.206 87.522 176.942z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M34.767 316.206l-12.748-1.019c-10.97 0-19.865-8.881-19.865-19.835v-61.084h25.58l7.033 81.938z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M29.68 236.111l1.184-.075a1.749 1.749 0 011.853 1.632l4.548 72.175-5.303.333-4.508-71.543a2.377 2.377 0 012.227-2.522z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M69.36 350.092L14.13 329.861c6.887 10.036 10.69 30.097 14.02 51.701l-7.012 16.375a1.476 1.476 0 001.422 1.875h39.137c.973 0 1.68-.918 1.428-1.856l-5.396-12.215a18.231 18.231 0 01-1.287-10.548c1.756-9.828 5.628-18.438 12.916-25.096v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M6 315.153a1.16 1.16 0 00-.991 1.73c12.834 22.835 32.705 33.789 56.534 33.789 23.83 0 43.41-15.999 44.247-35.993a1.166 1.166 0 00-1.18-1.213L6 315.153z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M31.611 306.702h70.279c3.644 0 6.601 2.952 6.601 6.591v1.894H37.69c-3.354 0-6.079-2.721-6.079-6.069v-2.416z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M27.701 231.673H2.333A2.331 2.331 0 000 234.002v1.338a2.331 2.331 0 002.333 2.329H27.7a2.33 2.33 0 002.333-2.329v-1.338a2.33 2.33 0 00-2.333-2.329z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint6_linear_0_6484)",
                        d: "M120.294 141.409c-5.047.246-8.914 4.581-8.57 9.615l15.747 232.388c.32 4.731 4.259 8.408 9.011 8.408h168.273a9.023 9.023 0 008.996-8.248l19.953-232.562c.431-5.04-3.368-9.442-8.425-9.77-62.526-4.02-131.614-3.431-204.985.164v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M126.857 204.325c-.712-8.35 5.88-15.52 14.271-15.52h160.68c8.367 0 14.954 7.131 14.276 15.457l-11.707 144.115c-.6 7.402-6.775 13.113-14.213 13.147l-136.623.604c-7.462.034-13.705-5.663-14.339-13.089L126.847 204.32l.01.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M321.025 180.518a1.81 1.81 0 01-1.481.773H121.553c-.76 0-1.438-.473-1.694-1.189a1.798 1.798 0 011.694-2.411h197.991c1.457 0 2.309 1.634 1.481 2.827z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint7_linear_0_6484)",
                        d: "M124.993 149.159a1.839 1.839 0 00-1.79 1.967l1.442 19.767a1.836 1.836 0 001.829 1.701h42.578c.992 0 1.805-.788 1.834-1.778l.653-20.797a1.831 1.831 0 00-1.878-1.889l-44.672 1.029h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint8_linear_0_6484)",
                        d: "M256.017 157.861l.764 13.032a1.836 1.836 0 001.83 1.701h54.424c.992 0 1.805-.788 1.834-1.778l1.331-14.061a1.831 1.831 0 00-1.878-1.889l-56.52 1.029a1.838 1.838 0 00-1.79 1.966h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M196.646 172.594c6.663 0 12.065-5.393 12.065-12.046s-5.402-12.046-12.065-12.046c-6.663 0-12.064 5.393-12.064 12.046s5.401 12.046 12.064 12.046z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M206.219 161.261c1.087-4.597-1.765-9.203-6.369-10.288-4.604-1.085-9.218 1.762-10.304 6.359-1.087 4.597 1.765 9.203 6.369 10.288 4.604 1.085 9.217-1.762 10.304-6.359z",
                        opacity: "0.64"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M231.132 172.594c6.663 0 12.065-5.393 12.065-12.046s-5.402-12.046-12.065-12.046c-6.663 0-12.064 5.393-12.064 12.046s5.401 12.046 12.064 12.046z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M240.845 160.682c.758-4.663-2.413-9.056-7.083-9.813-4.67-.756-9.07 2.41-9.828 7.072-.758 4.662 2.413 9.055 7.083 9.812 4.67.757 9.07-2.409 9.828-7.071z",
                        opacity: "0.64"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M267.868 147.169h-10.83c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.83c.567 0 1.026-.458 1.026-1.024v-3.397c0-.566-.459-1.024-1.026-1.024zM283.481 147.169H272.65c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.831c.566 0 1.026-.458 1.026-1.024v-3.397c0-.566-.46-1.024-1.026-1.024zM299.572 147.169h-10.831c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.831c.566 0 1.026-.458 1.026-1.024v-3.397c0-.566-.46-1.024-1.026-1.024z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint9_linear_0_6484)",
                        d: "M315.184 147.169h-10.831c-.567 0-1.026.458-1.026 1.024v3.397c0 .566.459 1.024 1.026 1.024h10.831c.566 0 1.026-.458 1.026-1.024v-3.397c0-.566-.46-1.024-1.026-1.024z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M305.394 369.183H136.023c-.62 0-1.118-.503-1.118-1.117 0-.618.503-1.116 2.85-1.116h169.371c-1.113 0-.61.503-.61 1.116 0 .619-.503 1.117-1.117 1.117h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint10_linear_0_6484)",
                        d: "M266.953 319.709c25.544-25.504 25.544-66.854 0-92.358-25.544-25.505-66.96-25.505-92.504 0-25.544 25.504-25.544 66.854 0 92.358 25.544 25.504 66.96 25.504 92.504 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint11_linear_0_6484)",
                        d: "M221.352 325.967c29.368 0 53.176-23.771 53.176-53.093 0-29.322-23.808-53.092-53.176-53.092-29.368 0-53.176 23.77-53.176 53.092s23.808 53.093 53.176 53.093z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint12_linear_0_6484)",
                        d: "M221.352 322.903c27.674 0 50.108-22.399 50.108-50.029 0-27.63-22.434-50.029-50.108-50.029-27.674 0-50.108 22.399-50.108 50.029 0 27.63 22.434 50.029 50.108 50.029z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint13_linear_0_6484)",
                        d: "M240.772 231.233c-3.992-2.251-9.088-1.768-12.301 1.498-5.111 5.189-10.613 14.365-4.656 27.087 8.968 19.154 7.206 49.817-11.377 57.944 0 0 45.031 5.141 53.713-38.172 5.657-28.227-15.433-42.742-25.379-48.357z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M213.158 234.804l-.788.039c-.494.058-1.244.145-2.188.434-.939.29-2.057.769-3.291 1.498-1.224.74-2.555 1.725-3.949 2.962-.672.609-1.427 1.3-2.153 2.02-.358.362-.731.734-1.104 1.116-.363.396-.735.797-1.117 1.213a54.58 54.58 0 00-4.511 5.658c-2.923 4.242-5.647 9.485-7.104 15.626-.165.769-.373 1.537-.484 2.334-.068.396-.136.792-.203 1.194l-.025.149c-.009.053 0 .015-.004.049l-.01.077-.034.309-.073.623c-.043.416-.101.841-.135 1.252-.024.406-.044.812-.068 1.222-.068.812-.029 1.663-.039 2.503.049 3.378.591 6.866 1.622 10.297.111.435.271.855.421 1.28.155.426.295.856.459 1.276.18.416.354.836.533 1.256.092.208.174.421.271.628l.305.614c.203.411.411.822.619 1.232.228.401.46.802.692 1.203l.349.604.387.58c.261.387.518.773.779 1.165.581.729 1.113 1.517 1.762 2.203.314.353.619.72.948 1.058.339.334.678.667 1.021 1l.257.252.063.062c.024.025 0 0 .043.039l.14.121.567.488.566.483.561.43c.373.29.746.58 1.157.846.402.27.794.56 1.215.802 6.591 4.155 15.074 5.808 23.142 4.242 8.087-1.541 15.685-6.093 21.11-12.485 2.676-3.18 4.824-6.871 6.059-10.814 1.238-3.938 1.519-8.147.571-12.094-.934-3.929-3.015-7.567-5.779-10.452-2.773-2.899-6.204-5.044-9.969-6.165-3.692-1.116-7.666-1.29-11.373-.643-3.716.643-7.225 2.039-10.211 4.04-2.986 1.995-5.473 4.58-7.09 7.518-.803 1.469-1.398 3.015-1.708 4.6-.324 1.561-.334 3.165-.136 4.697.421 3.058 1.854 5.861 4.012 7.649 2.139 1.821 4.912 2.512 7.424 2.435 5.062-.155 9.287-3.368 10.085-6.886.378-1.71-.062-3.421-.938-4.45-.886-1.077-2.106-1.367-3.044-1.333-.949.038-1.617.401-1.985.695a2.75 2.75 0 00-.387.377c-.077.092-.121.14-.121.14l-.019.025a.238.238 0 11-.368-.305s.044-.058.136-.169c.082-.116.237-.266.445-.454.426-.353 1.19-.788 2.274-.855a4.56 4.56 0 011.772.251c.159.048.309.13.469.198.155.082.329.179.47.275l.208.15c.096.068.145.126.222.189.145.12.271.265.407.41 1.031 1.189 1.568 3.044 1.171 5.03-.397 1.948-1.771 3.832-3.668 5.209-1.897 1.377-4.366 2.329-7.09 2.45a12.817 12.817 0 01-4.172-.488c-.353-.087-.692-.237-1.04-.353-.344-.14-.678-.3-1.021-.459-.33-.193-.692-.377-.993-.58l-.45-.309c-.082-.063-.13-.087-.246-.174l-.223-.184a12.018 12.018 0 01-2.991-3.638 14.498 14.498 0 01-1.548-4.663c-.242-1.657-.262-3.396.067-5.126.31-1.716.925-3.407 1.772-5.001 1.713-3.18 4.331-5.948 7.467-8.089 3.141-2.15 6.833-3.662 10.763-4.377 3.939-.72 8.111-.595 12.166.589 8.024 2.295 14.959 9.166 17.108 17.786 1.088 4.291.779 8.905-.542 13.128-1.322 4.247-3.572 8.142-6.417 11.544-5.687 6.735-13.667 11.572-22.257 13.239-8.595 1.691-17.625-.029-24.71-4.46-.455-.261-.876-.57-1.307-.86-.436-.28-.852-.604-1.273-.928l-.629-.483-.571-.488-.566-.483-.141-.121s-.077-.068-.091-.082l-.068-.068-.276-.27c-.368-.358-.736-.715-1.099-1.073-.358-.367-.682-.759-1.026-1.136-.701-.739-1.272-1.575-1.897-2.362a35.666 35.666 0 01-5.12-10.505c-1.074-3.648-1.645-7.334-1.655-10.91.019-.894-.005-1.773.078-2.667.029-.445.062-.884.091-1.324.039-.435.102-.841.15-1.261l.078-.624.039-.309.009-.077.015-.106.029-.16.232-1.251c.136-.836.363-1.638.547-2.445.803-3.204 1.979-6.156 3.315-8.838a49.104 49.104 0 014.433-7.233 55.702 55.702 0 014.825-5.663c.406-.406.798-.807 1.2-1.189.407-.376.803-.744 1.195-1.101a73.336 73.336 0 012.275-1.947c1.481-1.204 2.909-2.165 4.22-2.88 1.321-.706 2.526-1.155 3.538-1.397a12.106 12.106 0 012.352-.323c.522.004.793.009.793.009.136 0 .242.111.237.247 0 .13-.106.232-.232.236l.019.015z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint14_linear_0_6484)",
                        d: "M368.064 210.012c2.052-5.451 2.943-11.935 1.588-19.497 8.29-1.44 16.028-4.392 22.818-9.093.808 11.635-2.289 24.487-13.018 37.234-5.212 6.189-12.22 12.35-21.458 18.337l-2.72 5.798-8.174-10.166s15.147-7.176 20.964-22.613z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint15_linear_0_6484)",
                        d: "M253.065 159.374c8.382 1.464 15.713.372 22.198-2.03.17 1.435.412 2.885.75 4.334 1.418 6.364 3.369 12.525 6.103 18.207-12.559 1.855-23.897-1.783-32.352-6.122-.116-5.885 1.491-10.785 3.305-14.389h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M275.263 157.344c10.889-4.029 19.363-11.751 26.327-17.22 14.663-11.524 25.794-5.572 25.794-5.572l-15.98 30.171c-9.979 9.388-19.972 13.79-29.293 15.167-2.734-5.683-4.685-11.843-6.102-18.207a40.755 40.755 0 01-.751-4.334l.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint16_linear_0_6484)",
                        d: "M221.671 144.854l7.39 4.305c8.851 5.823 16.807 8.958 24.004 10.215-1.81 3.604-3.422 8.499-3.306 14.389-9.374-4.813-15.205-10.49-15.205-10.49-16.721-10.775-12.883-18.419-12.883-18.419z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint17_linear_0_6484)",
                        d: "M305.805 355.267a39.61 39.61 0 00-.368-1.701l-60.309-252.827-25.814 4.972L257.57 362.79c.087.575.184 1.145.295 1.715l1.665 8.601c2.851 14.756 13.246 25.164 23.21 23.241l11.847-2.28c9.965-1.919 15.733-15.438 12.878-30.2l-1.665-8.6h.005zm-20.21 24.058c-6.61 1.275-13.715-6.702-15.858-17.811-2.149-11.108 1.471-21.149 8.081-22.424 6.611-1.276 13.715 6.702 15.859 17.81 2.149 11.108-1.471 21.149-8.082 22.425z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint18_linear_0_6484)",
                        d: "M254.579 1.604c-6.615-3.89-14.731 1.972-13.274 9.5l9.645 49.898a11.666 11.666 0 01-2.715 9.934l-12.302 13.897a11.692 11.692 0 01-13.996 2.696l-16.599-8.33a11.666 11.666 0 01-6.224-8.21l-9.645-49.898c-1.456-7.528-11.174-9.954-15.863-3.885-11.218 14.52-16.367 33.94-12.53 53.793 6.935 35.886 39.732 55.17 74.305 48.507 34.573-6.663 57.827-36.746 50.887-72.632-3.838-19.854-15.854-35.964-31.679-45.275l-.01.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint19_linear_0_6484)",
                        d: "M249.866 2.513c-6.616-3.89-14.732 1.971-13.275 9.499l9.645 49.899a11.647 11.647 0 01-2.715 9.934L231.219 85.74a11.69 11.69 0 01-13.995 2.696l-16.6-8.33a11.665 11.665 0 01-6.223-8.209L184.756 22c-1.457-7.529-11.174-9.954-15.864-3.885-11.218 14.52-16.367 33.939-12.529 53.793 6.935 35.886 39.732 55.17 74.305 48.507 34.573-6.664 57.826-36.747 50.886-72.633-3.837-19.854-15.854-35.963-31.679-45.274l-.009.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint20_linear_0_6484)",
                        d: "M302.045 355.992a42.517 42.517 0 00-.368-1.701l-60.305-252.827-25.813 4.972 38.256 257.079c.087.575.184 1.145.295 1.715l1.665 8.601c2.85 14.756 13.245 25.164 23.21 23.241l11.847-2.281c9.964-1.918 15.733-15.437 12.877-30.199l-1.664-8.6zm-20.21 24.057c-6.611 1.276-13.715-6.701-15.859-17.81-2.148-11.108 1.471-21.149 8.082-22.424 6.611-1.276 13.715 6.701 15.859 17.81 2.149 11.108-1.471 21.149-8.082 22.424z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint21_linear_0_6484)",
                        d: "M220.708 155.982a5.44 5.44 0 011.268-4.484c2.076-2.397 5.662-5.682 8.261-3.469 3.871 3.295-.373 14.572-.373 14.572l-4.292 6.548-.063 4.179c-2.323-2.715-3.712-9.398-4.806-17.346h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint22_linear_0_6484)",
                        d: "M319.718 398.985c0-.178.015-.357.063-.541 2.914-10.673 16.484-17.095 16.484-17.095l5.318.517c2.884 9.509 2.381 15.298 1.839 17.868-.014.073-.039.14-.058.208-4.404.309-13.454.396-23.65-.957h.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint23_linear_0_6484)",
                        d: "M343.369 399.947c-.252.86-.905 1.517-1.723 1.672-6.277 1.193-16.193-.049-20.355-.672-.919-.135-1.573-1-1.573-1.962 10.197 1.353 19.247 1.266 23.651.957v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint24_linear_0_6484)",
                        d: "M343.877 373.985l-2.463 10.804c-.179.793-.804 1.377-1.544 1.431-.91.067-2.202.091-3.494-.121-1.162-.193-1.95-1.387-1.718-2.653l1.752-9.601 7.472.14h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint25_linear_0_6484)",
                        d: "M296.634 398.956c5.89-.053 8.944-.686 10.531-1.299a38.085 38.085 0 01-.053 1.792c-.034.657-.533 1.174-1.133 1.16l-32.303-.817c-1.031-.024-1.612-1.232-1.147-2.164 4.23.43 15.002 1.415 24.105 1.333v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint26_linear_0_6484)",
                        d: "M272.534 397.623c.038-.082.077-.165.13-.242 2.928-3.928 10.347-11.717 24.769-14.882l6.891-.087s2.967 5.383 2.836 15.245c-1.587.613-4.641 1.246-10.531 1.299-9.103.083-19.875-.903-24.105-1.333h.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint27_linear_0_6484)",
                        d: "M305.8 372.014c-.087.512-1.176 8.287-1.602 11.302-.101.715-.634 1.261-1.292 1.328-1.176.116-3.078.208-4.728-.159-.89-.203-1.524-1.073-1.505-2.073l.232-12.229 8.895 1.836v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint28_linear_0_6484)",
                        d: "M314.647 225.604s-19.15 79.368-20.35 158.712c-.02 1.445 11.058 2.72 11.314 1.391 2.59-13.596 19.649-102.159 27.498-114.49 0 0-.179 78.053-2.449 113.529-.058.884 9.994 3.774 12.094 1.522 0 0 14.165-86.384 14.746-140.592.029-2.793-5.019-20.067-5.019-20.067h-37.834v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint29_linear_0_6484)",
                        d: "M300.477 141.172c-.31 3.078 1.185-1.517 0 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M300.477 141.172c.029-.285.072-.638.135-1.068 20.95-14.5 51.927-6.378 63.939-4.638a16.07 16.07 0 0110.056 5.638c6.117 7.345 16.624 22.391 17.863 40.317-6.79 4.702-14.523 7.654-22.818 9.094-.692-3.87-1.965-8.021-3.973-12.457a31.612 31.612 0 01-.847 3.04c-9.026 26.768-13.73 42.056-13.807 47.221-.01.701-41.334-1.009-34.017-1.222 3.059-.087-14.247-61.036-23.287-71.855-.537-.642 7.941-15.587 6.761-14.07h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint30_linear_0_6484)",
                        d: "M345.595 113.462l1.742 22.072s-12.486 3.498-21.39-3.03l6.727-19.902 12.921.864v-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint31_linear_0_6484)",
                        d: "M331.667 88.08c-.305.275-13.071 24.178-13.071 24.178l13.826 6.987 15.472-20.859s-11.136-14.911-16.227-10.306z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint32_linear_0_6484)",
                        d: "M336.313 93.197c3.102.454 4.743 3.875 5.396 5.658.237.647.16 1.362-.203 1.947l-7.177 11.451a2.283 2.283 0 01-.392.469c-.842.754-3.722 2.938-5.851-.15-1.82-2.633-3.528-5.03-5.386-6.039-1.085-.59-2.444-.16-3.02.932-1.191 2.247-3.499 6.832-4.975 11.191a2.202 2.202 0 001.239 2.734c2.802 1.199 8.348 3.368 13.289 4.146a2.216 2.216 0 002.119-.855c2.188-2.875 8.349-10.91 10.439-12.911 1.941-1.86 5.445-1.077 7.017-.594a2.25 2.25 0 001.781-.198c1.626-.938 4.477-3.291 1.989-7.417-.619-1.024-.266-2.368.746-3.01 1.814-1.145 3.803-3.32 2.018-6.939-2.26-4.57-8.658-4.14-12.249-7.504-1.771-1.657-3.509-3.508-5.812-4.286-.494-.169-1.012-.28-1.529-.27-2.26.043-5.682 3.764-5.837 6.01-.218 3.209 3.702 5.238 6.403 5.635h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint33_linear_0_6484)",
                        d: "M339.091 115.969s2.826-7.77 6.247-7.417c3.422.353 6.055 3.813 1.733 7.562-5.372 4.668-7.98-.145-7.98-.145z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M366.85 176.063c4.747-12.254 3.392-27.189 3.378-27.339l-1.249.121c.015.145 1.341 14.79-3.3 26.769l1.171.449z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint34_linear_0_6484)",
                        d: "M333.748 269.617a.626.626 0 00.615-.459c1.476-5.281 11.905-10.915 12.011-10.973a.624.624 0 10-.59-1.101c-.45.241-11.005 5.948-12.627 11.736a.63.63 0 00.596.797h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint35_linear_0_6484)",
                        d: "M363.685 186.862c.068-.348 0-.71-.199-1.005l-15.418-23.193a.6.6 0 00-.499-.266h-28.228c-.465 0-.891.247-1.128.643l-13.415 22.666c-.232.392-.314.856-.232 1.305 5.309 16.1 10.448 31.948 10.081 39.655 9.621 7.504 26.549 5.938 38.101 2.483.595-10.059 5.551-25.893 10.937-42.293v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint36_linear_0_6484)",
                        d: "M358.255 134.649l-10.361 29.73h-6.238l9.214-30.962a.616.616 0 01.711-.425l6.49 1.338a.241.241 0 01.179.319h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint37_linear_0_6484)",
                        d: "M322.758 132.562l2.545 31.001-5.754.705-4.897-30.909a.39.39 0 01.353-.449l7.37-.672a.354.354 0 01.387.324h-.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint38_linear_0_6484)",
                        d: "M323.769 89.612c12.302-23.203 44.194-2.126 29.351 17.423-11.034-7.325-23.505-18.216-29.351-17.423z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint39_linear_0_6484)",
                        d: "M324.572 87.109c-24.874-1.266-4.399 7.943 18.255 12.857-5.638-5.977-11.276-10.432-18.255-12.857z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_6484",
                        x1: "101.745",
                        x2: "250.03",
                        y1: "144.642",
                        y2: "144.642",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_6484",
                        x1: "380.628",
                        x2: "336.183",
                        y1: "-97.082",
                        y2: "-46.761",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_6484",
                        x1: "160.176",
                        x2: "219.07",
                        y1: "34.775",
                        y2: "-82.23",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_6484",
                        x1: "-2425.57",
                        x2: "-2542.61",
                        y1: "-1194.59",
                        y2: "-1253.68",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_6484",
                        x1: "-777.342",
                        x2: "-836.235",
                        y1: "1823.72",
                        y2: "1940.73",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_6484",
                        x1: "15.017",
                        x2: "142.212",
                        y1: "222.845",
                        y2: "222.845",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_6484",
                        x1: "111.704",
                        x2: "333.738",
                        y1: "265.143",
                        y2: "265.143",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_6484",
                        x1: "123.198",
                        x2: "171.549",
                        y1: "160.36",
                        y2: "160.36",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_6484",
                        x1: "256.012",
                        x2: "316.205",
                        y1: "163.732",
                        y2: "163.732",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_6484",
                        x1: "303.327",
                        x2: "316.205",
                        y1: "149.894",
                        y2: "149.894",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#9CFFFB"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9BFFFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_6484",
                        x1: "155.295",
                        x2: "286.11",
                        y1: "273.527",
                        y2: "273.527",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_6484",
                        x1: "287.415",
                        x2: "183.182",
                        y1: "234.992",
                        y2: "294.952",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_6484",
                        x1: "171.244",
                        x2: "271.46",
                        y1: "272.874",
                        y2: "272.874",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_6484",
                        x1: "212.525",
                        x2: "338.667",
                        y1: "282.828",
                        y2: "224.075",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_6484",
                        x1: "360.312",
                        x2: "372.768",
                        y1: "114.404",
                        y2: "236.538",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_6484",
                        x1: "264.491",
                        x2: "277.999",
                        y1: "162.664",
                        y2: "295.143",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_6484",
                        x1: "198.82",
                        x2: "301.649",
                        y1: "103.764",
                        y2: "240.783",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_6484",
                        x1: "71.034",
                        x2: "286.902",
                        y1: "252.392",
                        y2: "248.175",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_6484",
                        x1: "145.106",
                        x2: "276.486",
                        y1: "182.924",
                        y2: "-27.288",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_6484",
                        x1: "214.78",
                        x2: "243.726",
                        y1: "5.726",
                        y2: "382.598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_6484",
                        x1: "241.9",
                        x2: "270.846",
                        y1: "3.643",
                        y2: "380.515",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_6484",
                        x1: "261.621",
                        x2: "311.929",
                        y1: "146.168",
                        y2: "125.82",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_6484",
                        x1: "319.718",
                        x2: "343.843",
                        y1: "390.742",
                        y2: "390.742",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_6484",
                        x1: "332.763",
                        x2: "331.972",
                        y1: "337.887",
                        y2: "379.917",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_6484",
                        x1: "337.82",
                        x2: "341.644",
                        y1: "363.335",
                        y2: "403.457",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_6484",
                        x1: "290.977",
                        x2: "290.186",
                        y1: "337.101",
                        y2: "379.13",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_6484",
                        x1: "272.534",
                        x2: "307.17",
                        y1: "390.689",
                        y2: "390.689",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_6484",
                        x1: "300.312",
                        x2: "304.141",
                        y1: "366.915",
                        y2: "407.037",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_6484",
                        x1: "-1672.49",
                        x2: "-1472.04",
                        y1: "-2019",
                        y2: "-1784.87",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_6484",
                        x1: "300.636",
                        x2: "300.936",
                        y1: "140.993",
                        y2: "143.907",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FDF53F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.66",
                                stopColor: "#E57A58"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#D93C65"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_6484",
                        x1: "332.496",
                        x2: "348.558",
                        y1: "107.222",
                        y2: "183.249",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_6484",
                        x1: "333.332",
                        x2: "333.814",
                        y1: "94.535",
                        y2: "34.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_6484",
                        x1: "314.584",
                        x2: "356.039",
                        y1: "103.556",
                        y2: "103.556",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_6484",
                        x1: "342.31",
                        x2: "344.511",
                        y1: "148.139",
                        y2: "112.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_6484",
                        x1: "216.923",
                        x2: "327.348",
                        y1: "107.141",
                        y2: "247.796",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_6484",
                        x1: "-1610.58",
                        x2: "-1405.75",
                        y1: "-1982.01",
                        y2: "-1751.7",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_6484",
                        x1: "337.019",
                        x2: "429.351",
                        y1: "106.156",
                        y2: "416.025",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_6484",
                        x1: "310.857",
                        x2: "403.193",
                        y1: "113.954",
                        y2: "423.818",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_6484",
                        x1: "360.801",
                        x2: "265.556",
                        y1: "73.077",
                        y2: "178.618",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_6484",
                        x1: "312.99",
                        x2: "343.661",
                        y1: "89.977",
                        y2: "95.283",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_6484",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H400V402.116H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/sharedButton/index.tsx
var sharedButton = __webpack_require__(90652);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/howIsHomeWarranty/index.tsx




function HowIsCarWarranty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 order-1 lg:order-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "How Is a Home Warranty Different From Homeowners' Insurance?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 lg:text-lg text-base lg:leading-8 font-light",
                        children: "While homeowners' insurance primarily covers property damage and the structure of your house, a home warranty is designed to provide protection for your appliances and systems. It's a smart investment to ensure the safety of your home, but it should not be considered a replacement for homeowners' insurance. It's worth noting that manufacturer warranties may provide coverage for certain home systems in the case of recent home purchases."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mt-[50px] mt-7 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[250px] h-[250px] md:h-[402px] md:w-[400px] md:min-w-[400px] relative mx-auto lg:mt-16 order-2 lg:order-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 90652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SharedButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52072);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function SharedButton() {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        className: `bg-[#F02B17] text-white py-4 sm:px-8 px-4 sm:text-xl font-semibold  ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_1___default().animation)}`,
        children: "Get My Free Quote Now"
    });
}


/***/ }),

/***/ 71527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhatIsCarWarrantyCategoryPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsCarWarrantyCategoryPage/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 403 400",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M359.665 236.232c-17.053.732-36.026-18.666-40.394-37.61-4.494-19.491 9.487-25.475 12.926-51.189 3.903-29.212-12.208-35.915-17.855-76.792-1.274-9.223-8.641-62.596 10.581-69.762 17.772-6.629 60.735 25.328 64.379 59.157 2.599 24.122-16.706 31.444-13.585 59.557 2.736 24.664 18.504 27.185 21.401 51.019 3.522 29.012-15.065 64.657-37.453 65.62z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#91B3FA",
                d: "M357.481 243.139c8.813-30.839 6.747-80.577 3.459-116.868-3.561-39.294-9.272-71.73-9.33-72.053l-1.436.18c.058.323 5.764 32.715 9.315 71.961 3.278 36.188 5.344 85.761-3.414 116.419l1.406.366v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M67.999 237.287c25.51-5.857 43.657-44.048 34.287-60.437-6.33-11.069-21.117-5.007-30.672-17.263-12.203-15.647 4.733-34.728.176-66.377C67.91 66.274 49.43 36.935 33.912 37.93 17.664 38.971.254 73.538 7.298 98.896c4.582 16.491 17.117 20.507 16.409 34.551-.82 16.296-18.128 19.325-22.11 34.297-7.16 26.892 32.657 77.29 66.402 69.538v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M53.197 244.424a.946.946 0 001.168-1.104c-13.815-69.113-4.02-142.573-3.923-143.31a.944.944 0 10-1.87-.26c-.104.738-9.937 74.516 3.941 143.936.074.366.352.64.689.728l-.005.01z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint0_linear_0_34274)",
                d: "M22.32 112.383c.092.025.195.02.293-.024a.45.45 0 00.234-.596c-6.263-14.513-11.963-35.348-3.57-52.21C24.272 49.508 32 45.605 32.08 45.566a.45.45 0 00.205-.606.45.45 0 00-.606-.205c-.327.161-8.08 4.079-13.214 14.396-4.719 9.477-7.928 26.364 3.547 52.972a.456.456 0 00.303.259h.004z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M348.855 117.605a4.692 4.692 0 00-1.456-3.317 4.704 4.704 0 00-3.385-1.289l-101.564 3.243a4.691 4.691 0 00-4.538 4.827l5.012 168.209a4.691 4.691 0 004.734 4.552l99.521-.967a4.692 4.692 0 003.317-1.416 4.708 4.708 0 001.329-3.352l-2.97-170.485v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#BDD0FB",
                opacity: "0.63",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M338.259 125.553h-90.445c-.879 0-1.587.611-1.578 1.441l.088 7.968c.01.835.733 1.778 1.617 1.778l90.704.093c.899 0 1.593-.968 1.563-1.813l-.273-8.006c-.029-.84-.777-1.461-1.671-1.461h-.005zM338.846 142.851l-90.836-.152c-.884 0-1.593.84-1.583 1.686l.088 8.069c.01.846.738 1.647 1.622 1.647l91.099.249c.904 0 1.608-.801 1.578-1.656l-.278-8.143c-.03-.85-.787-1.7-1.686-1.705l-.004.005zM339.461 161.042l-91.251-.313c-.889 0-1.602.406-1.592 1.256l.087 8.138c.01.85.738 1.495 1.627 1.5l91.495.405c.904 0 1.617-.64 1.588-1.499l-.278-8.217c-.03-.855-.777-1.275-1.681-1.28l.005.01zM340.057 178.784l-91.652-.469c-.889 0-1.607.572-1.597 1.432l.088 8.211c.01.86.738 1.344 1.631 1.349l91.901.566c.909.005 1.632-.474 1.603-1.343l-.284-8.29c-.029-.865-.786-1.456-1.69-1.46v.004zM340.658 196.678l-92.053-.625a1.604 1.604 0 00-1.602 1.607l.088 8.285c.01.87.747 1.807 1.646 1.812l92.321.733c.914.01 1.622-.928 1.593-1.807l-.284-8.363c-.029-.87-.796-1.637-1.704-1.642h-.005zM341.269 214.733l-92.463-.786c-.899-.01-1.617.913-1.607 1.788l.088 8.358c.01.874.747 1.656 1.651 1.665l92.731.894a1.598 1.598 0 001.607-1.646l-.288-8.436c-.029-.879-.806-1.822-1.719-1.832v-.005zM341.904 233.579l-92.888-.957c-.904-.01-1.632.464-1.622 1.343l.093 8.432c.01.884.752 1.499 1.656 1.509l93.146 1.065c.924.01 1.652-.596 1.617-1.485l-.288-8.515c-.029-.889-.791-1.382-1.71-1.392h-.004zM342.524 251.961l-93.303-1.128c-.908-.01-1.636.64-1.627 1.524l.093 8.505c.01.889.753 1.343 1.661 1.353l93.562 1.231c.928.01 1.661-.425 1.631-1.324l-.293-8.588c-.029-.894-.801-1.568-1.724-1.578v.005zM343.149 270.51l-93.723-1.3c-.914-.015-1.641.816-1.632 1.71l.093 8.583c.01.899.762 1.822 1.676 1.837l93.996 1.411c.933.015 1.656-.894 1.622-1.802l-.293-8.666c-.029-.904-.811-1.759-1.739-1.773z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M193.088 24.39c-.059-3.014-2.496-5.49-5.491-5.49H74.496c-3.034 0-6.009 2.608-6.009 5.661v272.913c0 1.471.84 2.877 1.871 3.913 1.03 1.036 2.565 1.617 4.02 1.612l118.256-.327c1.47 0 2.911-.601 3.942-1.661a5.63 5.63 0 001.583-4.006l-5.071-272.62v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                fill: "#BDD0FB",
                opacity: "0.81",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M109.795 51.057l-32.222-.044-.254-16.628h32.251l.225 16.672zM145.909 51.053l-32.187-.044-.22-16.624h32.216l.191 16.668zM181.989 51.043l-32.157-.044-.186-16.614h32.187l.156 16.658zM110.195 80.91l-32.162.019-.254-16.521 32.196-.015.22 16.516zM146.251 80.885l-32.133.02-.22-16.511 32.163-.015.19 16.506zM182.263 80.86l-32.099.02-.181-16.501 32.129-.015.151 16.496zM110.596 110.552l-32.104.034-.255-16.462 32.139-.03.22 16.458zM146.588 110.512l-32.074.035-.22-16.453 32.104-.03.19 16.448zM182.541 110.478l-32.045.034-.181-16.448 32.075-.029.151 16.443zM110.996 140.095l-32.05.044-.254-16.403 32.085-.044.219 16.403zM146.925 140.042l-32.021.044-.219-16.399 32.055-.039.185 16.394zM182.815 139.988l-31.987.049-.185-16.394 32.021-.039.151 16.384zM111.397 169.532l-31.997.059-.254-16.35 32.031-.049.22 16.34zM147.262 169.464l-31.967.063-.215-16.345 31.997-.053.185 16.335zM183.089 169.4l-31.933.059-.181-16.335 31.962-.054.152 16.33zM111.792 198.871l-31.942.074-.25-16.297 31.972-.063.22 16.286zM147.594 198.788l-31.908.073-.215-16.286 31.938-.064.185 16.277zM183.362 198.705l-31.875.074-.185-16.277 31.908-.064.152 16.267zM112.188 228.108l-31.884.083-.254-16.233 31.918-.083.22 16.233zM147.931 228.01l-31.855.088-.215-16.233 31.885-.078.185 16.223zM183.636 227.912l-31.821.088-.186-16.223 31.855-.078.152 16.213zM112.584 257.242l-31.83.103-.25-16.184 31.86-.093.22 16.174zM148.264 257.134l-31.801.098-.215-16.174 31.83-.093.186 16.169zM183.909 257.022l-31.772.097-.18-16.164 31.801-.093.151 16.16zM112.975 286.278l-31.777.112-.244-16.125 31.806-.102.215 16.115zM148.595 286.156l-31.747.112-.215-16.12 31.777-.103.185 16.111zM184.177 286.029l-31.713.112-.18-16.11 31.742-.103.151 16.101z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#91B3FA",
                d: "M256.807 72.615c-.034-1.617-1.524-2.921-3.356-2.921H142.519c-1.852 0-3.82 1.343-3.82 2.984v229.227c0 1.226.781 2.399 1.763 3.263.982.865 2.423 1.349 3.81 1.349l112.149-.274c1.398 0 2.76-.503 3.737-1.387.977-.884 1.525-2.081 1.5-3.317l-4.846-228.93-.005.006z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M193.098 85.936l-36.29-.108.014-4.02 36.252.098.024 4.03zM193.195 100.747l-36.436-.151.014-4.05 36.398.137.024 4.064zM193.298 115.676l-36.588-.186.015-4.084 36.544.171.029 4.099zM193.401 130.726l-36.74-.22.01-4.118 36.701.21.029 4.128zM193.503 145.909l-36.896-.259.015-4.157 36.852.249.029 4.167zM193.709 176.65l-37.204-.337.015-4.226 37.16.327.029 4.236zM194.026 223.741l-37.678-.459.015-4.333 37.634.449.029 4.343zM193.606 161.213l-37.048-.298.015-4.186 37.003.283.03 4.201zM193.811 192.213l-37.36-.376.015-4.26 37.316.367.029 4.269zM193.919 207.909l-37.517-.415.01-4.294 37.477.405.03 4.304zM194.134 239.705l-37.839-.498.014-4.368 37.795.484.03 4.382zM194.241 255.811l-38-.542.014-4.407 37.957.528.029 4.421zM194.349 272.053l-38.167-.586.015-4.446 38.122.572.03 4.46zM194.461 288.432l-38.332-.63.014-4.479 38.284.615.034 4.494zM240.678 86.083l-36.52-.113-.039-4.03 36.476.103.083 4.04zM240.971 100.938l-36.667-.147-.039-4.07 36.627.143.079 4.074zM241.269 115.915l-36.818-.186-.039-4.098 36.778.176.079 4.108zM241.572 131.019l-36.975-.224-.039-4.133 36.931.21.083 4.147zM241.875 146.246l-37.126-.259-.044-4.167 37.086.249.084 4.177zM242.49 177.089l-37.443-.337-.039-4.24 37.399.328.083 4.249zM243.433 224.341l-37.922-.459-.044-4.347 37.878.449.088 4.357zM242.182 161.604l-37.287-.298-.039-4.206 37.243.288.083 4.216zM242.802 192.707l-37.599-.376-.044-4.28 37.556.372.087 4.284zM243.115 208.456l-37.761-.42-.044-4.309 37.722.406.083 4.323zM243.75 240.36l-38.083-.499-.044-4.386 38.039.488.088 4.397zM244.073 256.519l-38.249-.542-.044-4.426 38.205.532.088 4.436zM244.4 272.82l-38.415-.591-.044-4.46 38.371.576.088 4.475zM244.727 289.258l-38.582-.635-.044-4.499 38.538.62.088 4.514z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M338.992 387.504H63.964C28.636 387.504 0 358.864 0 323.541v-84.652h402.956v84.652c0 35.328-28.636 63.963-63.964 63.963z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint1_linear_0_34274)",
                d: "M122.378 161.326c30.656 0 55.508-24.852 55.508-55.508 0-30.656-24.852-55.508-55.508-55.508-30.656 0-55.508 24.852-55.508 55.508 0 30.656 24.852 55.508 55.508 55.508z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M143.691 79.424l-5.564-7.928c-.845-1.197-2.222-1.968-3.693-1.968h-25.338c-1.466 0-2.843.771-3.693 1.968l-5.564 7.9a4.543 4.543 0 00-.235 4.865l12.819 22.607c.806 1.412 2.305 2.404 3.927 2.404h10.83c1.622 0 3.122-.982 3.928-2.394l12.818-22.544a4.622 4.622 0 00-.235-4.905v-.005zM133.814 134.884l-.914.048s-8.973 8.319-8.514 8.622c.229.152.757.591 1.221 1.002a.344.344 0 01.112.342.354.354 0 01-.244.264c-.22.063-.444.092-.664.146-.88.225-1.788.269-2.672.269-.88-.064-1.759-.132-2.565-.415-.42-.093-.786-.303-1.177-.45-.357-.205-.733-.381-1.051-.635l-.478-.366c-.157-.122-.284-.284-.425-.416-.303-.258-.503-.6-.748-.903-.21-.328-.395-.674-.566-1.026-.113-.371-.332-.752-.372-1.089l-.127-.508-.034-.128-.019-.19-.044-.386-.088-.767v-.049l-.01-.024v-.01c-.019-.132.02.166.015.132v-.073l.009-.142.01-.283v-.567l.122-.547c.035-.366.191-.713.313-1.06.083-.357.332-.679.479-1.026.21-.327.425-.659.669-.977.513-.63 1.07-1.255 1.754-1.807.649-.577 1.387-1.016 2.144-1.51.738-.483 1.627-.791 2.306-1.211l.132-.113c.698-.175 1.226-.791 1.333-1.509l.093-.63.752-4.216a4.988 4.988 0 002.331-4.221 4.934 4.934 0 00-1.036-3.033l.586-3.278h-8.27l.601 2.433a4.978 4.978 0 00-1.856 3.878c0 1.568.771 3.049 1.963 3.957l.03 2.013c.004.41-.24.781-.616.943-.327.141-.65.283-.982.478-1.001.572-1.949 1.368-2.848 2.145-.908.752-1.729 1.675-2.481 2.662-.357.513-.689 1.06-.997 1.617-.254.601-.586 1.153-.747 1.803-.186.635-.371 1.265-.42 1.929l-.108.982.034.977.025.489.014.244.01.122.02.156v.01l.01.024.009.049.157.757.078.377.039.19.073.244.313.972c.195.675.527 1.183.801 1.764.322.547.684 1.08 1.084 1.578.435.474.841.967 1.354 1.348.249.195.483.415.742.591l.801.498c.533.333 1.114.557 1.681.797.586.176 1.157.405 1.758.488 1.182.274 2.379.283 3.552.22 1.167-.132 2.315-.347 3.395-.757.268-.103.542-.191.806-.303l.776-.371.386-.186.127-.063.039-.025.083-.054.162-.102.649-.42c.45-.332.992-.757 1.392-1.163.401-.42.797-.835 1.119-1.309.694-.909 1.187-1.925 1.573-2.951.401-1.025.66-2.081.835-3.136.176-1.065.254-2.051.215-3.146l-.014-.009z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint2_linear_0_34274)",
                d: "M83.044 269.069l-14.166-3.835s-3.351.972-2.858 5.955c.493 4.982 14.62 4.074 14.62 4.074l2.404-6.19v-.004z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint3_linear_0_34274)",
                d: "M208.959 214.249c27.024 6.756 42.88 24.821 50.696 26.648 7.816 1.827 39.134 3.497 44.243 8.241 5.105 4.743.23 8.113 6.795 14.215 7.264 20.497-15.226 26.633-15.226 26.633l-204.45-1.661s-13.796 1.24-14.103-8.612c-.308-9.853 3.048-14.831 3.77-23.702.724-8.871.743-9.321 2.717-13.922 1.973-4.602 21.171-5.1 24.903-10.22 3.737-5.119 8.183-13.282 24.03-16.062 21.889-3.844 60.949-5.476 76.625-1.553v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint4_linear_0_34274)",
                d: "M75.814 279.126c.352 11.324 19.555 9.321 19.638 9.311 0 0 15.265-11.685-5.735-11.24-6.312-.161-12.71-3.508-12.71-3.508l-1.193 5.433v.004z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint5_linear_0_34274)",
                d: "M311.939 268.419s.2 2.887-5.212 5.837c-6.707 3.659-29.999-.361-29.999-.361l-2.657 14.987L296.024 290c-.513.142 28.826-1.548 15.915-21.581z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint6_linear_0_34274)",
                d: "M111.768 246.7s-.66-5.144 4.743-11.45c5.403-6.307 8.559-10.464 12.711-11.534 4.152-1.069 34.561-5.275 36.559-2.042 1.998 3.234 4.567 23.106 4.567 23.106l-58.585 1.92h.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#7D97F4",
                d: "M129.774 223.174c3.404-.508 29.27-3.512 35.948-2.657l1.729 6.648-55.713 19.535s-.264-4.23 2.516-8.407c4.675-7.01 11.954-14.67 15.515-15.119h.005z",
                opacity: "0.23"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint7_linear_0_34274)",
                d: "M174.877 221.669c.84 3.84 3.947 22.559 3.947 22.559l65.751-.303s-20.727-19.046-36.661-22.06c-15.935-3.014-33.575-2.223-33.037-.196z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint8_linear_0_34274)",
                d: "M205.666 220.453c-12.979-1.802-17.737-1.46-31.342-.268l1.31 5.441s20.248-3.971 39.114-1.675c0 0-4.846-2.912-9.082-3.498z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint9_linear_0_34274)",
                d: "M302.384 248.161s-10.654-3.415-13.253 5.007c-2.477 8.03 21.562 10.19 21.562 10.19s-1.773-11.91-8.309-15.197z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M108.128 237.599a.784.784 0 00.181-.024c2.501-.757 4.606-3.39 7.049-6.443 3.561-4.455 7.601-9.506 14.186-10.762 12.632-2.413 31.777-4.079 31.967-4.098a.617.617 0 00.562-.67.606.606 0 00-.669-.561c-.191.014-19.403 1.695-32.095 4.113-7.034 1.343-11.406 6.809-14.923 11.206-2.311 2.892-4.309 5.383-6.439 6.033a.621.621 0 00-.415.772.62.62 0 00.591.439l.005-.005zM88.55 244.614c.229 0 .449-.127.556-.342 1.036-2.09 5.633-3.038 10.073-3.956 1.588-.328 3.234-.67 4.743-1.065a.624.624 0 00.445-.758.628.628 0 00-.757-.444c-1.48.386-3.107.723-4.68 1.05-4.953 1.021-9.628 1.988-10.933 4.621a.619.619 0 00.552.894z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint10_linear_0_34274)",
                d: "M141.998 289.204c.876-10.84-7.202-20.338-18.041-21.214-10.84-.876-20.338 7.202-21.214 18.042-.876 10.839 7.202 20.337 18.041 21.213 10.84.876 20.338-7.201 21.214-18.041z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint11_linear_0_34274)",
                d: "M134.722 287.743c-.181 6.937-5.95 12.413-12.886 12.237-6.937-.18-12.413-5.95-12.237-12.886.181-6.937 5.95-12.413 12.886-12.237 6.937.181 12.413 5.95 12.237 12.886z",
                opacity: "0.57"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint12_linear_0_34274)",
                d: "M281.969 291.293c2.69-10.538-3.671-21.26-14.209-23.95-10.537-2.69-21.26 3.672-23.95 14.209-2.689 10.537 3.672 21.26 14.21 23.95 10.537 2.69 21.26-3.672 23.949-14.209z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint13_linear_0_34274)",
                d: "M275.238 286.527c-.181 6.937-5.95 12.413-12.886 12.237-6.937-.181-12.413-5.95-12.237-12.886.181-6.937 5.95-12.413 12.886-12.237 6.937.181 12.413 5.95 12.237 12.886z",
                opacity: "0.57"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BDD0FB",
                d: "M178.892 286.757h.063c.362 0 .645-.142.64-.499 0-.258-.161-.405-.381-.503-1.28-2.061-2.941-24.283-3.698-38.01a.638.638 0 00-.684-.596.663.663 0 00-.615.694c.005.098.542 9.624 1.309 19.174 1.563 19.442 2.525 19.74 3.366 19.74z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint14_linear_0_34274)",
                d: "M236.354 249.143h-13.385a4.298 4.298 0 00-4.299 4.298v.684a4.3 4.3 0 004.299 4.299h13.385a4.3 4.3 0 004.299-4.299v-.684a4.298 4.298 0 00-4.299-4.298z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint15_linear_0_34274)",
                d: "M334.019 215.358h4.856c.845 0 1.534.67 1.558 1.51l2.79 94.421-12.745-.351 3.541-95.575v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint16_linear_0_34274)",
                d: "M300.039 309.877l18.724-92.589a2.407 2.407 0 012.36-1.925h12.896l3.175 94.68-37.16-.161.005-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint17_linear_0_34274)",
                d: "M337.199 324.752H84.49a2.116 2.116 0 01-2.115-2.115v-10.752c0-1.216.987-2.203 2.203-2.203H337.2v15.075-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint18_linear_0_34274)",
                d: "M397.407 266.802l-11.89-43.315c-.298-1.099-1.158-1.29-2.125-1.29H339.53c-2.37 0-4.289 1.998-4.289 4.46v97.934h64.975l-2.814-57.789h.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint19_linear_0_34274)",
                d: "M401.671 304.206c-.361-.63-.952-.972-1.456-.948l-25.221 1.28a3.35 3.35 0 00-3.18 3.322l-.137 18.045 28.553 1.832c1.036 0 2.208-1.319 2.208-3.166v-17.962c0-.904-.4-1.768-.762-2.398l-.005-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint20_linear_0_34274)",
                d: "M388.125 268.751l-7.186-34.737c-.249-1.212-1.143-2.13-2.164-2.13h-28.103c-.606 0-1.182.366-1.603.899-.42.527-.649 1.279-.63 2.017l.674 27.854c.03 1.309.821 2.413 1.876 2.619l34.615 6.834c.743.146 1.495-.171 2.003-.85.508-.679.703-1.617.518-2.511v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint21_linear_0_34274)",
                d: "M388.12 231.195l-.42.049c-.713.083-1.358.484-1.783 1.104a2.892 2.892 0 00-.435 2.159l6.952 36.066c.224 1.177 2.745 1.924 4.313 2.022a.77.77 0 00.811-.713l.259-3.092c.024-.308 0-.616-.078-.909l-9.614-36.691-.005.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint22_linear_0_34274)",
                d: "M361.507 271.833h-8.91c-1.12 0-2.028.908-2.028 2.028v.366c0 1.12.908 2.027 2.028 2.027h8.91a2.027 2.027 0 002.027-2.027v-.366c0-1.12-.908-2.028-2.027-2.028z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M338.782 296.493a.49.49 0 01-.488-.489v-52.157a.49.49 0 01.488-.488.49.49 0 01.489.488v52.157a.49.49 0 01-.489.489z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint23_linear_0_34274)",
                d: "M397.66 308.51h-6.135a2.237 2.237 0 00-2.238 2.237v6.722a2.238 2.238 0 002.238 2.237h6.135a2.238 2.238 0 002.238-2.237v-6.722a2.237 2.237 0 00-2.238-2.237z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M393.411 307.445v12.964h-1.593c-1.231 0-3.419-1.314-3.419-2.545v-7.352c0-1.231 2.183-3.067 3.419-3.067h1.593z",
                opacity: "0.8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint24_linear_0_34274)",
                d: "M335.382 311.05H73.861l-.318-2.907 15.7-2.902 246.139.323v5.486z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint25_linear_0_34274)",
                d: "M363.891 348.41c11.849 0 21.455-9.606 21.455-21.455 0-11.849-9.606-21.455-21.455-21.455-11.849 0-21.455 9.606-21.455 21.455 0 11.849 9.606 21.455 21.455 21.455z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint26_linear_0_34274)",
                d: "M367.881 343.927c9.364-2.21 15.163-11.592 12.953-20.956-2.21-9.363-11.592-15.162-20.956-12.952-9.363 2.21-15.162 11.592-12.952 20.955 2.21 9.364 11.592 15.163 20.955 12.953z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M378.521 333.452a.485.485 0 01-.449-.679 14.863 14.863 0 001.172-5.813c0-8.236-6.702-14.938-14.938-14.938-2.555 0-5.075.655-7.288 1.895a.488.488 0 11-.479-.85 15.904 15.904 0 017.767-2.022c8.774 0 15.915 7.137 15.915 15.915 0 2.15-.42 4.231-1.25 6.194a.487.487 0 01-.45.298z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint27_linear_0_34274)",
                d: "M371.653 328.775a7.991 7.991 0 10-15.556-3.671 7.99 7.99 0 005.942 9.613 7.991 7.991 0 009.614-5.942z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint28_linear_0_34274)",
                d: "M180.687 332.464c2.722-11.533-4.421-23.088-15.953-25.81-11.532-2.722-23.087 4.42-25.809 15.953-2.722 11.532 4.42 23.087 15.952 25.809 11.533 2.722 23.088-4.42 25.81-15.952z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint29_linear_0_34274)",
                d: "M163.799 344.519c9.364-2.21 15.163-11.592 12.953-20.955-2.21-9.363-11.592-15.162-20.956-12.952-9.363 2.21-15.162 11.592-12.952 20.955 2.21 9.363 11.592 15.162 20.955 12.952z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M174.442 334.048a.485.485 0 01-.45-.679 14.87 14.87 0 001.173-5.813c0-8.236-6.703-14.938-14.939-14.938a14.93 14.93 0 00-7.288 1.895.488.488 0 01-.479-.85 15.907 15.907 0 017.767-2.022c8.774 0 15.916 7.137 15.916 15.915 0 2.149-.42 4.23-1.251 6.194a.487.487 0 01-.449.298z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint30_linear_0_34274)",
                d: "M167.657 329.061a7.993 7.993 0 00-15.696-3.022 7.993 7.993 0 0015.696 3.022z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint31_linear_0_34274)",
                d: "M302.033 329.638c1.167-11.792-7.447-22.297-19.238-23.463-11.792-1.167-22.296 7.447-23.463 19.238-1.166 11.792 7.447 22.296 19.238 23.463 11.792 1.166 22.297-7.447 23.463-19.238z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint32_linear_0_34274)",
                d: "M283.988 344.664c9.448-1.819 15.631-10.953 13.812-20.4-1.819-9.447-10.952-15.63-20.4-13.811-9.447 1.819-15.63 10.952-13.811 20.399 1.819 9.447 10.952 15.631 20.399 13.812z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M295.335 334.048a.484.484 0 01-.449-.679 14.888 14.888 0 001.172-5.813c0-8.236-6.702-14.938-14.938-14.938a14.93 14.93 0 00-7.289 1.895.488.488 0 11-.478-.85 15.902 15.902 0 017.767-2.022c8.773 0 15.915 7.137 15.915 15.915 0 2.149-.42 4.23-1.251 6.194a.486.486 0 01-.449.298z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint33_linear_0_34274)",
                d: "M288.548 329.064a7.992 7.992 0 00-6.337-9.359 7.99 7.99 0 00-9.358 6.336 7.992 7.992 0 0015.695 3.023z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint34_linear_0_34274)",
                d: "M131.613 332.471c2.722-11.533-4.42-23.088-15.952-25.81-11.533-2.722-23.088 4.421-25.81 15.953-2.722 11.532 4.42 23.087 15.953 25.809 11.532 2.722 23.088-4.42 25.809-15.952z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint35_linear_0_34274)",
                d: "M114.025 344.666c9.447-1.819 15.631-10.953 13.811-20.4-1.819-9.447-10.952-15.63-20.399-13.811-9.447 1.819-15.63 10.952-13.812 20.399 1.82 9.447 10.953 15.631 20.4 13.812z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M125.368 334.048a.484.484 0 01-.449-.679 14.888 14.888 0 001.172-5.813c0-8.236-6.702-14.938-14.938-14.938-2.555 0-5.076.654-7.294 1.895a.488.488 0 11-.478-.85 15.902 15.902 0 017.767-2.022c8.773 0 15.915 7.137 15.915 15.915 0 2.149-.42 4.23-1.251 6.194a.486.486 0 01-.449.298h.005z",
                opacity: "0.7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint36_linear_0_34274)",
                d: "M118.583 329.065a7.992 7.992 0 10-15.695-3.022 7.992 7.992 0 1015.695 3.022z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint37_linear_0_34274)",
                d: "M5.447 235.04c2.882-4.797 3.624-9.101 2.774-14.67-1.407-9.188-.312-19.418 5.545-26.975 5.554-7.171 15.549-7.811 21.65-14.21.044-.044.18-.254.386-.576a15.913 15.913 0 002.481-8.065c.596-18.006 13.693-17.796 19.907-14.382 9.838 5.408 7.679 15.5 7.679 15.5-2.745 2.936-12.55-3.322-12.55-3.322l-4.074 6.541a88.704 88.704 0 013.747 1.735c9.233 4.528 10.224 39.9 5.022 45.557-5.203 5.656-6.116 11.059-.87 20.316 5.247 9.257 2.213 21.348-25.7 31.376-4.518 1.627-11.328 1.798-15.793-.009C5.857 269.884.47 258.233.205 248.2c-.137-5.095 2.74-9.003 5.237-13.16h.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M12.681 223.477a.122.122 0 01-.122-.112c-1.148-12.794 2.765-21.221 6.253-26.032 4.382-6.053 9.501-8.681 11.836-9.282 5.15-1.319 7.548-7.376 7.572-7.44a.121.121 0 01.156-.068.119.119 0 01.069.156c-.025.064-2.472 6.238-7.738 7.587-2.985.767-7.923 3.966-11.7 9.188-3.458 4.783-7.347 13.151-6.203 25.871a.122.122 0 01-.113.132h-.01zM17.24 268.399s-.03 0-.045-.01c-.112-.044-11.191-4.484-10.996-16.77 0-.068.054-.122.122-.122.069 0 .122.059.122.122-.19 12.115 10.733 16.497 10.845 16.541a.118.118 0 01.068.156.12.12 0 01-.112.078l-.005.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint38_linear_0_34274)",
                d: "M84.95 223.296s-12.086 14.474-24.254 2.721l-4.704 10.903s17.771 13.761 31.254-7.889l-2.296-5.735z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint39_linear_0_34274)",
                d: "M55.102 196.429c-3.355-1.006-13.12-2.863-22.412 5.711a5.751 5.751 0 00-1.656 5.735c2.496 9.188 9.081 36.329 3.307 48.077 0 0 10.176 11.216 21.274 2.174 0 0 4.978-21.704 11.504-31.234 4.504-6.58-7.18-24.704-10.136-29.08a3.463 3.463 0 00-1.876-1.383h-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint40_linear_0_34274)",
                d: "M49.905 178.912s-6.77 13.257-7.958 19.344c0 0 5.105 3.195 10.786-.293 0 0 2.39-13.824 3.493-16.208l-6.321-2.843z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint41_linear_0_34274)",
                d: "M68.565 303.698c-.039.987 1.69 8.803 2.633 12.97a6.847 6.847 0 01-.737 4.924l-32.607 54.877a7.362 7.362 0 00-.855 2.135c-.596 2.574-1.837 8.886-1.192 14.63l1.685 3.503-7.293-1.656-1.588-19.589 2.066-1.26a9.81 9.81 0 003.967-4.646c2.95-7.161 10.268-25.392 12.159-34.277 2.144-10.098 13.355-18.299 13.355-18.299l-1.968-4.656 10.375-8.656z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint42_linear_0_34274)",
                d: "M22.09 388.339s3.937-6.247 4.401-8.675c.464-2.433 1.754-6.727 4.182-5.432 0 0 1.143 11.812.752 16.423-.396 4.616 5.217 4.465 5.217 4.465s1.549.215 2.677 1.348c.782.782.225 2.14-.88 2.208-1.836.117-4.752.151-7.815-.444a2.392 2.392 0 01-1.93-2.208l-.81-13.595-4.969 6.277-.83-.376.005.009z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint43_linear_0_34274)",
                d: "M49.09 312.437s-1.149 49.089-1.305 56.06c-.156 6.971 1.099 22.422 8.09 27.038l-3.044 2.252s-3.8-3.229-7.513-9.447c-4.172-6.986-5.432-8.261-5.432-8.261l1.382-2.833a6.202 6.202 0 00.503-3.996c-1.509-7.308-6.545-31.625-7.923-36.857-1.622-6.18-1.739-14.435 3.908-21.343 5.642-6.907 11.328-2.608 11.328-2.608l.005-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint44_linear_0_34274)",
                d: "M42.636 400a.427.427 0 01-.43-.366c-.234-1.637-1.202-8.197-1.993-9.897-.909-1.944-3.874-10.137 0-10.83 0 0 9.633 14.068 11.48 15.969 1.846 1.895 4.181.664 4.181.664s1.803.533 3.16 2.267c.646.825.045 2.037-1.005 2.046l-6.488.064a4.56 4.56 0 01-4.279-2.877c-1.143-2.853-3.102-7.035-5.388-8.891l1.187 11.372a.436.436 0 01-.425.479z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint45_linear_0_34274)",
                d: "M57.144 252.831s-1.46 4.66.782 12.334l13.932 48.65a1.505 1.505 0 01-.943 1.831c-4.167 1.495-17.864 5.726-36.564 4.436a2.122 2.122 0 01-1.934-1.651c-1.231-5.545-5.437-24.469-6.302-28.357-3.297-14.816-6.492-28.905 9.707-38.567 7.464 3.199 13.941 3.195 21.322 1.324z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint46_linear_0_34274)",
                d: "M40.34 208.783s-2.804 40.076 23.086 19.945c0 0 3.825-3.61 6.585-4.049 1.485-.235 3.166-.396 4.397-.489.561-.044.825.684.361 1.007-.889.625-2.056 1.299-3.068 1.402-1.954.2.127 1.631-1.998 5.373s-5.163 2.33-5.163 2.33-29.666 30.38-35.592-22.608c-.21-9.857 9.277-9.335 11.387-2.911h.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint47_linear_0_34274)",
                d: "M92.897 213.336l-8.807-1.163c-1.05-.176-2.135.44-2.785 1.578l-5.793 12.808c-1.09 1.915-.313 4.45 1.45 4.744l7.074.908c.68.112 1.373-.313 1.754-1.079l7.835-15.642c.455-.904.073-2.027-.728-2.159v.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint48_linear_0_34274)",
                d: "M86.889 230.609s5.92-8.617 5.236-9.682c-.688-1.06-5.881-2.579-7.097-2.941-1.222-.356-3.513 7.46 1.866 12.618l-.005.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint49_linear_0_34274)",
                d: "M65.077 171.442s1.26 22.286-8.113 22.598c-9.375.313-10.288-15.534-10.288-15.534s2.77-10.009 7.23-11.177c4.464-1.167 11.167 4.113 11.167 4.113h.004z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint50_linear_0_34274)",
                d: "M62.322 164.564s4.284 4.382 3.547 7.108c-.738 2.726-9.926-.127-12.188-1.412l-7.591 8.08s.234-11.968 5.47-15.651c5.237-3.684 10.762 1.88 10.762 1.88v-.005z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "url(#paint51_linear_0_34274)",
                d: "M49.519 178.721s-1.143-7.645-4.88-5.495c-3.737 2.149.273 8.074 3.195 7.703l1.685-2.208z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_34274",
                        x1: "14.171",
                        x2: "32.334",
                        y1: "78.555",
                        y2: "78.555",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_34274",
                        x1: "124.2",
                        x2: "122.735",
                        y1: "43.906",
                        y2: "93.733",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_34274",
                        x1: "66.103",
                        x2: "82.255",
                        y1: "268.987",
                        y2: "272.718",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#2B3582"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#150E42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_34274",
                        x1: "205.667",
                        x2: "214.787",
                        y1: "214.801",
                        y2: "167.906",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_34274",
                        x1: "131.986",
                        x2: "117.009",
                        y1: "209.628",
                        y2: "233.403",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_34274",
                        x1: "294.646",
                        x2: "294.646",
                        y1: "193.649",
                        y2: "236.315",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_34274",
                        x1: "167.289",
                        x2: "127.688",
                        y1: "174.615",
                        y2: "276.036",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_34274",
                        x1: "223.828",
                        x2: "184.219",
                        y1: "196.323",
                        y2: "297.77",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_34274",
                        x1: "369.183",
                        x2: "396.71",
                        y1: "-294.708",
                        y2: "-376.114",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_34274",
                        x1: "331.293",
                        x2: "370.011",
                        y1: "207.757",
                        y2: "145.806",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_34274",
                        x1: "114.863",
                        x2: "167.219",
                        y1: "293.624",
                        y2: "253.216",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_34274",
                        x1: "109.671",
                        x2: "134.79",
                        y1: "287.02",
                        y2: "287.669",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_34274",
                        x1: "255.355",
                        x2: "307.718",
                        y1: "292.215",
                        y2: "251.817",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_34274",
                        x1: "250.182",
                        x2: "275.302",
                        y1: "285.808",
                        y2: "286.457",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_34274",
                        x1: "275.35",
                        x2: "258.741",
                        y1: "213.473",
                        y2: "228.127",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_34274",
                        x1: "393.215",
                        x2: "316.771",
                        y1: "234.967",
                        y2: "274.676",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_34274",
                        x1: "303.727",
                        x2: "306.658",
                        y1: "29.788",
                        y2: "81.075",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_34274",
                        x1: "209.233",
                        x2: "211.172",
                        y1: "346.139",
                        y2: "248.371",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_34274",
                        x1: "381.965",
                        x2: "309.37",
                        y1: "253.3",
                        y2: "363.641",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_34274",
                        x1: "387.69",
                        x2: "384.789",
                        y1: "295.642",
                        y2: "400.904",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_34274",
                        x1: "360.085",
                        x2: "414.865",
                        y1: "251.453",
                        y2: "252.831",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_34274",
                        x1: "388.51",
                        x2: "409.011",
                        y1: "251.844",
                        y2: "253.556",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_34274",
                        x1: "379.342",
                        x2: "344.331",
                        y1: "262.537",
                        y2: "280.607",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_34274",
                        x1: "387.338",
                        x2: "394.114",
                        y1: "331.449",
                        y2: "315.256",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_34274",
                        x1: "189.004",
                        x2: "191.935",
                        y1: "36.339",
                        y2: "87.631",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_34274",
                        x1: "342.436",
                        x2: "385.341",
                        y1: "326.955",
                        y2: "326.955",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_34274",
                        x1: "359.619",
                        x2: "366.878",
                        y1: "277.401",
                        y2: "361.608",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_34274",
                        x1: "371.737",
                        x2: "349.931",
                        y1: "314.175",
                        y2: "349.904",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_34274",
                        x1: "138.337",
                        x2: "181.241",
                        y1: "327.663",
                        y2: "327.663",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_34274",
                        x1: "156.993",
                        x2: "164.252",
                        y1: "294.862",
                        y2: "379.073",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_34274",
                        x1: "167.679",
                        x2: "145.867",
                        y1: "314.682",
                        y2: "350.411",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_34274",
                        x1: "259.202",
                        x2: "302.107",
                        y1: "327.783",
                        y2: "327.783",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_34274",
                        x1: "276.989",
                        x2: "284.248",
                        y1: "284.517",
                        y2: "368.724",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_34274",
                        x1: "288.567",
                        x2: "266.761",
                        y1: "314.687",
                        y2: "350.415",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_34274",
                        x1: "89.263",
                        x2: "132.168",
                        y1: "327.664",
                        y2: "327.664",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_34274",
                        x1: "108.28",
                        x2: "115.539",
                        y1: "299.064",
                        y2: "383.276",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_34274",
                        x1: "118.607",
                        x2: "96.796",
                        y1: "314.685",
                        y2: "350.413",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_34274",
                        x1: "75.116",
                        x2: "56.265",
                        y1: "125.504",
                        y2: "172.449",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_34274",
                        x1: "78.331",
                        x2: "67.574",
                        y1: "208.143",
                        y2: "247.941",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_34274",
                        x1: "144.986",
                        x2: "125.207",
                        y1: "103.092",
                        y2: "128.005",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_34274",
                        x1: "53.901",
                        x2: "48.381",
                        y1: "207.143",
                        y2: "188.702",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint41_linear_0_34274",
                        x1: "106.224",
                        x2: "85.218",
                        y1: "420.766",
                        y2: "394.387",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint42_linear_0_34274",
                        x1: "21.952",
                        x2: "39.459",
                        y1: "386.617",
                        y2: "386.452",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint43_linear_0_34274",
                        x1: "40.291",
                        x2: "91.798",
                        y1: "337.443",
                        y2: "445.767",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint44_linear_0_34274",
                        x1: "38.214",
                        x2: "59.087",
                        y1: "389.625",
                        y2: "389.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint45_linear_0_34274",
                        x1: "79.576",
                        x2: "36.246",
                        y1: "245.064",
                        y2: "305.559",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint46_linear_0_34274",
                        x1: "57.657",
                        x2: "103.713",
                        y1: "223.536",
                        y2: "223.536",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint47_linear_0_34274",
                        x1: "80.896",
                        x2: "89.248",
                        y1: "214.646",
                        y2: "224.24",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint48_linear_0_34274",
                        x1: "90.215",
                        x2: "84.544",
                        y1: "212.354",
                        y2: "233.325",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint49_linear_0_34274",
                        x1: "63.977",
                        x2: "31.856",
                        y1: "175.416",
                        y2: "196.193",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint50_linear_0_34274",
                        x1: "74.921",
                        x2: "56.021",
                        y1: "124.996",
                        y2: "172.058",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint51_linear_0_34274",
                        x1: "59.462",
                        x2: "27.342",
                        y1: "168.435",
                        y2: "189.212",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/sharedButton/index.tsx
var sharedButton = __webpack_require__(90652);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsCarWarrantyCategoryPage/index.tsx




function WhatIsCarWarrantyCategoryPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:mt-28 mt-14 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 order-1 lg:order-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "What Is a Car Warranty?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 lg:text-lg text-base lg:leading-8 font-light",
                        children: "A car warranty is a contract between you and your vehicle's automaker (or the provider of the coverage in the case of an extended warranty). In simple terms, it says that they will pay for repairs when a defective part or failure of workmanship causes your vehicle or one of its components to fail."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " lg:text-lg text-base lg:leading-8 font-light",
                        children: "A new car warranty can fill dozens of pages - or more - with what's covered, what's not, legalese, exceptions and stipulations. Most new car warranties are similar in their broad coverage but may have minor differences. Extended warranties can vary significantly regarding what's covered, who pays, where you can get your car serviced and how much of a deductible you're responsible for."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mt-[50px] mt-7 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[250px] h-[250px] md:h-[400px] md:w-[402px] md:min-w-[402px] relative mx-auto lg:mt-16 order-2 lg:order-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 63868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhatIsHomeWarrantyCategoryPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsHomeWarrantyCategoryPage/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 380 399",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_6405)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_6405)",
                        d: "M43.787 324.958c7.758 8.121 15.098 13.357 20.893 17.495 68.166 48.629 148.82 34.455 165.959 30.992 25.314-5.112 74.24-14.991 109.618-56.359 53.521-62.582 51.233-165.531 3.673-226.258-6.703-8.556-47.061-75.552-129.228-88.573-49.142-7.79-106.849 6.522-148.5 41.216-87.421 72.829-81.2 219.952-22.42 281.487h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        opacity: "0.92",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#7D97F4",
                                d: "M282.596 1.373c-.674-1.887-3.434-1.612-3.718.372-2.728 19.203-11.463 69.325-31.329 97.952-32.352 46.609-48.597 117.467-19.707 149.199 0 0 128.422-41.781 54.754-247.523z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                d: "M281.895 28.352c.009.482-.019 1.038-.032 1.566l-.074 1.603-.178 3.206a529.875 529.875 0 01-.431 6.407 594.847 594.847 0 01-1.11 12.795 659.225 659.225 0 01-2.944 25.514c-2.32 16.961-5.167 33.854-8.872 50.562-1.884 8.346-3.846 16.677-6.139 24.917-2.297 8.239-4.777 16.428-7.593 24.503a82.303 82.303 0 01-1.063 3.026l-1.096 3.013-1.096 3.013c-.38 1.001-.784 1.989-1.174 2.985-.797 1.985-1.549 3.987-2.388 5.953l-2.541 5.888c-3.484 7.808-7.345 15.446-11.632 22.854a.233.233 0 00.083.317.23.23 0 00.312-.078c4.493-7.308 8.468-14.927 12.104-22.698l2.618-5.879c.862-1.966 1.637-3.964 2.462-5.948.404-.996.821-1.984 1.211-2.981l1.132-3.012 1.137-3.013a87.23 87.23 0 001.101-3.023c5.708-16.189 10.256-32.77 13.924-49.533l1.344-6.293 1.247-6.31c.431-2.099.788-4.217 1.183-6.325l.577-3.164.537-3.174a547.811 547.811 0 003.773-25.449c1.059-8.51 1.986-17.035 2.692-25.582.348-4.271.655-8.552.912-12.828.119-2.14.239-4.28.33-6.425l.115-3.215.037-1.608c0-.542.022-1.06-.005-1.644a.23.23 0 00-.238-.216.224.224 0 00-.216.23v.05l-.009-.004z",
                                opacity: "0.43"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M345.771 23.408c-.376-2.324-3.622-2.6-4.37-.368-7.249 21.573-28.028 77.537-57.069 106.311-47.285 46.852-81.159 125.128-54.603 167.938 0 0 157.105-20.691 116.042-273.886v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M339.237 54.386c-.092.57-.238 1.2-.367 1.81l-.421 1.837-.881 3.665c-.6 2.44-1.224 4.873-1.857 7.303-1.279 4.86-2.618 9.7-4.002 14.532a791.795 791.795 0 01-8.826 28.82c-6.287 19.083-13.182 37.969-21.018 56.46-3.952 9.227-8.006 18.422-12.412 27.442a122.852 122.852 0 01-1.659 3.381l-1.692 3.362-1.692 3.362c-.573 1.116-1.169 2.218-1.756 3.329-1.183 2.214-2.334 4.446-3.544 6.642l-3.673 6.572c-.307.547-.605 1.098-.922 1.64l-.958 1.621-1.912 3.243-1.912 3.242c-.651 1.07-1.329 2.127-1.994 3.192l-2.004 3.188c-.678 1.056-1.316 2.14-2.026 3.169l-4.196 6.246c-5.703 8.258-11.797 16.24-18.34 23.855a.233.233 0 00.023.326.23.23 0 00.321-.018c6.726-7.482 12.934-15.423 18.776-23.616l4.268-6.228c.729-1.029 1.376-2.108 2.064-3.16l2.04-3.179c.674-1.06 1.366-2.112 2.031-3.182l1.949-3.234 1.948-3.233.977-1.617c.321-.542.623-1.093.94-1.639 10.032-17.458 18.812-35.618 26.63-54.164l2.893-6.972 2.787-7.013c.945-2.333 1.811-4.694 2.715-7.041l1.343-3.527 1.298-3.546c3.475-9.443 6.762-18.959 9.798-28.549 3.044-9.59 5.942-19.226 8.587-28.935a693.304 693.304 0 003.801-14.606 497.932 497.932 0 001.756-7.339l.83-3.683.395-1.847c.119-.624.256-1.217.348-1.892a.228.228 0 00-.192-.257.23.23 0 00-.257.188l-.009.05h.004z",
                        opacity: "0.43"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M46.996 0h152.346c7.597 0 13.755 6.169 13.755 13.779v336.197c0 7.61-6.158 13.778-13.755 13.778H46.996c-7.596 0-13.755-6.168-13.755-13.778V13.779C33.241 6.169 39.4 0 46.996 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M63.988 0h152.346c7.597 0 13.755 6.169 13.755 13.779v336.197c0 7.61-6.158 13.778-13.755 13.778H63.988c-7.596 0-13.755-6.168-13.755-13.778V13.779C50.233 6.169 56.392 0 63.988 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M67.537 3.6h143.996c6.584 0 11.921 5.347 11.921 11.942v181.404c0 6.596-5.337 11.942-11.921 11.942H67.537c-6.584 0-11.921-5.346-11.921-11.942V15.542c0-6.595 5.337-11.941 11.921-11.941zM67.954 211.138h143.997c6.583 0 11.921 5.347 11.921 11.942v125.132c0 6.595-5.338 11.942-11.921 11.942H67.954c-6.583 0-11.92-5.347-11.92-11.942V223.08c0-6.595 5.337-11.942 11.92-11.942z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M208.517 158.467a5.396 5.396 0 01-5.392-5.401V66.628a5.396 5.396 0 015.392-5.4c2.98 0 5.392 2.42 5.392 5.4v86.438a5.397 5.397 0 01-5.392 5.401zM209.415 288.124a5.397 5.397 0 01-5.392-5.402v-52.67a5.397 5.397 0 015.392-5.402 5.397 5.397 0 015.392 5.402v52.67a5.397 5.397 0 01-5.392 5.402z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_0_6405)",
                        d: "M333.987 273.271H199.881c-5.452 0-9.876 4.432-9.876 9.893v87.347h154.432v-86.778c0-5.777-4.682-10.467-10.45-10.467v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_0_6405)",
                        d: "M232.017 284.969h103.891a3.98 3.98 0 013.976 3.982v70.027c0 2.2-1.78 3.982-3.976 3.982H232.017a3.978 3.978 0 01-3.975-3.982v-70.027a3.979 3.979 0 013.975-3.982z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_0_6405)",
                        d: "M222.838 273.271h-20.816c-6.635 0-12.022 5.397-12.022 12.042v85.198h32.838v-97.24z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_0_6405)",
                        d: "M230.476 351.239a2.446 2.446 0 002.44-2.443V302.55a2.447 2.447 0 00-2.44-2.443 2.45 2.45 0 00-2.439 2.443v46.246a2.449 2.449 0 002.439 2.443z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_0_6405)",
                        d: "M198.748 282.521h17.62a4.2 4.2 0 014.196 4.202v6.251a4.2 4.2 0 01-4.196 4.203h-17.62a4.2 4.2 0 01-4.195-4.203v-6.251a4.199 4.199 0 014.195-4.202z",
                        opacity: "0.43"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint6_linear_0_6405)",
                        d: "M207.703 366.359c-5.353 0-9.693-4.347-9.693-9.709 0-5.363 4.34-9.71 9.693-9.71s9.692 4.347 9.692 9.71c0 5.362-4.339 9.709-9.692 9.709z",
                        opacity: "0.47"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint7_linear_0_6405)",
                        d: "M207.556 364.379c-4.262 0-7.717-3.46-7.717-7.729s3.455-7.73 7.717-7.73 7.717 3.461 7.717 7.73-3.455 7.729-7.717 7.729z",
                        opacity: "0.43"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        opacity: "0.43",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint8_linear_0_6405)",
                                d: "M209.55 307.8a2.87 2.87 0 002.866 2.871 2.87 2.87 0 002.866-2.871 2.87 2.87 0 00-2.866-2.871 2.87 2.87 0 00-2.866 2.871z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint9_linear_0_6405)",
                                d: "M200.628 307.8a2.87 2.87 0 002.866 2.871 2.869 2.869 0 002.865-2.871 2.869 2.869 0 00-2.865-2.871 2.87 2.87 0 00-2.866 2.871z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint10_linear_0_6405)",
                                d: "M209.55 317.734a2.87 2.87 0 002.866 2.871 2.87 2.87 0 002.866-2.871 2.87 2.87 0 00-2.866-2.87 2.87 2.87 0 00-2.866 2.87z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint11_linear_0_6405)",
                                d: "M200.628 317.734a2.87 2.87 0 002.866 2.871 2.869 2.869 0 002.865-2.871 2.868 2.868 0 00-2.865-2.87 2.87 2.87 0 00-2.866 2.87z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint12_linear_0_6405)",
                                d: "M209.39 328.316a2.87 2.87 0 002.866 2.871 2.87 2.87 0 002.865-2.871 2.869 2.869 0 00-2.865-2.87 2.87 2.87 0 00-2.866 2.87z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint13_linear_0_6405)",
                                d: "M200.468 328.316a2.869 2.869 0 002.865 2.871 2.87 2.87 0 002.866-2.871 2.87 2.87 0 00-2.866-2.87 2.868 2.868 0 00-2.865 2.87z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint14_linear_0_6405)",
                                d: "M208.909 338.577a2.868 2.868 0 002.865 2.87 2.87 2.87 0 002.866-2.87 2.87 2.87 0 00-2.866-2.871 2.869 2.869 0 00-2.865 2.871z"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "url(#paint15_linear_0_6405)",
                                d: "M199.986 338.577a2.87 2.87 0 002.866 2.87 2.868 2.868 0 002.865-2.87 2.869 2.869 0 00-2.865-2.871 2.87 2.87 0 00-2.866 2.871z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "mask0_0_6405",
                        style: {
                            maskType: "luminance"
                        },
                        width: "112",
                        height: "79",
                        x: "228",
                        y: "284",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M228.042 284.969h111.842v77.991H228.042v-77.991z"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fill: "#fff",
                        mask: "url(#mask0_0_6405)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M282.046 245.521l4.435-2.565 73.27 127.126-4.435 2.565-73.27-127.126z",
                                opacity: "0.06"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M230.477 263.392l4.436-2.565 73.27 127.126-4.435 2.565-73.271-127.126z",
                                opacity: "0.11"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M256.578 261.68l12.107-7.002 73.271 127.126-12.107 7.002-73.271-127.126z",
                                opacity: "0.14"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint16_linear_0_6405)",
                        d: "M25.768 222.487c-1.674-4.45-2.394-9.746-1.293-15.923-6.75-1.176-13.045-3.587-18.574-7.427-.656 9.503 1.861 19.998 10.596 30.405 4.24 5.052 9.945 10.086 17.464 14.973l2.215 4.735 6.652-8.299S30.5 235.09 25.763 222.483l.005.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint17_linear_0_6405)",
                        d: "M119.37 181.133c-6.822 1.199-12.792.303-18.065-1.658a32.185 32.185 0 01-.609 3.541c-1.151 5.195-2.742 10.228-4.966 14.867 10.22 1.516 19.45-1.456 26.332-5.001.096-4.809-1.215-8.805-2.687-11.749h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint18_linear_0_6405)",
                        d: "M101.305 179.475c-8.862-3.293-15.758-9.594-21.425-14.063-11.935-9.411-20.995-4.552-20.995-4.552l13.003 24.636c8.125 7.666 16.254 11.262 23.842 12.383 2.224-4.639 3.815-9.673 4.966-14.867.275-1.19.472-2.366.609-3.542v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint19_linear_0_6405)",
                        d: "M144.923 169.274l-6.016 3.518c-7.203 4.754-13.682 7.317-19.537 8.341 1.472 2.944 2.783 6.94 2.687 11.748 7.634-3.931 12.375-8.565 12.375-8.565 13.613-8.8 10.486-15.042 10.486-15.042h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint20_linear_0_6405)",
                        d: "M76.744 339.715l49.087-206.467 21.008 4.06-31.137 209.935c-.068.469-.151.937-.238 1.401l-1.353 7.022c-2.32 12.052-10.779 20.549-18.89 18.983l-9.642-1.865c-8.11-1.566-12.806-12.607-10.481-24.659l1.352-7.023c.092-.463.188-.927.298-1.387h-.004zm16.153 21.036c5.382 1.042 11.159-5.47 12.911-14.546 1.747-9.071-1.197-17.274-6.58-18.312-5.382-1.038-11.16 5.47-12.91 14.546-1.748 9.071 1.196 17.274 6.579 18.312z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint21_linear_0_6405)",
                        d: "M128.948 60.052l-7.849 40.747a9.531 9.531 0 002.21 8.111l10.013 11.349a9.505 9.505 0 0011.394 2.205l13.512-6.802a9.52 9.52 0 005.067-6.706l7.849-40.748c1.183-6.145 9.097-8.129 12.911-3.169 9.134 11.86 13.324 27.714 10.202 43.927-5.644 29.307-32.342 45.055-60.481 39.613-28.138-5.438-47.065-30.01-41.42-59.312 3.122-16.213 12.906-29.372 25.786-36.973 5.382-3.178 11.989 1.612 10.806 7.758z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint22_linear_0_6405)",
                        d: "M132.781 60.791l-7.849 40.748a9.532 9.532 0 002.21 8.111l10.014 11.349a9.502 9.502 0 0011.393 2.204l13.512-6.802a9.521 9.521 0 005.067-6.705l7.849-40.748c1.183-6.145 9.097-8.13 12.912-3.174 9.133 11.86 13.324 27.714 10.201 43.926-5.644 29.307-32.342 45.056-60.481 39.614-28.138-5.438-47.065-30.01-41.42-59.312 3.122-16.213 12.906-29.372 25.786-36.973 5.382-3.178 11.989 1.612 10.806 7.757v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint23_linear_0_6405)",
                        d: "M79.802 340.308l49.087-206.468 21.008 4.06-31.136 209.935c-.069.469-.152.937-.239 1.401l-1.352 7.023c-2.32 12.051-10.78 20.548-18.89 18.982l-9.643-1.865c-8.11-1.566-12.806-12.607-10.481-24.659l1.352-7.022c.092-.464.188-.928.298-1.387h-.004zm16.153 21.035c5.383 1.043 11.16-5.47 12.911-14.546 1.747-9.075-1.197-17.273-6.579-18.311-5.383-1.043-11.16 5.47-12.912 14.545-1.747 9.071 1.197 17.274 6.58 18.312z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint24_linear_0_6405)",
                        d: "M145.707 178.364a4.464 4.464 0 00-1.032-3.666c-1.687-1.956-4.608-4.638-6.726-2.833-3.155 2.691.302 11.9.302 11.9l3.494 5.346.051 3.412c1.889-2.218 3.021-7.674 3.911-14.164v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M65.12 376.807c0-.147-.013-.294-.054-.441-2.37-8.712-13.416-13.962-13.416-13.962l-4.328.423c-2.348 7.766-1.94 12.492-1.5 14.591.014.06.033.115.046.17 3.586.253 10.95.322 19.248-.785l.005.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M45.868 377.593c.207.702.734 1.24 1.403 1.364 5.108.973 13.182-.042 16.57-.552.748-.11 1.284-.817 1.28-1.598-8.3 1.107-15.667 1.034-19.248.786h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint25_linear_0_6405)",
                        d: "M45.456 356.387l2.003 8.823c.147.648.656 1.126 1.257 1.167.738.055 1.792.078 2.842-.101.945-.156 1.587-1.135 1.399-2.168l-1.426-7.84-6.08.115.005.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M83.905 376.784c-4.79-.046-7.28-.56-8.569-1.061.005.478.018.965.041 1.466.028.537.431.959.922.946l26.295-.666c.839-.023 1.311-1.006.931-1.769-3.444.349-12.215 1.158-19.62 1.089v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M103.525 375.696c-.032-.065-.06-.134-.11-.198-2.385-3.206-8.423-9.567-20.16-12.153l-5.613-.073s-2.416 4.395-2.31 12.447c1.288.5 3.778 1.019 8.569 1.061 7.41.068 16.176-.74 19.619-1.089l.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint26_linear_0_6405)",
                        d: "M76.446 354.78c.068.418.958 6.765 1.302 9.227.082.583.513 1.029 1.05 1.084.958.096 2.503.17 3.851-.133.725-.166 1.243-.878 1.224-1.69l-.188-9.99-7.24 1.497v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint27_linear_0_6405)",
                        d: "M69.247 235.219s15.585 64.814 16.566 129.606c.018 1.18-9 2.223-9.207 1.134-2.104-11.106-15.992-83.425-22.384-93.497 0 0 .142 63.74 1.995 92.712.046.721-8.134 3.081-9.844 1.24 0 0-11.527-70.542-12-114.813-.022-2.278 4.086-16.387 4.086-16.387h30.793l-.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint28_linear_0_6405)",
                        d: "M80.778 166.271c.253 2.517-.962-1.236 0 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint29_linear_0_6405)",
                        d: "M80.778 166.271c-.023-.235-.06-.519-.11-.873-17.051-11.84-42.264-5.208-52.04-3.785a13.105 13.105 0 00-8.183 4.602c-4.98 5.999-13.53 18.285-14.54 32.927 5.525 3.839 11.82 6.251 18.574 7.426.564-3.16 1.6-6.549 3.237-10.173.188.841.418 1.667.688 2.48 7.345 21.862 11.178 34.346 11.238 38.562.009.574 33.645-.822 27.689-.997-2.49-.073 11.595-49.846 18.954-58.678.436-.524-6.465-12.727-5.502-11.491h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint30_linear_0_6405)",
                        d: "M44.057 143.637l-1.416 18.022s10.16 2.857 17.409-2.475l-5.475-16.254-10.518.702v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint31_linear_0_6405)",
                        d: "M55.396 122.914c.248.225 10.637 19.745 10.637 19.745l-11.252 5.704-12.59-17.035s9.065-12.175 13.205-8.414z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint32_linear_0_6405)",
                        d: "M51.613 127.089c-2.521.372-3.86 3.165-4.392 4.62a1.818 1.818 0 00.165 1.59l5.841 9.351c.087.142.193.271.317.381.687.615 3.026 2.402 4.763-.124 1.481-2.15 2.87-4.106 4.384-4.933a1.805 1.805 0 012.457.758c.968 1.837 2.847 5.576 4.049 9.135a1.809 1.809 0 01-1.009 2.237c-2.283.978-6.795 2.751-10.816 3.385a1.82 1.82 0 01-1.728-.698c-1.78-2.347-6.795-8.91-8.497-10.546-1.581-1.52-4.429-.881-5.712-.486a1.823 1.823 0 01-1.45-.161c-1.324-.763-3.644-2.687-1.618-6.053.505-.836.22-1.934-.605-2.458-1.481-.937-3.1-2.709-1.642-5.667 1.84-3.73 7.048-3.381 9.973-6.127 1.44-1.355 2.856-2.861 4.727-3.5.404-.138.82-.23 1.247-.22 1.839.036 4.626 3.072 4.75 4.909.179 2.618-3.012 4.281-5.208 4.602l.004.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint33_linear_0_6405)",
                        d: "M49.348 145.69s-2.297-6.343-5.084-6.058c-2.784.285-4.93 3.114-1.413 6.173 4.374 3.812 6.497-.119 6.497-.119v.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint34_linear_0_6405)",
                        d: "M26.758 194.765c-3.865-10.008-2.76-22.202-2.75-22.326l1.012.096c-.009.12-1.09 12.079 2.687 21.858l-.954.367.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint35_linear_0_6405)",
                        d: "M53.7 271.162a.514.514 0 01-.5-.372c-1.202-4.313-9.693-8.915-9.776-8.961a.508.508 0 01-.206-.693.507.507 0 01.692-.207c.367.198 8.955 4.855 10.276 9.586a.508.508 0 01-.482.647H53.7z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint36_linear_0_6405)",
                        d: "M29.495 202.761l12.55-18.941a.482.482 0 01.403-.216h22.975c.376 0 .725.197.917.524l10.922 18.513c.188.322.257.699.188 1.066-4.324 13.149-8.505 26.087-8.203 32.384-7.831 6.127-21.609 4.85-31.013 2.03-.486-8.216-4.52-21.145-8.9-34.538-.054-.285 0-.579.161-.822z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint37_linear_0_6405)",
                        d: "M33.755 160.943l8.436 24.278h5.076l-7.501-25.284a.502.502 0 00-.578-.349l-5.282 1.093a.194.194 0 00-.147.257l-.004.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint38_linear_0_6405)",
                        d: "M62.645 159.234l-2.073 25.316 4.686.574 3.99-25.242a.316.316 0 00-.285-.367l-5.997-.552a.294.294 0 00-.317.267l-.004.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint39_linear_0_6405)",
                        d: "M61.824 124.163c-10.014-18.95-35.974-1.736-23.892 14.229 8.982-5.984 19.133-14.876 23.892-14.229z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint40_linear_0_6405)",
                        d: "M61.168 122.119c20.248-1.033 3.581 6.486-14.86 10.5 4.59-4.882 9.18-8.52 14.86-10.5z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_6405",
                        x1: "-47.689",
                        x2: "288.093",
                        y1: "489.86",
                        y2: "73.556",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#DAE3FE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9EFFD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_6405",
                        x1: "314.822",
                        x2: "41.863",
                        y1: "346.274",
                        y2: "217.888",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_6405",
                        x1: "239.912",
                        x2: "334.236",
                        y1: "239.918",
                        y2: "419.269",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_6405",
                        x1: "271.641",
                        x2: "170.349",
                        y1: "203.235",
                        y2: "393.883",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_6405",
                        x1: "263.232",
                        x2: "217.507",
                        y1: "263.814",
                        y2: "349.879",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_6405",
                        x1: "184.847",
                        x2: "272.348",
                        y1: "314.437",
                        y2: "220.019",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_6405",
                        x1: "147.68",
                        x2: "230.529",
                        y1: "426.222",
                        y2: "330.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_6405",
                        x1: "162.637",
                        x2: "228.607",
                        y1: "408.719",
                        y2: "332.511",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_6405",
                        x1: "228.376",
                        x2: "184.673",
                        y1: "268.605",
                        y2: "375.575",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_6405",
                        x1: "220.724",
                        x2: "177.02",
                        y1: "265.477",
                        y2: "372.447",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_6405",
                        x1: "231.843",
                        x2: "188.139",
                        y1: "270.019",
                        y2: "376.994",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_6405",
                        x1: "224.195",
                        x2: "180.486",
                        y1: "266.896",
                        y2: "373.866",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_6405",
                        x1: "235.401",
                        x2: "191.697",
                        y1: "271.471",
                        y2: "378.446",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_6405",
                        x1: "227.748",
                        x2: "184.044",
                        y1: "268.347",
                        y2: "375.318",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_6405",
                        x1: "238.569",
                        x2: "194.865",
                        y1: "272.77",
                        y2: "379.741",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_6405",
                        x1: "230.921",
                        x2: "187.213",
                        y1: "269.643",
                        y2: "376.613",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_6405",
                        x1: "32.077",
                        x2: "21.877",
                        y1: "144.409",
                        y2: "244.144",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_6405",
                        x1: "110.072",
                        x2: "99.008",
                        y1: "183.82",
                        y2: "291.996",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_6405",
                        x1: "1367.59",
                        x2: "1327.14",
                        y1: "-1818.13",
                        y2: "-1755.73",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_6405",
                        x1: "163.512",
                        x2: "79.462",
                        y1: "135.694",
                        y2: "247.324",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_6405",
                        x1: "1773.06",
                        x2: "1741.82",
                        y1: "-1895.78",
                        y2: "-1855.42",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_6405",
                        x1: "1716.03",
                        x2: "1684.78",
                        y1: "-1939.94",
                        y2: "-1899.58",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_6405",
                        x1: "133.506",
                        x2: "-62.307",
                        y1: "132.458",
                        y2: "599.846",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_6405",
                        x1: "185.766",
                        x2: "415.019",
                        y1: "249.796",
                        y2: "234.234",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_6405",
                        x1: "103.58",
                        x2: "-10.674",
                        y1: "161.076",
                        y2: "97.861",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_6405",
                        x1: "50.377",
                        x2: "47.241",
                        y1: "347.674",
                        y2: "380.439",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_6405",
                        x1: "80.905",
                        x2: "77.769",
                        y1: "350.598",
                        y2: "383.358",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_6405",
                        x1: "107.602",
                        x2: "36.778",
                        y1: "135.877",
                        y2: "390.172",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_6405",
                        x1: "80.65",
                        x2: "80.406",
                        y1: "166.124",
                        y2: "168.503",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_6405",
                        x1: "1354.07",
                        x2: "1313.62",
                        y1: "-1826.88",
                        y2: "-1764.48",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_6405",
                        x1: "54.709",
                        x2: "41.55",
                        y1: "138.525",
                        y2: "200.594",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_6405",
                        x1: "48.624",
                        x2: "59.632",
                        y1: "145.851",
                        y2: "128.144",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_6405",
                        x1: "57.023",
                        x2: "50.642",
                        y1: "76.274",
                        y2: "163.05",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_6405",
                        x1: "46.682",
                        x2: "44.876",
                        y1: "171.968",
                        y2: "142.861",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_6405",
                        x1: "27.707",
                        x2: "23.851",
                        y1: "183.604",
                        y2: "183.604",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_6405",
                        x1: "148.788",
                        x2: "58.543",
                        y1: "138.479",
                        y2: "253.054",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_6405",
                        x1: "71.847",
                        x2: "-3.759",
                        y1: "143.899",
                        y2: "396.807",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_6405",
                        x1: "51.04",
                        x2: "-24.57",
                        y1: "137.676",
                        y2: "390.584",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_6405",
                        x1: "72.333",
                        x2: "-3.277",
                        y1: "144.041",
                        y2: "396.95",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_6405",
                        x1: "31.682",
                        x2: "109.485",
                        y1: "110.66",
                        y2: "196.598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_6405",
                        x1: "70.598",
                        x2: "45.633",
                        y1: "124.458",
                        y2: "128.762",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_6405",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H380V399H0z",
                            transform: "matrix(-1 0 0 1 380 0)"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whatIsHomeWarrantyCategoryPage/index.tsx



function WhatIsHomeWarrantyCategoryPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:pt-16 pt-8 lg:px-12 px-6 lg:mt-52 mt-20 bg-[#F1F6FF]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "What Is a Home Warranty For?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-base lg:leading-8 font-light",
                        children: "A home warranty is a service contract that provides coverage for repairing or replacing major home systems and appliances. It is designed to protect homeowners from unexpected expenses that arise due to the breakdown of essential household items. With a home warranty, homeowners can be at ease knowing that if a covered item malfunctions or stops working, they can contact their warranty provider to arrange for repairs or replacements. This can save homeowners from incurring high repair or replacement costs, providing financial protection and added convenience for their homes."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[250px] md:h-[399px] md:w-[380px] md:min-w-[380px] relative mx-auto lg:mx-0 lg:bottom-24 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 66709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WhoIsHomeWarranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whoIsHomeWarranty/mainImg.tsx


function MainImg() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 437 434",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_53)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M174.953 309.406S133.898 127.383 43.097 27.867c-6.104-6.688-17.594-4.155-20.232 4.49C5.198 90.18-30.036 265.62 174.953 309.406z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M156.349 297.621c.45.434-.173 1.12-.686.748-18.818-13.721-91.287-81.073-115.796-214.93-.078-.429.581-.591.702-.173 8.632 31.039 44.185 145.496 115.78 214.355z",
                        opacity: "0.24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M176.298 223.439S160.039 84.685 98.977 3.553C94.873-1.9 85.89-.9 83.157 5.338c-18.279 41.704-59.706 169.668 93.136 218.101h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M163.075 213.224c.309.361-.225.822-.581.502-13.228-11.67-62.962-67.435-70.584-169.034-.026-.325.492-.398.55-.073 4.02 23.785 21.671 111.788 70.621 168.6l-.006.005z",
                        opacity: "0.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M420.38 165.528H330.7v221.059h89.68V165.528z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_0_53)",
                        d: "M432.388 180.469H326.423l-19.394-77.918h102.667l26.864 71.382c1.414 3.051-.811 6.536-4.172 6.536z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_0_53)",
                        d: "M409.701 103.624l-115.618.466-3.203-9.603 111.723.601c3.916 0 7.093 2.319 7.093 5.176v3.36h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        opacity: "0.89",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                d: "M400.845 231.331H350.77a.586.586 0 00-.586.586v77.814c0 .324.262.586.586.586h50.075a.586.586 0 00.586-.586v-77.814a.587.587 0 00-.586-.586z",
                                opacity: "0.71"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#91B3FA",
                                d: "M373.493 235.602h-19.248a.324.324 0 00-.324.324v69.796c0 .179.145.325.324.325h19.248c.18 0 .325-.146.325-.325v-69.796a.324.324 0 00-.325-.324zM397.369 235.602h-19.248a.325.325 0 00-.325.324v69.796c0 .179.146.325.325.325h19.248a.325.325 0 00.324-.325v-69.796a.324.324 0 00-.324-.324z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M106.295 386.587h-84.35a5.33 5.33 0 01-5.33-5.328V165.528h89.68v221.059z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_0_53)",
                        d: "M4.607 180.469h105.965l37.826-82.79-121.104 4.872-26.86 71.387c-1.413 3.051.812 6.536 4.173 6.536v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_0_53)",
                        d: "M27.294 103.624l122.7-1.937 9.606-8.001-124.669 1.402c-4.219 0-7.642 2.319-7.642 5.176v3.36h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        opacity: "0.89",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#fff",
                                d: "M35.104 310.317H85.18a.587.587 0 00.586-.586v-77.814a.587.587 0 00-.586-.586H35.104a.587.587 0 00-.586.586v77.814c0 .323.262.586.586.586z",
                                opacity: "0.71"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fill: "#91B3FA",
                                d: "M62.46 306.047h19.248c.18 0 .325-.146.325-.325v-69.796a.324.324 0 00-.325-.324H62.46a.324.324 0 00-.324.324v69.796c0 .179.145.325.324.325zM38.58 306.047h19.248c.179 0 .324-.146.324-.325v-69.796a.324.324 0 00-.324-.324H38.58a.324.324 0 00-.325.324v69.796c0 .179.146.325.325.325z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#91B3FA",
                        d: "M218.5 57.383S96.92 149.148 93.905 149.148l-1.356 236.648 250.217 1.57.329-238.218L218.5 57.383z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M235.57 215.569h-45.285a3.72 3.72 0 01-3.722-3.721v-3.25a3.724 3.724 0 013.466-3.716l45.285-3.145a3.723 3.723 0 013.983 3.716v6.395a3.719 3.719 0 01-3.721 3.721h-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M171.158 334.683h80.959c.916 0 1.66.743 1.66 1.659v15.438h-84.278v-15.438a1.66 1.66 0 011.659-1.659z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M167.583 349.859h90.816a1.66 1.66 0 011.659 1.659v15.962h-94.135v-15.962a1.66 1.66 0 011.66-1.659z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M160.254 367.129h109.661a1.66 1.66 0 011.659 1.659v17.532H158.595v-17.532a1.66 1.66 0 011.659-1.659z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint4_linear_0_53)",
                        d: "M188.427 221.446h49.007c1.026 0 1.863.837 1.863 1.863V336.08h-52.734V223.309c0-1.026.838-1.863 1.864-1.863z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M205.607 296.642h-7.957a4.814 4.814 0 01-4.81-4.809v-58.822a4.814 4.814 0 014.81-4.809h7.957a4.814 4.814 0 014.811 4.809v58.822a4.814 4.814 0 01-4.811 4.809zm-7.957-67.865a4.24 4.24 0 00-4.234 4.234v58.822a4.24 4.24 0 004.234 4.234h7.957a4.24 4.24 0 004.235-4.234v-58.822a4.24 4.24 0 00-4.235-4.234h-7.957zM227.818 296.642h-7.957a4.813 4.813 0 01-4.81-4.809v-58.822a4.813 4.813 0 014.81-4.809h7.957a4.814 4.814 0 014.811 4.809v58.822a4.814 4.814 0 01-4.811 4.809zm-7.957-67.865a4.24 4.24 0 00-4.234 4.234v58.822a4.24 4.24 0 004.234 4.234h7.957a4.24 4.24 0 004.235-4.234v-58.822a4.24 4.24 0 00-4.235-4.234h-7.957zM205.607 330.601h-7.957c-2.653 0-4.81-4.019-4.81-8.959v-12.597c0-4.94 2.157-8.959 4.81-8.959h7.957c2.654 0 4.811 4.019 4.811 8.959v12.597c0 4.94-2.157 8.959-4.811 8.959zm-7.957-29.442c-2.334 0-4.234 3.537-4.234 7.881v12.597c0 4.348 1.9 7.886 4.234 7.886h7.957c2.335 0 4.235-3.538 4.235-7.886V309.04c0-4.349-1.9-7.881-4.235-7.881h-7.957zM227.818 330.601h-7.957c-2.654 0-4.81-4.019-4.81-8.959v-12.597c0-4.94 2.156-8.959 4.81-8.959h7.957c2.654 0 4.811 4.019 4.811 8.959v12.597c0 4.94-2.157 8.959-4.811 8.959zm-7.957-29.442c-2.334 0-4.234 3.537-4.234 7.881v12.597c0 4.348 1.9 7.886 4.234 7.886h7.957c2.335 0 4.235-3.538 4.235-7.886V309.04c0-4.349-1.9-7.881-4.235-7.881h-7.957z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M281.17 195.002h-.503c-13.024 0-24.425 9.216-24.425 22.236v23.45h24.928v-45.686zM256.242 247.612v68.985c0 2.324 2.727 5.924 5.052 5.924h19.876v-74.909h-24.928zM287.98 195.002h-1.267v45.686h24.927v-23.45c0-13.02-10.636-22.236-23.66-22.236zM286.713 322.521h20.64c2.324 0 4.287-3.6 4.287-5.924v-68.985h-24.927v74.909z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M313.792 326.828h-60.005c-3.439 0-6.24-2.8-6.24-6.238V216.725c0-16.427 13.364-29.787 29.796-29.787h12.893c16.432 0 29.796 13.36 29.796 29.787V320.59c0 3.438-2.801 6.238-6.24 6.238zm-36.449-139.315c-16.112 0-29.22 13.104-29.22 29.212V320.59a5.67 5.67 0 005.664 5.662h60.005a5.67 5.67 0 005.664-5.662V216.725c0-16.108-13.108-29.212-29.22-29.212h-12.893z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M143.875 195.002h-.503c-13.024 0-24.425 9.216-24.425 22.236v23.45h24.928v-45.686zM118.947 247.612v68.985c0 2.324 2.728 5.924 5.052 5.924h19.876v-74.909h-24.928zM150.68 195.002h-1.267v45.686h24.928v-23.45c0-13.02-10.637-22.236-23.661-22.236zM149.413 322.521h20.64c2.325 0 4.288-3.6 4.288-5.924v-68.985h-24.928v74.909z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BDD0FB",
                        d: "M176.523 326.828h-60.004c-3.44 0-6.24-2.8-6.24-6.238V216.725c0-16.427 13.364-29.787 29.795-29.787h12.893c16.432 0 29.796 13.36 29.796 29.787V320.59c0 3.438-2.8 6.238-6.24 6.238zm-36.449-139.315c-16.112 0-29.219 13.104-29.219 29.212V320.59a5.67 5.67 0 005.664 5.662h60.004a5.67 5.67 0 005.664-5.662V216.725c0-16.108-13.107-29.212-29.22-29.212h-12.893z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint5_linear_0_53)",
                        d: "M293.67 59.387h-20.614v33.55h20.614v-33.55z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint6_linear_0_53)",
                        d: "M270.339 54.52h25.268a4.86 4.86 0 014.858 4.856v5.448h-33.314v-7.112a3.195 3.195 0 013.194-3.192h-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint7_linear_0_53)",
                        d: "M86.267 158.767L218.5 57.383l125.522 97.333c4.565 3.538 11.255 1.063 12.411-4.595l1.759-8.608L218.5 35.131 83.284 138.378a6.733 6.733 0 00-2.141 7.907l5.124 12.477v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint8_linear_0_53)",
                        d: "M386.161 275.113c2.68 2.857 6.627 5.332 9.401 6.871-4.146 5.123-9.757 10.257-17.185 15.276l-2.125 4.767-6.811-8.158s12.223-6.081 16.72-18.756z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint9_linear_0_53)",
                        d: "M349.712 429.897c0-.146.005-.293.047-.445 2.204-8.745 13.155-14.187 13.155-14.187l4.339.34c2.497 7.709 2.173 12.434 1.775 14.538-.011.058-.032.115-.047.173-3.581.319-10.946.528-19.269-.419z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M368.975 430.316c-.193.701-.712 1.251-1.376 1.392-5.094 1.073-13.186.209-16.584-.236-.748-.099-1.298-.79-1.308-1.575 8.323.947 15.688.738 19.268.419z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint10_linear_0_53)",
                        d: "M368.991 409.142l-1.837 8.844c-.137.649-.634 1.136-1.236 1.188-.738.068-1.79.11-2.847-.047-.948-.141-1.607-1.104-1.44-2.135l1.277-7.855h6.083v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7D97F4",
                        d: "M330.919 430.227c4.79-.136 7.271-.696 8.554-1.225 0 .477 0 .963-.016 1.466-.016.534-.414.963-.9.963l-26.31-.168c-.837-.005-1.329-.978-.968-1.748 3.449.283 12.233.921 19.645.717l-.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint11_linear_0_53)",
                        d: "M311.274 429.51c.031-.068.057-.136.104-.199 2.325-3.245 8.24-9.708 19.934-12.513l5.612-.178s2.497 4.339 2.544 12.382c-1.283.524-3.759 1.089-8.554 1.225-7.407.209-16.196-.429-19.645-.717h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint12_linear_0_53)",
                        d: "M337.965 408.122c-.063.418-.832 6.771-1.13 9.236-.074.586-.498 1.036-1.032 1.104-.958.116-2.502.22-3.852-.057-.728-.152-1.257-.848-1.257-1.664v-9.975l7.271 1.361v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint13_linear_0_53)",
                        d: "M342.467 292.168s-13.531 51.406-13.285 116.1c0 1.177.832 2.198 1.989 2.439 1.701.356 4.203.785 6.271.727a2.32 2.32 0 002.214-1.941c1.895-11.121 12.783-73.784 18.986-83.958 0 0 4.083 55.808 2.775 84.764a1.374 1.374 0 001.209 1.428c1.089.126 2.821.22 5.036-.016a1.838 1.838 0 001.638-1.559c1.351-9.415 9.129-65.447 8.799-105.811-.02-2.277-6.019-12.173-6.019-12.173h-29.613z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint14_linear_0_53)",
                        d: "M323.649 229.95a56.155 56.155 0 005.726-8.74c2.246-4.244.184 2.748.796-2.046 16.829-12.141 42.176-5.997 51.98-4.762a13.08 13.08 0 018.271 4.438c8.402 9.718 26.833 36.329 5.135 63.139-2.774-1.539-6.721-4.014-9.401-6.871 2.402-6.767 2.596-15.412-2.434-26.01a24.013 24.013 0 01-.644 2.491c-6.936 21.959-7.303 40.234-7.287 44.447 0 .57-.34 1.088-.874 1.297-9.124 3.658-26.692 1.481-32.591.602a1.979 1.979 0 01-1.659-2.25c2.894-20.959-11.962-55.441-15.882-64.081a5.622 5.622 0 00-1.147-1.659l.011.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint15_linear_0_53)",
                        d: "M366.379 196.75l1.759 17.966s-10.108 3.046-17.463-2.141l5.166-16.327 10.533.502h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint16_linear_0_53)",
                        d: "M354.648 176.278c-.241.23-10.265 19.907-10.265 19.907l11.359 5.484 12.275-17.243s-9.296-11.984-13.369-8.154v.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint17_linear_0_53)",
                        d: "M362.987 184.907c.204.523.151 1.11-.136 1.591l-5.67 9.446a1.815 1.815 0 01-.308.387c-.676.628-2.984 2.455-4.769-.031-1.523-2.12-2.947-4.045-4.476-4.841-.895-.466-1.989-.094-2.444.806-.932 1.853-2.743 5.621-3.879 9.195a1.808 1.808 0 001.052 2.214c2.298.931 6.847 2.616 10.883 3.171a1.8 1.8 0 001.711-.728c1.738-2.375 6.628-9.022 8.297-10.686 1.55-1.544 4.413-.963 5.706-.591a1.83 1.83 0 001.45-.189c1.309-.79 3.591-2.752 1.503-6.075-.519-.827-.257-1.926.56-2.465 1.46-.963 3.046-2.763 1.539-5.689-1.529-2.957-4.261-3.224-6.12-2.993-.822.099-1.659-.33-1.973-1.099-.141-.34-.419-.633-.937-.738-.974-.199-1.618-1.089-1.424-2.067.33-1.675.079-3.847-2.591-5.317-4.905-2.695-9.197 1.695-10.286 5.4-1.094 3.706 4.386 6.327 7.836 6.762 2.534.319 3.921 3.082 4.481 4.527l-.005.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint18_linear_0_53)",
                        d: "M361.123 198.896s2.178-6.375 4.968-6.144c2.79.235 4.988 3.014 1.528 6.138-4.303 3.889-6.496.006-6.496.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint19_linear_0_53)",
                        d: "M384.648 247.455c3.68-10.063 2.345-22.215 2.329-22.335l-1.015.115c.015.12 1.319 12.036-2.277 21.87l.958.35h.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint20_linear_0_53)",
                        d: "M359.14 324.227a.508.508 0 00.492-.382c1.12-4.328 9.521-9.08 9.61-9.127a.508.508 0 00.194-.696.506.506 0 00-.696-.193c-.361.204-8.868 5.013-10.098 9.76a.51.51 0 00.498.638z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint21_linear_0_53)",
                        d: "M307.839 281.675c14.233-12.957 12.747-30.159 12.93-41.923.241-15.538 10.616-21.451 10.616-21.451l9.276 17.646c1.947 26.643-12.762 49.156-25.299 55.148-3.843-2.878-6.151-6.405-7.523-9.42z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint22_linear_0_53)",
                        d: "M282.143 295.256l6.621-2.753c8.355-2.962 14.521-6.678 19.076-10.828 1.371 3.015 3.68 6.542 7.522 9.42-7.983 3.815-14.668 4.841-14.668 4.841-15.641 5.709-18.551-.68-18.551-.68z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint23_linear_0_53)",
                        d: "M277.306 315.289a4.646 4.646 0 01-.592-3.988l4.089-13.188s-1.152-1.188-3.848.356c-2.696 1.544-4.789-1.031-4.789-1.031s3.905-1.931 9.788-4.621c3.366-1.539 6.784-1.157 9.098-.544l1.283 5.296c-3.146 7.619-7.837 14.103-13.652 19.755l-1.377-2.035z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint24_linear_0_53)",
                        d: "M312.74 301.086s4.177 1.444 5.014 7.211c.838 5.767-4.177 10.095-8.359 9.373-4.178-.722-8.659-11.534-.985-16.579s4.33 0 4.33 0v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint25_linear_0_53)",
                        d: "M277.16 186.582s-5.963 4.589-14.239 8.017c-4.617 1.91-13.594 4.736-14.782 12.989-.613 4.26-4.267 7.672-9.187 8.321-12.255 1.617-31.136 7.107-34.156 25.455-2.309 14.004 5.972 19.316 14.657 21.152 6.381 1.351 10.621 6.704 9.328 12.257-1.236 5.327.607 11.487 11.312 16.359 23.985 10.917 47.939-25.863 47.939-25.863l4.91-64.212-15.782-14.475z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M222.437 254.274c-.362 0-.775-.152-1.11-.335-5.596-3.145-8.58-9.634-7.255-15.789.79-3.684 2.91-6.86 5.962-8.943 2.162-1.476 4.732-2.381 7.182-3.182a154.233 154.233 0 0112.657-3.527c.351-.084.702-.162 1.047-.241 2.497-.576 5.083-1.167 7.418-2.177 2.999-1.293 5.182-3.177 6.156-5.301.602-1.319.774-2.779.942-4.192.204-1.727.419-3.517 1.418-5.045a.068.068 0 01.089-.021.067.067 0 01.021.089c-.984 1.502-1.198 3.276-1.397 4.987-.168 1.424-.346 2.894-.953 4.229-.984 2.156-3.193 4.061-6.219 5.369-2.35 1.015-4.936 1.607-7.443 2.182-.351.079-.702.163-1.047.241a152.044 152.044 0 00-12.647 3.527c-2.44.796-4.999 1.696-7.151 3.161-3.026 2.067-5.119 5.213-5.905 8.865-1.313 6.092 1.644 12.529 7.193 15.643.424.24 1.235.528 1.591.099.021-.026.063-.031.094-.01.027.021.032.062.011.094-.157.193-.393.267-.649.267l-.005.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M220.997 248.476s-.037-.011-.053-.027c-2.156-2.784-3.282-5.709-3.25-8.451.036-3.214 1.764-6.202 4.512-7.798.031-.021.068-.005.089.021.015.031.005.073-.026.089-2.707 1.57-4.408 4.516-4.445 7.688-.031 2.716 1.084 5.61 3.225 8.373.021.026.016.068-.011.094a.056.056 0 01-.041.016v-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint26_linear_0_53)",
                        d: "M302.652 241.249s13.375 33.163 17.552 62.72l-4.177 3.606s-13.375-37.486-23.404-48.303l10.029-18.023z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint27_linear_0_53)",
                        d: "M214.323 423.774l-.906 6.427c-.173 1.219-1.288 2.182-2.701 2.323-2.387.236-6.224.477-9.977.137-1.649-.152-2.717-1.591-2.215-2.952.916-2.481 2.586-6.207 5-8.399h8.27c1.529 0 2.712 1.151 2.529 2.464z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint28_linear_0_53)",
                        d: "M279.086 348.468l1.398 7.08s-4.675 40.83-5.507 57.163c-.131 2.559.638 5.092 2.193 7.274l8.124 11.383-20.651-10.514-.413-2.172 3.381-4.008-4.428-45.739c-.262-2.685.382-5.38 1.853-7.761l4.271-6.924 9.774-5.777.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint29_linear_0_53)",
                        d: "M286.655 433.016h-6.59c-1.235 0-2.398-.486-3.151-1.329-2.058-2.303-6.313-6.793-8.35-6.913-2.737-.157-2.387 8.242-2.387 8.242h-1.533l-1.948-10.44c-.492-2.627 1.026-5.228 3.759-6.458 0 0 .628 3.993 4.025 5.762 3.398 1.769 13.82 8.096 13.82 8.096s1.277-.157 2.68.063c2.078.324 1.79 2.977-.325 2.977z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint30_linear_0_53)",
                        d: "M250.798 351.833s-27.377 44.791-31.733 55.022c-4.35 10.226-5.878 18.761-5.936 19.567-.089 1.262-1.91 2.476-6.93 2.476-2.592 0-3.858-.895-4.481-1.764-.529-.738-.555-1.664-.11-2.444 1.586-2.763 6.611-11.597 8.47-15.606 2.224-4.783 7.003-26.464 9.626-34 2.623-7.536 5.585-15.716 17.002-23.246 0 0 7.837-6.62 14.087 0l.005-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint31_linear_0_53)",
                        d: "M268.093 278.436c7.062-25.81-10.83-40.411-10.83-40.411 11.291-9.347 31.858-13.601 31.858-13.601s19.625 12.376 17.3 22.063c-1.366 5.678-13.793 34.006-13.793 34.006s-11.495 4.694-24.53-2.062l-.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint32_linear_0_53)",
                        d: "M252.436 291.216c2.874-7.468 15.657-12.78 15.657-12.78 13.034 6.751 24.53 2.062 24.53 2.062s2.575 8.499.801 16.396c-1.78 7.897-12.941 58.654-12.941 58.654-17.588 3.072-44.641-3.093-44.641-3.093 11.202-17.154 13.72-53.777 16.594-61.245v.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint33_linear_0_53)",
                        d: "M276.291 207.368l-5.743 22.247c-.549 1.957 1.524 1.638 3.816 1.266 3.764-.612 8.611-1.873 10.229-4.396.167-.256.246-.549.293-.837l2.466-15.428c.193-1.224-.571-2.412-1.88-2.914l-4.758-1.822c-1.832-.701-3.952.199-4.423 1.884z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint34_linear_0_53)",
                        d: "M294.376 192.746s4.366 5.574 3.45 14.989c-.911 9.414-6.083 10.874-10.077 9.074-3.994-1.8-9.459-5.223-12.16-13.313-2.701-8.086 12.951-17.757 18.787-10.75z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint35_linear_0_53)",
                        d: "M282.096 202.13s2.722-12.932 13.641-6.458l1.518 3.051s7.905-3.276 3.256-9.969c-4.648-6.694-13.835-9.096-21.708-3.397-7.873 5.699-11.757 10.362-9.579 16.71 2.183 6.348 6.847 3.501 6.847 3.501s-.236-4.841 2.01-5.987c2.246-1.146 3.135 2.428 3.135 2.428l.88.121z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint36_linear_0_53)",
                        d: "M280.395 204.317s1.444-6.636-2.948-6.316c-4.397.319-.978 6.342.487 8.514l2.466-2.198h-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint37_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M299.48 287.118s-1.037-5.506 3.209-6.688c0 0-1.922-6.348 4.088-6.327 0 0 10.276-12.769 18.562.319 0 0 18.546 1.125 11.213 15.166 0 0 4.863 4.349-2.215 7.855 0 0-5.716 17.186-18.604 6.107l-16.248-16.427-.005-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint38_linear_0_53)",
                        d: "M358.04 274.731c-3.848-3.951-6.632 1.355-6.632 1.355-3.099 1.042 0 7.698 0 7.704-1.895 3.673-11.789 22.555-17.149 27.213-5.947 5.165 3.617 6.515 3.617 6.515s10.689-4.998 16.683-32.211c.052-.021.099-.036.141-.073.817-.623 7.193-6.552 3.34-10.503z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint39_linear_0_53)",
                        d: "M297.993 314.153c-3.894-5.066-9.192-24.193-11.055-31.243.848-1.235 3.742-5.819 1.303-7.232 0 0-1.675-5.751-6.234-2.643-4.204 2.868-.215 9.106.958 10.66-.069 15.616 7.333 34.66 7.333 34.66s12.49 2.036 7.69-4.207l.005.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint40_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M315.273 427.103s.864 3.202.801 5.568a.758.758 0 01-.654.732c-2.162.299-9.543 1.183-13.595 0a.748.748 0 01-.539-.737c.037-1.272.932-4.26 8.339-5.019l5.648-.539v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint41_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M302.531 378.135c-.91.596 5.963 48.858 7.627 49.208 0 0 1.906 1.769 4.848-.246-1.696-15.731-2.733-31.687-1.817-47.989l-10.658-.973z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint42_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M331.736 427.103s.864 3.202.801 5.568a.758.758 0 01-.655.732c-2.161.299-9.542 1.183-13.594 0a.745.745 0 01-.539-.737c.037-1.272.932-4.26 8.339-5.019l5.648-.539v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint43_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M318.995 378.135c-.911.596 5.962 48.858 7.627 49.208 0 0 1.905 1.769 4.847-.246-1.696-15.731-2.732-31.687-1.816-47.989l-10.658-.973z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint44_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M326.643 348.839s-22.42 1.026-27.76 2.899c0 0 .66 18.223 2.848 29.422.084.434.414.78.843.879 1.439.335 5.062.811 10.799-.796a1.12 1.12 0 00.811-1.156l-.591-7.259a.885.885 0 01.822-.942l.602-.089a.887.887 0 01.947.874l1.136 7.364c0 .476.309.9.759 1.051 1.686.571 6.072 1.639 11.856-.125a1.11 1.11 0 00.791-1.057c.057-8.933-1.544-19.625-3.863-31.06v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint45_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M318.236 350.409s2.832 7.876 9.673 8.426l-1.512-8.986s-5.298-.042-8.161.56z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint46_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M337.154 307.386s-10.134 6.511-22.441 5.788c-12.307-.722-17.541-5.5-20.436-9.121-.047.021-3.46.926-7.622 5.149a2.068 2.068 0 00-.345 2.449c2.732 4.988 6.224 8.709 7.799 11.859a6.615 6.615 0 011.712 4.616l-.623 23.712c-.016.659.44 1.23 1.084 1.35 4.496.853 21.566 3.825 32.182 1.952v-25.575a5.176 5.176 0 012.67-4.532c2.23-1.23 5.57-3.653 8.909-8.248l-2.894-9.409.005.01z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint47_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M319.576 301.912l1.109 12.21s-6.443 3.768-11.992.471l.984-10.666 9.893-2.02.006.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint48_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M307.803 279.347s-19.473 14.559-8.475 25.072c10.38 9.922 20.106-.89 20.106-.89s7.439-3.689 7.161-8.666c-.277-4.982-14.856-16.783-18.792-15.511v-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint49_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M322.083 300.368c-.712-.34-1.351-.936-1.822-1.816-.701-1.308-.78-2.904-.382-4.333.105-.366.231-.785.032-1.109-.241-.393-.786-.408-1.246-.455a4.175 4.175 0 01-3.288-2.35c-.591-1.277-.465-2.863.325-4.025-1.879-.486-2.083-1.962-3.418-2.883-1.225-.848-2.984-.126-4.329-.68-.99-.409-3.052-1.921-2.769-3.245.125-.591 1.837-1.853 2.392-2.245 2.481-1.753 5.193-1.23 7.386.754 6.334 5.719 12.008 11.262 13.217 14.161.848 2.03.791 4.647-.549 6.452-1.387 1.874-3.727 2.654-5.554 1.78l.005-.006z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint50_linear_0_53)",
                        fillRule: "evenodd",
                        d: "M317.199 304.649l4.361-5.264s4.952-.435 3.219 2.653c-1.738 3.093-6.208 3.548-7.58 2.611z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint51_linear_0_53)",
                        d: "M261.979 238.543c-2.088-.979-4.695-.67-6.517.649-3.617 2.632-11.925 10.508-12.793 27.72-1.115 22.074 37.83 16.313 37.83 16.313l2.225-4.799s-27.817-.958-27.817-10.556c0-6.761 8.077-14.616 11.668-17.772 1.377-1.209 1.979-2.957 1.476-4.595-.858-2.784-3.277-5.657-6.072-6.96z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint52_linear_0_53)",
                        d: "M277.62 278.436s3.989-1.92 7.329-2.883c3.34-.958 4.449 0 4.449 0s-3.339.957-4.449 1.92c-1.11.963 5.329.968 7.669.963 2.345 0 2.758 4.715.324 6.196-2.434 1.481-9.108 4.36-15.782-1.402l.46-4.794z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint53_linear_0_53)",
                        d: "M127.71 389.559s-34.329 17.563-50.305-1.366c-12.84-15.213 9.376-4.118 30.602-1.005 1.665.246 2.131-2.208.492-2.59-16.107-3.758-40.14-10.932-41.186-20.462-1.576-14.386 2.894-8.227 20.912.57s23.363 5.542 12.255-1.931c-11.108-7.473-32.9-8.446-35.188-16.055-2.287-7.615-.33-20.269-.225-25.994.105-5.72 28.01-3.831 32.288 5.343 4.271 9.174 4.192 26.025 11.212 31.761 7.02 5.73 3.308-10.603.529-19.358-2.785-8.761-3.005-14.569 7.04-8.938 10.041 5.631 10.763 20.749 8.224 30.871-2.539 10.121-.837 16.966.806 12.104 1.644-4.862 5.46-20.237 3.727-25.946-1.732-5.71 20.525 8.865-1.167 43.001l-.016-.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M125.643 389.067a.346.346 0 01-.304-.178c-13.929-26.051-43.83-52.448-44.128-52.709a.341.341 0 11.45-.513c.304.262 30.288 26.742 44.28 52.903a.34.34 0 01-.141.461.357.357 0 01-.157.041v-.005z",
                        opacity: "0.53"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint54_linear_0_53)",
                        d: "M147.11 399.204s-42.16-2.156-46.929-28.851c-3.832-21.456 11.145 1.23 29.555 15.81 1.445 1.146 3.23-.927 1.884-2.183-13.207-12.387-32.052-32.352-27.822-41.955 6.392-14.501 7.25-6.212 19.51 11.995 12.259 18.207 19.101 18.05 12.673 4.883-6.434-13.167-26.556-26.025-24.551-34.493 2.005-8.467 10.799-19.389 14.034-24.758 3.235-5.364 28.65 11.712 27.671 22.754-.979 11.037-10.292 26.967-6.779 36.24 3.512 9.279 8.946-8.237 11.108-18.06 2.162-9.823 5.14-15.454 11.574-4.616 6.433 10.839-1.173 25.56-9.13 33.766-7.956 8.2-10.092 15.621-5.873 11.91 4.225-3.71 16.264-16.191 17.751-22.55 1.487-6.358 14.599 19.646-24.676 40.119v-.011z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M145.414 397.603a.376.376 0 01-.189-.335c1.073-32.321-12.793-73.716-12.935-74.13a.367.367 0 01.236-.471.367.367 0 01.471.236c.141.413 14.05 41.939 12.977 74.396a.375.375 0 01-.56.314v-.01z",
                        opacity: "0.53"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_53",
                        x1: "394.704",
                        x2: "454.349",
                        y1: "94.387",
                        y2: "-24.939",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_0_53",
                        x1: "346.058",
                        x2: "352.583",
                        y1: "-6.432",
                        y2: "153.497",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_0_53",
                        x1: "152.941",
                        x2: "212.591",
                        y1: "-26.459",
                        y2: "-145.785",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_0_53",
                        x1: "87.738",
                        x2: "94.665",
                        y1: "33.378",
                        y2: "112.583",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_0_53",
                        x1: "45.516",
                        x2: "240.637",
                        y1: "431.901",
                        y2: "253.924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_0_53",
                        x1: "324.779",
                        x2: "376.58",
                        y1: "-8.53",
                        y2: "-114.51",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_0_53",
                        x1: "357.004",
                        x2: "324.043",
                        y1: "-48.989",
                        y2: "0.468",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_0_53",
                        x1: "-114.288",
                        x2: "243.813",
                        y1: "261.349",
                        y2: "112.531",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_0_53",
                        x1: "395.562",
                        x2: "369.441",
                        y1: "288.568",
                        y2: "288.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_0_53",
                        x1: "360.029",
                        x2: "359.375",
                        y1: "370.426",
                        y2: "442.473",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_0_53",
                        x1: "363.851",
                        x2: "367.591",
                        y1: "400.627",
                        y2: "433.273",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_0_53",
                        x1: "325.91",
                        x2: "325.256",
                        y1: "370.118",
                        y2: "442.164",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_0_53",
                        x1: "333.374",
                        x2: "337.115",
                        y1: "404.123",
                        y2: "436.763",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_0_53",
                        x1: "288.917",
                        x2: "408.541",
                        y1: "254.844",
                        y2: "440.513",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_0_53",
                        x1: "388.37",
                        x2: "363.254",
                        y1: "207.436",
                        y2: "250.355",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_0_53",
                        x1: "355.585",
                        x2: "369.863",
                        y1: "191.946",
                        y2: "253.663",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_0_53",
                        x1: "358.108",
                        x2: "351.072",
                        y1: "179.99",
                        y2: "221.416",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint17_linear_0_53",
                        x1: "365.514",
                        x2: "344.767",
                        y1: "199.598",
                        y2: "177.552",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint18_linear_0_53",
                        x1: "364.218",
                        x2: "365.47",
                        y1: "225.203",
                        y2: "196.116",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint19_linear_0_53",
                        x1: "367.614",
                        x2: "397.178",
                        y1: "203.574",
                        y2: "257.897",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#E1473D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#E9605A"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint20_linear_0_53",
                        x1: "356.03",
                        x2: "366.061",
                        y1: "304.691",
                        y2: "322.544",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint21_linear_0_53",
                        x1: "362.065",
                        x2: "336.949",
                        y1: "192.045",
                        y2: "234.964",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint22_linear_0_53",
                        x1: "243.718",
                        x2: "385.653",
                        y1: "288.914",
                        y2: "291.709",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint23_linear_0_53",
                        x1: "243.427",
                        x2: "385.361",
                        y1: "303.756",
                        y2: "306.552",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint24_linear_0_53",
                        x1: "316.65",
                        x2: "301.477",
                        y1: "254.269",
                        y2: "402.889",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint25_linear_0_53",
                        x1: "301.747",
                        x2: "217.792",
                        y1: "169.553",
                        y2: "293.419",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint26_linear_0_53",
                        x1: "325.826",
                        x2: "274.496",
                        y1: "91.577",
                        y2: "594.303",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint27_linear_0_53",
                        x1: "214.344",
                        x2: "198.404",
                        y1: "427.077",
                        y2: "427.077",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint28_linear_0_53",
                        x1: "280.436",
                        x2: "260.639",
                        y1: "481.487",
                        y2: "250.045",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint29_linear_0_53",
                        x1: "288.404",
                        x2: "262.613",
                        y1: "424.565",
                        y2: "424.565",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint30_linear_0_53",
                        x1: "234.209",
                        x2: "214.532",
                        y1: "484.213",
                        y2: "254.158",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint31_linear_0_53",
                        x1: "336.704",
                        x2: "317.863",
                        y1: "207.803",
                        y2: "223.507",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint32_linear_0_53",
                        x1: "310.928",
                        x2: "223.522",
                        y1: "294.691",
                        y2: "347.326",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint33_linear_0_53",
                        x1: "283.462",
                        x2: "279.763",
                        y1: "253.149",
                        y2: "226.077",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint34_linear_0_53",
                        x1: "285.314",
                        x2: "289.458",
                        y1: "225.948",
                        y2: "158.749",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint35_linear_0_53",
                        x1: "306.918",
                        x2: "185.728",
                        y1: "179.319",
                        y2: "261.746",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint36_linear_0_53",
                        x1: "276.456",
                        x2: "280.591",
                        y1: "226.627",
                        y2: "159.527",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint37_linear_0_53",
                        x1: "308.614",
                        x2: "343.029",
                        y1: "291.49",
                        y2: "280.939",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint38_linear_0_53",
                        x1: "351.931",
                        x2: "330.662",
                        y1: "280.063",
                        y2: "335.828",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint39_linear_0_53",
                        x1: "296.227",
                        x2: "272.01",
                        y1: "285.71",
                        y2: "323.999",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint40_linear_0_53",
                        x1: "316.074",
                        x2: "301.281",
                        y1: "430.571",
                        y2: "430.501",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint41_linear_0_53",
                        x1: "312.036",
                        x2: "304.569",
                        y1: "418.025",
                        y2: "350.087",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint42_linear_0_53",
                        x1: "332.537",
                        x2: "317.75",
                        y1: "430.575",
                        y2: "430.506",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint43_linear_0_53",
                        x1: "328.501",
                        x2: "321.035",
                        y1: "418.027",
                        y2: "350.09",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint44_linear_0_53",
                        x1: "365.84",
                        x2: "294.1",
                        y1: "286.019",
                        y2: "398.227",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint45_linear_0_53",
                        x1: "328.694",
                        x2: "321.185",
                        y1: "345.693",
                        y2: "357.562",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint46_linear_0_53",
                        x1: "316.576",
                        x2: "326.805",
                        y1: "335.646",
                        y2: "399.126",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF928E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE7062"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint47_linear_0_53",
                        x1: "320.644",
                        x2: "309.75",
                        y1: "332.658",
                        y2: "291.779",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint48_linear_0_53",
                        x1: "1168.85",
                        x2: "1194.56",
                        y1: "615.416",
                        y2: "625.019",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint49_linear_0_53",
                        x1: "310.161",
                        x2: "335.575",
                        y1: "291.378",
                        y2: "280.674",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#09005D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1A0F91"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint50_linear_0_53",
                        x1: "1167.7",
                        x2: "1193.41",
                        y1: "618.492",
                        y2: "628.095",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#C4421B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#5C0E16"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint51_linear_0_53",
                        x1: "322.434",
                        x2: "378.077",
                        y1: "164.55",
                        y2: "68.015",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint52_linear_0_53",
                        x1: "345.346",
                        x2: "400.995",
                        y1: "177.758",
                        y2: "81.218",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEBBBA"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF928E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint53_linear_0_53",
                        x1: "147.089",
                        x2: "217.21",
                        y1: "288.667",
                        y2: "197.067",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint54_linear_0_53",
                        x1: "237.078",
                        x2: "205.675",
                        y1: "282.46",
                        y2: "303.401",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#4F52FF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4042E2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_0_53",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H437V434H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var mainImg = (MainImg);

// EXTERNAL MODULE: ./src/components/fullcoveragewarranty/sharedButton/index.tsx
var sharedButton = __webpack_require__(90652);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/whoIsHomeWarranty/index.tsx




function WhoIsHomeWarranty() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col lg:flex-row lg:gap-28 gap-16 lg:mt-28 mt-14 lg:mb-52 mb-28 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[574px] mx-auto lg:mx-0 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold lg:text-3xl text-2xl lg:leading-[45px] ",
                        children: "Who Is a Home Warranty For?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-5 lg:text-lg text-base lg:leading-8 font-light",
                        children: "A home warranty is a great solution for homeowners looking to protect their appliances and systems from unforeseen breakdowns and costly repairs. It's especially beneficial for individuals who may not have the skills or time to handle maintenance tasks. By providing coverage for home systems, a home warranty offers homeowners peace of mind in the event of unexpected breakdowns."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:mt-[50px] mt-7 text-center sm:text-left",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sharedButton/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[300px] h-[250px] md:h-[434px] md:w-[437px] md:min-w-[437px] relative mx-auto lg:mx-0 lg:mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainImg, {})
            })
        ]
    });
}


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 96119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResolvedForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);



const FormNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(47341)]).then(__webpack_require__.bind(__webpack_require__, 47341)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47341)
            ]
    }
});
const FormOld = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(75108)]).then(__webpack_require__.bind(__webpack_require__, 75108)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75108)
            ]
    }
});
function ResolvedForm(props) {
    const { loadOneToOneForm , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // The new form is the default for every domain. Keep the legacy form
    // available as an explicit per-domain escape hatch while one-to-one flows,
    // which are only implemented by the new form, always stay on FormNew.
    const useOldForm = !loadOneToOneForm && domain?.config?.forceOldForm === true;
    return useOldForm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormOld, {
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormNew, {
        ...props
    });
}


/***/ }),

/***/ 12282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","mainSectionHome":"styles_mainSectionHome__00aIl","mainSectionCar":"styles_mainSectionCar__vYpet","form":"styles_form__mEYnV","step-title":"styles_step-title__CXxri","step-description":"styles_step-description__9AhyF","label-as-step-title":"styles_label-as-step-title__wAVam","tcpa":"styles_tcpa__6tBuO","progress-bar":"styles_progress-bar__7Uwpr","form-inner":"styles_form-inner__iepul","field-wrapper":"styles_field-wrapper__38oE5","field":"styles_field__O79LZ","form-button":"styles_form-button__6nqZw","radio-field":"styles_radio-field__7UQcY","checkbox-field":"styles_checkbox-field__qy0gU","step":"styles_step__poK3k","submit-button":"styles_submit-button__0vyR3","blink":"styles_blink__wNun2"};

/***/ }),

/***/ 52072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__jZBiM"};

/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ })

}]);